// i18n namespace `recognition` (nl) — REQ-099 / REQ-102 / REQ-103.
// D-6 (2026-08-01): traducción completa desde el español (idioma fuente). Se retiraron los 34
// marcadores de traducción pendiente que diferían el trabajo a una "Fase 7" inexistente.
const recognition = {
  // Armazon propio del modulo (menu lateral y cabecera): el portal no comparte estos textos.
  shell: {
    backToPortal: 'Terug naar het portaal',
    collapseMenu: 'Menu inklappen',
    expandMenu: 'Menu uitklappen',
    fundamentals: 'Kernprincipes',
  },
  moduleTitle: 'Erkenningsprogramma',
  nav: {
    recognize: 'Waarderen',
    shine: 'Shine Together',
    profile: 'Mijn profiel',
    admin: 'Admin',
    team: 'Team',
    dashboard: 'Dashboard',
    innovation: 'Innovatie LATAM',
  },
  // F8 (paridad demo, H-96/H-97)
  frontlineMore: {
    tab: 'Meer bekijken',
    title: 'Meer opties',
    documents: 'Documenten',
    language: 'Taal',
    selectLanguage: 'Selecteer taal',
  },
  common: {
    loading: 'Laden…',
    error: 'De informatie kon niet worden geladen.',
    retry: 'Opnieuw proberen',
    empty: 'Er is nog niets om te tonen.',
    notConfigured: 'De erkenningsservice is niet geconfigureerd.',
    forbidden: 'Je hebt geen toestemming om deze sectie te bekijken.',
    close: 'Sluiten',
    remove: 'Verwijderen',
    cancel: 'Annuleren',
    insertEmoji: 'Emoji invoegen',
    actions: 'Acties',
  },
  recognize: {
    title: 'Een collega waarderen',
    subtitle: 'Bedank een gedrag dat aansluit bij onze Kernprincipes.',
    feedTitle: 'Recente erkenningen',
    feedEmpty: 'Er zijn nog geen erkenningen. Wees de eerste die iemand waardeert!',
    newCta: 'Nieuwe erkenning',
    form: {
      messagePlaceholder: 'Schrijf je erkenningsbericht…',
      anonymous: 'Anoniem versturen',
      submit: 'Erkenning versturen',
    },
  },
  wall: {
    title: 'Erkenningsmuur',
    count: '{{count}} erkenningen',
    empty: 'Er zijn nog geen erkenningen om te tonen.',
    prev: 'Vorige',
    next: 'Volgende',
    pageOf: 'Pagina {{page}} van {{total}}',
    for: 'voor',
    anonymous: 'Anoniem',
    senderHidden: 'Identiteit niet zichtbaar',
    userUnavailable: 'Gebruiker niet beschikbaar',
    points_one: '+{{count}} punt',
    points_other: '+{{count}} punten',
    pointsTitle: 'Punten die deze erkenning waard is',
    fundamentalsRecognized: 'Erkende Kernprincipes',
    fundIconTooltipAria: 'Alle Kernprincipes van deze erkenning bekijken',
    behaviorsRecognized: 'Erkende gedragingen',
    habitsRecognized: 'Erkende dagelijkse gewoonten',
    detailUnavailable: 'De volledige details konden niet worden geladen.',
    reportCount: '{{count}} keer gemeld — in behandeling',
    receivedIn: 'Ontvangen in:',
    antiSpoilerBlurredHint: 'Wacht op de prijsuitreiking van het Brillamos Juntos-evenement om je nominaties te zien.',
    antiSpoilerHiddenHint: 'Sommige waarderingen zijn verborgen door de Anti-Spoilermodus tot hun campagne afloopt.',
  },
  reactions: {
    addLabel: 'Reageren',
    countLabel: '{{count}} reacties',
    modalTitle: 'Reacties',
    error: 'Je reactie kon niet worden opgeslagen. Probeer het opnieuw.',
    whoReacted: 'Reageerden',
    whoLoading: 'Laden…',
    whoEmpty: 'Nog niemand heeft gereageerd.',
    whoError: 'Kan de lijst niet laden.',
  },
  origin: {
    diario: 'Dagelijks',
    brillamos: 'Wij stralen',
    personalizada: 'Campagne',
    csv: 'Bulkupload',
    delegado: 'Gedelegeerd',
    sistema: 'Systeem',
  },
  panel: {
    title: 'Waardeer je collega’s',
    recipientsLabel: 'Personen',
    recipientsPlaceholder: 'Zoeken op naam of e-mail…',
    searchError: 'Personen konden niet worden gezocht',
    fundamentalLabel: 'Kernprincipe (max. {{max}})',
    fundamentalLabelUnbounded: 'Kernprincipe',
    maxFundamentalsHint: 'Je kunt maximaal {{max}} Kernprincipe(s) selecteren.',
    behaviorsLabel: 'Gedragingen',
    habitsLabel: 'Dagelijkse gewoonten',
    habitRequiredHint: 'Selecteer minstens één daily habit om te kunnen versturen.',
    summaryLabel: 'Samenvatting',
    edit: 'Bewerken',
    messageLabel: 'Jouw bericht',
    messagePlaceholder: 'Waarom waardeer je deze persoon?',
    anonymous: 'Anoniem versturen',
    sendToBrillamos: 'Ook naar Brillamos sturen',
    // Decisión 6 (2026-10-15) — «Enviar también a Brillamos» avisa antes y después de enviar.
    sendToBrillamosNoCabe: 'Deze erkenning past niet binnen de regels van ‘{{campana}}’ ({{limites}}). Als je hem zo verstuurt, gaat hij uit als dagelijkse erkenning.',
    brillamosMaxPersonas_one: 'maximaal {{count}} persoon',
    brillamosMaxPersonas_few: 'maximaal {{count}} personen',
    brillamosMaxPersonas_other: 'maximaal {{count}} personen',
    brillamosMaxFundamentales_one: 'maximaal {{count}} Fundamental',
    brillamosMaxFundamentales_few: 'maximaal {{count}} Fundamentals',
    brillamosMaxFundamentales_other: 'maximaal {{count}} Fundamentals',
    sendToBrillamosSalioDiario: 'Verstuurd als dagelijkse erkenning: hij is niet opgenomen in ‘{{campana}}’.',
    charCount: '{{count}} tekens',
    charsAvailableHint: 'Je nadert de limiet. Je hebt nog {{remaining}} van {{max}} tekens.',
    charsLimitReachedHint: 'Je hebt de limiet van {{max}} tekens bereikt. Kort een deel in om verder te schrijven.',
    charsLimitSentenceNote: 'De zin die je op de post-it hebt samengesteld telt ook mee voor de limiet.',
    errMessageTooLong: 'Je bericht overschrijdt de limiet van {{max}} tekens. Kort een deel in en verstuur het opnieuw.',
    errRecipientRequired: 'Kies de persoon die je wilt erkennen voordat je verstuurt.',
    errFundamentalRequired: 'Kies minstens één Fundamental voordat je verstuurt.',
    errSessionUnknown: 'We konden je sessie niet identificeren. Sluit de app, meld je opnieuw aan en probeer het nog eens.',
    errRecipientWithoutCampaign_one: '{{names}} heeft geen actieve campagne en kan deze erkenning daarom niet ontvangen. Verwijder deze persoon uit de verzending om verder te gaan.',
    errRecipientWithoutCampaign_few: '{{names}} hebben geen actieve campagne en kunnen deze erkenning daarom niet ontvangen. Verwijder deze personen uit de verzending om verder te gaan.',
    errRecipientWithoutCampaign_other: '{{names}} hebben geen actieve campagne en kunnen deze erkenning daarom niet ontvangen. Verwijder deze personen uit de verzending om verder te gaan.',
    errDelegateNotAllowed: 'Je hebt niet de machtiging „Namens iemand anders erkennen”. Verstuur de erkenning op je eigen naam.',
    errDelegateOtherUnit: 'Je kunt alleen erkennen namens mensen uit je eigen eenheid. Kies iemand anders als afzender.',
    errDelegateNotOperational: 'Je kunt alleen erkennen namens operationeel personeel. Kies iemand anders als afzender.',
    errDelegateNotFound: 'De gekozen afzender bestaat niet of is niet meer actief. Kies iemand anders.',
    errDelegateRequesterWithoutUnit: 'Aan je profiel is geen eenheid toegewezen, dus je kunt niet namens iemand anders erkennen.',
    errDelegateNotEligible: 'Je kunt niet namens deze persoon erkennen. Kies iemand anders als afzender.',
    errDelegateCheckUnavailable: 'We konden de gekozen afzender niet controleren. Probeer het over een paar minuten opnieuw.',
    send: 'Versturen',
    sending: 'Versturen…',
    sentTitle: 'Erkenning verstuurd!',
    sentSubtitle: 'Zichtbaar voor het team en de leidinggevende.',
    sendErrorGeneric: 'De erkenning kon niet worden verstuurd. Probeer het opnieuw.',
    legalHint: 'Je moet de geldende juridische voorwaarden accepteren voordat je waardeert.',
    sendingDisabledHint: 'Het versturen van waarderingen is tijdelijk uitgeschakeld.',
    scheduleRestrictedHint: 'Verzenden valt op dit moment buiten het toegestane tijdvenster voor jouw locatie.',
    weeklyLimitHint: 'Er geldt een limiet van {{count}} waarderingen per week voor jouw locatie.',
    missingRecipientsHint: 'Selecteer minstens één persoon om te waarderen.',
    missingFundamentalHint: 'Selecteer minstens één Kernprincipe.',
    messageMinCharsHint: 'Schrijf minstens {{count}} tekens in je bericht.',
    missingBehaviorForHabitHint: 'Kies een gedraging om de beschikbare daily habits te zien.',
    noHabitsAvailableHint: 'Dit Kernprincipe heeft geen daily habits geconfigureerd; kies een ander.',
    groupTag: 'Team',
    delegateTitle: 'Verzendmodus',
    modeSelfTab: 'In mijn naam',
    modeOnBehalfTab: 'Namens iemand anders',
    delegateLabel: 'Namens',
    delegateSubtitle: 'Je kunt erkenningen versturen namens medewerkers op de werkvloer.',
    delegatePlaceholder: 'Medewerker zoeken…',
    onBehalfActiveBanner: 'Je erkent namens {{name}}.',
  },
  profile: {
    title: 'Mijn erkenningsprofiel',
    subtitle: 'Jouw erkenningsactiviteit en je reeks.',
    received: 'Ontvangen',
    sent: 'Verzonden',
    streak: 'Reeks',
    empty: 'Je hebt nog geen erkenningsactiviteit.',
    weeksStreak: 'Weken op rij',
    monthsStreak: 'Maanden reeks',
    record: 'Record',
    totalSent: 'Verzonden',
  },
  catalog: {
    title: 'Kernprincipes',
    empty: 'De catalogus met Kernprincipes is leeg.',
  },
  notifications: {
    title: 'Meldingen',
    close: 'Meldingen sluiten',
    placeholder: 'De meldingenbox is binnenkort beschikbaar.',
    unread: '{{count}} ongelezen',
    markAllRead: 'Alles als gelezen markeren',
    markRead: 'Markeren als gelezen',
    readState: 'Leesstatus',
    inviteToRecognize: 'Erken iemand',
    markUnread: 'Markeren als ongelezen',
    loadMore: 'Eerdere meldingen bekijken',
    recognitionUnavailable: 'Deze erkenning is niet meer beschikbaar.',
    unsavedTitle: 'Je hebt niet-opgeslagen wijzigingen',
    unsavedDesc: 'Als je nu weggaat, verlies je wat je aan het schrijven bent.',
    unsavedConfirm: 'Weggaan zonder opslaan',
    unsavedCancel: 'Hier blijven',
    campaignInactive: 'De campagne van deze erkenning is afgelopen en kan daarom niet meer worden geopend.',
    campaignUnavailable: 'Deze campagne is afgelopen en kan daarom niet meer worden geopend.',
    unavailable: 'De box is momenteel niet beschikbaar.',
    empty: 'Je hebt geen meldingen.',
  },
  // ── WP-12/WP-13 (D4) — Stralen+Nomineren, Bibliotheek, Profiel, Wrapped ──
  home: {
    sent: 'Verzonden', received: 'Ontvangen', recognizeCta: 'Nu waarderen', recent: 'Recente waarderingen',
    active: 'Actieve campagne',
    ended: 'Campagne beëindigd',
    daysLeft: 'Nog {{count}} dagen',
    heroLogoAlt: 'Shine Together',
    nominateNow: 'Nu nomineren',
    // Demo-pariteit (D1/D2) — hero van /app/reconocer, overgenomen uit HomePage.tsx van de demo.
    titleLine1: 'Nomineer wie',
    titleVive: 'leeft de',
    subtitle: 'Erken een collega die anderen inspireert door onze Kernprincipes te leven.',
    cta: '✨ Iemand erkennen',
    // Paridad demo — estados vacios de los dos muros de la home (HomePage.tsx : 501 / 535).
    emptySent: 'Je hebt nog niemand erkend!',
    emptyReceived: 'Blijf de Fundamentals waarmaken en je wordt binnenkort erkend!',
  },
  streak: {
    title: 'Jouw erkenningsreeks',
    subtitle: 'Erken elke week en blijf schijnen!',
    subtitleMonthly: 'Erken elke maand en blijf stralen!',
    weeks: 'wkn',
    months: 'mnd',
    month: 'mnd',
    monthsMany: 'mnd',
    record: 'Record',
    total: 'Nominaties',
    activeDays: '{{count}} actieve dagen deze week',
    currentLevel: 'HUIDIG NIVEAU',
    atRisk: 'Je reeks loopt deze week gevaar',
    atRiskMonthly: 'Je reeks loopt deze maand gevaar',
    // FASE 7 (demo-pariteit, H-91) — verenigde .streak-*-familie.
    current: 'Huidige reeks',
    thisWeek: 'Deze week',
    days: 'dagen',
    today: 'Vandaag!',
    nudgeDone: 'Je hebt vandaag al geschenen! 🌟',
    nudgeTodo: 'Erken vandaag en houd je reeks! 🚀',
    periodProgress: '{{sent}} van {{min}} deze week',
    periodProgressDone: 'Weekdoel behaald! ({{sent}} van {{min}})',
    periodProgressMonthly: '{{sent}} van {{min}} deze maand',
    periodProgressDoneMonthly: 'Maanddoel behaald! ({{sent}} van {{min}})',
    provisionalNote: 'Inclusief deze week · bevestigd bij afsluiting',
    provisionalNoteMonthly: 'Inclusief deze maand · bevestigd bij afsluiting',
    badgeProvisional: 'BIJ AFSLUITING',
    badgeProvisionalTooltip: 'Je hebt het minimum van deze periode al gehaald: de badge wordt al getoond en wordt bevestigd zodra de periode wordt afgesloten.',
    badgesTitle: 'Badges',
    celebration: {
      title: 'Badge ontgrendeld!',
      message: 'Ga zo door, je doorzettingsvermogen valt op!',
      cta: 'Geweldig!',
    },
    badgeWeek: '{{count}} week',
    badgeWeeks: '{{count}} weken',
    badgeWeeksMany: '{{count}} weken',
    badgeMonth: '{{count}} maand',
    badgeMonths: '{{count}} maanden',
    badgeMonthsMany: '{{count}} maanden',
    note: '* De reeks wordt berekend op basis van verzonden erkenningen',
    day: { mon: 'M', tue: 'D', wed: 'W', thu: 'D', fri: 'V', sat: 'Z', sun: 'Z' },
  },
  // 2026-08-10 — alleen `crossOu` wordt nog gebruikt (door NominarView). De rest hoorde bij de
  // "Activiteitenfeed" van Brillamos Juntos (`BrillamosFeed`, op verzoek van de klant verwijderd).
  feed: {
    crossOu: 'Cross-OU',
  },
  docs: {
    allLanguages: "Alle talen",
    title: 'Campagnedocumenten',
    download: 'Downloaden',
    loadError: 'Kan het document niet laden.',
    cat: {
      howto: 'Hoe nomineer je',
      awards: 'Prijzen',
      legal: 'Deelnamevoorwaarden',
      privacy: 'Privacybeleid',
      cookies: 'Cookiebeleid',
      notice: 'Juridische kennisgeving',
    },
  },
  library: {
    title: 'De Kernprincipes',
    subtitle: 'De basis van hoe we bij Sigma werken, samenwerken en groeien.',
    watchVideo: 'Video bekijken',
    behaviorsCount: '{{count}} Houdingen en Gedragingen',
    dailyHabits: 'Dagelijkse Gewoonten',
    micrositeSpace: 'Ruimte van de cultuur-microsite',
  },
  nominate: {
    back: 'Samen Stralen',
    thanksTo: 'Dank aan {{name}} voor',
    demonstrating: 'het tonen van {{fundamental}}',
    defaultMessage: 'Erkenning verstuurd',
    sentTitle: 'Nominatie verstuurd!',
    sentSubtitle: 'Bedankt dat je {{name}} laat stralen.',
    redirecting: 'Terug naar de campagne…',
    yourRecognition: 'Jouw erkenning',
    thanksWord: 'Dank aan',
    slotWho: 'wie?',
    forWord: 'voor',
    slotWhat: 'wat deed die?',
    demonstratingWord: 'en toont daarmee',
    slotFund: 'kernprincipe?',
    elements: '{{done}}/3 elementen',
    eyebrow: 'Erkenning maken',
    title: 'Vul de drie velden in',
    field1: 'Tag je collega',
    searchPlaceholder: 'Naam van de collega…',
    noResults: 'We hebben niemand met die naam gevonden.',
    field2: 'Bij welk Kernprincipe?',
    field3: 'Wat deed die?',
    noActions: 'Voor dit Kernprincipe zijn geen gedragingen geconfigureerd.',
    pickFundFirst: 'Kies eerst een Kernprincipe.',
    completeMessage: 'Maak je bericht af',
    personalizeTitle: 'Personaliseer je bericht',
    personalizeSub: 'Voeg je eigen stem toe. De rest staat al klaar.',
    messagePlaceholder: 'Beschrijf het specifieke moment dat je zag…',
    charCount: '{{count}} tekens',
    idealRange: '30–80 ideaal',
    nudgeText: 'Je bericht heeft meer impact als je er een eigen zin aan toevoegt.',
    addLine: 'Zin toevoegen',
    sendAnyway: 'Toch versturen',
    send: 'Nominatie versturen',
  },
  wrapped: {
    readyTitle: 'Je Recap staat klaar', readySubtitle: 'Beleef de momenten opnieuw die je {{year}} lieten stralen.', open: 'Mijn Recap bekijken',
    introHint: 'Een blik op jouw jaar van waarderen.',
    topReceptor: 'Wie je het vaakst waardeerde',
    topEmisor: 'Jouw fan nr. 1',
    topFundamentalHint: 'Wat je het meest vierde.',
    bottomFundamentalHint: 'Wat je het minst vierde. Jouw uitdaging voor dit jaar.',
    crossOuValue: '{{count}} cross-OU-erkenningen',
    messageFrom: 'Van {{name}}',
    winnerYear: 'Jaar {{anio}}',
    winnerPosition: 'Plaats {{position}}',
    sinceMonth: 'Je overzicht loopt vanaf {{month}}.',
    streakValue: '{{count}} weken',
    streakValueOne: '{{count}} week',
    streakValueMany: '{{count}} weken',
    streakValueMonth: '{{count}} maanden',
    streakValueMonthOne: '{{count}} maand',
    streakValueMonthMany: '{{count}} maanden',
    unavailable: 'Je Wrapped is nog niet beschikbaar.',
    // RF-130-correctie F1 (H-06) — de backend stuurt een STABIELE SLEUTEL
    // (`GetRecognitionWrappedQueryHandler.cs`), geen tekst. `WrappedModal.tsx` herleidt hem tegen
    // deze drie, met een whitelist: nooit `t(ruweSleutel)`.
    generosityTag: {
      generoso: 'Gul',
      muyGeneroso: 'Heel gul',
      superGeneroso: 'Super gul',
    },
  },
  prof: {
    myFolders: 'Mijn ontvangen erkenningen, gefilterd op Fundamental',
    viewingTitle: 'Profiel van {{name}}',
    backToMine: 'Mijn profiel',
    myTeam: 'Team',
    searchColleague: 'Een collega zoeken…',
    campaignBannerSub: 'De campagne loopt — ga naar Shine Together',
    ctaRecognize: 'Iemand erkennen',
    myWrapped: 'Mijn Wrapped {{year}}',
    brillamosFolder: 'Shine Together',
    emptySent: 'Je hebt nog geen erkenningen verstuurd.',
    emptyBrillamos: 'Hier zijn nog geen erkenningen uit Wij stralen.',
    folderEmpty: 'Er zijn nog geen erkenningen in deze map.',
    recognizeName: '{{name}} erkennen',
    // FASE 6 (demo-pariteit, H-75/H-77/H-78) — profiel `.rp2-*`.
    thisWeek: 'Deze week',
    weekdayInitials: 'M,D,W,D,V,Z,Z',
    badges: 'Badges · Shine Together',
    recap: 'Wrapped {{year}}',
    sigmaMsg: '"Bedankt dat je de cultuur van Sigma leeft"',
    sigmaFrom: '— Sigma · {{year}}',
    sigmaNote: 'Geen ontvangen erkenningen in {{year}}. Deze erkenning is een herinnering aan jouw waarde voor het team.',
    sigmaNoteSent: 'Geen verzonden erkenningen in {{year}}. Deze erkenning is een herinnering aan jouw waarde voor het team.',
  },
  time: {
    moment: 'Zojuist',
    hours: '{{n}} u geleden',
    yesterday: 'Gisteren',
    days: '{{n}} dagen geleden',
  },
  // ── WP-11 REQ-104 — Interactieve post-it / Word Builder ──
  builder: {
    modeLabel: 'Erkenningsmodus',
    modeClassic: 'Klassiek',
    modeInteractive: 'Interactief',
    previewLabel: 'Voorbeeld van de erkenning',
    thanksWord: 'Ik waardeer',
    forWord: 'voor',
    demonstratingWord: 'en toont daarmee',
    slotWho: 'wie?',
    slotWhat: 'wat deed die?',
    slotFund: 'kernprincipe?',
    stepOf: 'Stap {{step}} van {{total}}',
    step1Title: 'Wie waardeer je?',
    step3Title: 'Welk gedrag of welke gewoonte?',
    step4Title: 'Voeg je bericht toe',
    complementPlaceholder: 'Beschrijf het specifieke moment dat je zag…',
    noActions: 'Voor dit Kernprincipe zijn geen gedragingen of gewoonten geconfigureerd.',
    back: 'Terug',
    next: 'Volgende',
  },
  ri: {
    bankLabel: 'Woordenbank',
    bankTitle: 'Kies je woorden',
    bankHint: 'Tik hieronder op een woord om je post-it aan te vullen 👇',
    forWhom: 'Voor wie',
    searchPlaceholder: 'Naam van de collega…',
    catAccion: 'Kernprincipes',
    catComportamiento: 'Gedragingen',
    catHabito: 'Gewoonten',
    catImpacto: 'Impact',
    msgLabel: 'Jouw bericht',
    msgTitle: 'Bouw je erkenning op',
    words: 'elementen',
    clear: 'Wissen',
    clickToRemove: 'Klik om te verwijderen',
    clickHint: 'Klik op een woord uit de woordenbank',
    pickFundFirst: '👆 Kies een kernprincipe om de gedragingen te zien',
    pickBehaviorFirst: '👆 Kies een gedrag om de gewoonten te zien',
    noHabitsForFund: '👆 Dit Kernprincipe heeft geen ingestelde gewoonten',
    howLabel: 'Hoe werkt het?',
    howTitle: 'Drie eenvoudige stappen',
    step1: '<strong>Beweeg de muis</strong> over een woord en het doelvak licht op.',
    step2: '<strong>Klik</strong> op het woord om het in het bericht te plaatsen.',
    step3: '<strong>Klik op het vak</strong> van de post-it om een geplaatst woord te verwijderen.',
    quote: 'Waarderen is het onzichtbare benoemen. Als we iemand vertellen wat we in hem of haar zien, weven we gemeenschap.',
    cta: 'Maak je bericht af',
    ctaDone: 'Maak je bericht af →',
    popupTitle: 'Voeg de persoonlijke toets toe',
    popupChars: '30-80 tekens ideaal',
    nudgeMsg: 'Je bericht heeft meer impact als je er een eigen zin aan toevoegt 💛',
    nudgeAdd: 'Zin toevoegen',
    nudgeSkip: 'Toch versturen',
    sent: 'Erkenning verstuurd!',
    sentIntro: 'Dank aan mijn',
    continueBtn: 'Doorgaan →',
    seeRecognition: 'Mijn erkenning bekijken →',
    clearReset: 'Wissen en opnieuw beginnen',
    wStep: 'Stap {{step}} van {{total}}',
    wQPersona: 'Wie waardeer je?',
    wQFund: 'Welk kernprincipe leefde die?',
    wQBehavior: 'Welk gedrag toonde die?',
    wQHabit: 'Welke gewoonte was het?',
    wQImpact: 'Wat was de impact?',
    templateThanks: 'Ik waardeer',
    templateForLiving: 'voor het leven van',
    templateWith: 'met',
    templateShowing: ', en toont daarmee dat',
    templateThat: '. Dat',
    slotPersona: 'persoon',
    slotAccion: 'kernprincipe',
    slotComportamiento: 'gedrag',
    slotHabito: 'gewoonte',
    slotImpacto: 'impact',
    impact1: 'inspireert ons',
    impact2: 'laat ons groeien',
    impact3: 'brengt ons op één lijn',
    impact4: 'brengt het team vooruit',
    tooltipFundamental: 'Een Fundamental is de waarde die de persoon liet zien.',
    tooltipComportamiento: 'Het concrete gedrag dat die waarde toonde.',
    tooltipHabito: 'De dagelijkse gewoonte waarin dat gedrag zichtbaar is.',
    tooltipImpacto: 'Het effect dat het had op het team.',
    guideStep1Title: 'Kies je woorden',
    guideStep1Text: 'Hier kies je het Fundamental, gedrag, gewoonte en impact die je wilt erkennen.',
    guideStep2Title: 'Je post-it neemt vorm aan',
    guideStep2Text: 'Elk gekozen woord vult een plek in de zin van je erkenning.',
    guideStep3Title: 'Voeg je persoonlijke touch toe',
    guideStep3Text: 'Dit bericht maakt hun erkenning nog specialer.',
    guideStep4Title: 'Verstuur je erkenning',
    guideStep4Text: 'Zodra alles compleet is, wordt deze knop actief en kun je versturen.',
    guideReopen: 'Bekijk de gids opnieuw',
    guideNext: 'Volgende',
    guideSkip: 'Overslaan',
    guideDone: 'Begrepen',
    progressLabel: '{{value}} van {{total}} stappen voltooid',
  },
  // ── WP-11 REQ-106 — CSV-bulkupload ──
  bulk: {
    or: 'of',
    open: 'Bulkupload',
    title: 'Bulkupload van erkenningen',
    subtitle: 'Upload een CSV met meerdere erkenningen tegelijk, controleer en corrigeer voordat je bevestigt.',
    stepInstructions: 'Instructies',
    stepUpload: 'Bestand uploaden',
    stepReview: 'Controleren',
    stepConfirm: 'Bevestigen',
    stepOf: 'Stap {{step}} van {{total}}',
    next: 'Volgende',
    back: 'Terug',
    instructionsIntro: 'Download de sjabloon, vul één collega per rij in en upload het bestand om te valideren en in bulk te laden.',
    matchByIdentity: 'Zoek de persoon op via het geregistreerde e-mailadres of het personeelsnummer — één van beide volstaat. Ken je het e-mailadres niet? Het personeelsnummer werkt net zo goed.',
    onePersonPerRowWarning: 'Belangrijk: elke rij in het bestand is ÉÉN persoon. Zet niet meerdere e-mailadressen of personeelsnummers in dezelfde cel — als je meerdere personen wilt erkennen, voeg dan per persoon een aparte rij toe.',
    // colRequired/colOptional: gedeeld met adminBulkUsers/StepInstructions.tsx (Europa/VS-register)
    // — deze wizard gebruikt ze niet meer (de vaste kolommen hebben geen verplicht/optioneel-label).
    // Niet verwijderen bij een opschoning hier zonder eerst die andere gebruiker te controleren.
    colRequired: 'Verplicht',
    colOptional: 'Optioneel',
    colNameNombre: 'Naam',
    colNameCorreoNomina: 'E-mail of personeelsnummer',
    colNameFundamental: 'Fundamenteel',
    colReceptorEmailDesc: 'E-mail van wie de erkenning ontvangt.',
    colMensajeDesc: 'Erkenningsbericht. Kan verplicht zijn afhankelijk van je organisatie-eenheid.',
    colEmisorEmailDesc: 'E-mailadres van de afzender. Verplicht: dit e-mailadres of het personeelsnummer.',
    colReceptorNominaDesc: 'Personeelsnummer van de ontvanger (AD, SuccessFactors of het Europa-register). Alternatief voor e-mail — vervangt het niet, is bedoeld voor mensen zonder e-mail of die zich nog niet registreerden.',
    colEmisorNominaDesc: 'Personeelsnummer van de afzender. Verplicht: dit nummer of het e-mailadres.',
    markColumnsTitle: 'En één kolom voor elk Fundamental, Gedrag en Dagelijkse gewoonte',
    markColumnsIntro: 'Na die vaste kolommen zie je een kolom voor elk daarvan — zet een X (of een ander teken, zoals "ja") in de juiste kolom. Je hoeft geen enkele code te typen.',
    markFundamentalHint: 'Markeer één of meer Fundamentals per rij — tot het maximum dat je organisatie-eenheid toestaat.',
    markBehaviorHint: 'Gedrag is optioneel — je kunt er meerdere markeren.',
    markHabitHint: 'Dagelijkse gewoonten zijn optioneel — je kunt er meerdere markeren.',
    markColumnsOutro: 'De kolom Mensaje is de laatste kolom in het bestand, na alle markeringskolommen.',
    downloadTemplate: 'Sjabloon downloaden',
    templateError: 'Sjabloon kon niet worden gedownload.',
    catalogError: 'De Fundamentals-catalogus kon niet worden geladen. Probeer het opnieuw — zonder de catalogus kan het bestand niet worden gevalideerd.',
    upload: 'CSV uploaden',
    dragDropHint: 'Sleep je CSV-bestand hierheen of klik om het te selecteren.',
    invalidFileType: 'Alleen CSV-bestanden worden geaccepteerd.',
    emptyFile: 'Het bestand bevat geen gegevensrijen.',
    parseError: 'Het CSV-bestand kon niet worden gelezen.',
    uploadError: 'De bulkupload kon niet worden verwerkt.',
    validRows: '{{count}} geldige rijen',
    invalidRows: '{{count}} met fouten',
    reviewHint: 'Corrigeer de rood gemarkeerde rijen direct in de tabel; elke wijziging wordt opnieuw gevalideerd.',
    colLine: '#',
    colReceptor: 'Ontvanger',
    colFundamental: 'Fundamental',
    colMensaje: 'Bericht',
    colReceptorNomina: 'Personeelsnr.',
    colBehavior: 'Gedrag',
    colHabits: 'Daily Habits',
    colStatus: 'Status',
    ok: 'Geldig',
    expandRow: 'Details van rij {{line}} weergeven',
    collapseRow: 'Details van rij {{line}} verbergen',
    habitsCount_one: '{{count}} Dagelijkse gewoonte',
    habitsCount_other: '{{count}} Dagelijkse gewoonten',
    revalidating: 'Opnieuw valideren…',
    downloadErrors: 'Fouten downloaden (CSV)',
    confirmSummary: 'Er worden {{count}} erkenningen aangemaakt. Rijen met fouten worden overgeslagen.',
    confirm: '{{count}} geldige laden',
    committed: 'Er zijn {{created}} erkenningen aangemaakt. {{skipped}} rijen zijn overgeslagen.',
    duplicatesSkipped_one: '1 erkenning is niet verzonden: deze was al eerder met hetzelfde bericht verzonden.',
    duplicatesSkipped_other: '{{count}} erkenningen zijn niet verzonden: deze waren al eerder met hetzelfde bericht verzonden.',
    notFoundTitle: 'E-mails niet gevonden in de directory:',
    errors: {
      receptorRequired: 'Het e-mailadres van de ontvanger is verplicht.',
      receptorNotFound: 'Dit e-mailadres bestaat niet in de directory.',
      emisorMissing: 'Afzender ontbreekt: vul het e-mailadres of personeelsnummer in van wie erkent.',
      emisorOtherUnit: 'Afzender buiten je eenheid: je kunt alleen uploaden namens mensen uit je eigen eenheid.',
      emisorStaff: 'Afzender met een zakelijk account (staff): uploaden kan alleen namens operationeel personeel.',
      delegateCheckUnavailable: 'We konden de afzenders in het bestand niet controleren en er is niets geüpload. Probeer het over een paar minuten opnieuw.',
      multiplePeopleNotSupported: 'Deze kolom mag maar één persoon bevatten (één e-mailadres of één personeelsnummer). Voeg voor meerdere personen een aparte rij per persoon toe.',
      fundamentalInvalid: 'Het Fundamental is verplicht, of het bericht voldoet niet aan de eisen van je organisatie-eenheid.',
      selfRecognition: 'Je kunt jezelf niet erkennen.',
      blockedWord: 'Het bericht bevat een niet-toegestaan woord.',
      weeklyCapExceeded: 'De afzender heeft de wekelijkse limiet voor erkenningen bereikt.',
      duplicateInFile: 'Deze rij komt meerdere keren voor in het bestand.',
      behaviorInvalid: 'Het Gedrag is niet geldig voor het Fundamental van deze rij.',
      habitInvalid: 'Een van de Daily Habits is niet geldig voor het Fundamental van deze rij.',
      campaignClosed: 'De campagne is niet actief.',
      notAllowedForCampaign: 'Deze rij is niet toegestaan voor de campagne van deze batch.',
      maxFundamentalsExceeded: 'Je kunt niet meer Fundamentals selecteren voor deze erkenning: de limiet wordt bepaald door de configuratie van de organisatie-eenheid van de afzender.',
      generic: 'Deze rij kon niet worden gevalideerd.',
    },
  },
  // ── WP-11 REQ-107 — Post-it-acties ──
  actions: {
    // RF-086 / RN-M06 — de redenencatalogus (`reportReasons`) is verwijderd: de reden is vrije tekst.
    reportCharsLeft: 'Nog {{n}} tekens',
    edit: 'Bewerken',
    report: 'Melden',
    delete: 'Verwijderen',
    saveEdit: 'Opslaan',
    editError: 'De erkenning kon niet worden bewerkt.',
    editMinChars: 'Het bericht moet minstens {{min}} tekens bevatten ({{count}}/{{min}}).',
    reportReason: 'Reden van de melding',
    reportPlaceholder: 'Beschrijf het probleem kort…',
    reportError: 'De melding kon niet worden verstuurd.',
    reportSent: 'Melding verstuurd. Ons team bekijkt hem.',
    sendReport: 'Melding versturen',
    deleteConfirm: 'Weet je zeker dat je deze erkenning wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    deleteError: 'De erkenning kon niet worden verwijderd.',
    confirmDelete: 'Ja, verwijderen',
  },
  // ── WP-15 — Admin (REQ-126/127/128) ──
  admin: {
    // PLAN WP-U8-T5 — estas claves no existian en ningun locale.
    bulkUsers: {
      title: 'Bulkimport van het personeelsbestand (Europa en VS)',
      descLong: 'Aanmaken en bijwerken van het personeelsbestand Europa/VS via een CSV met 24 kolommen, plus de regio van het bestand (Europa of VS), gekozen bij het uploaden. Dit is incrementeel: wie niet in het bestand voorkomt, blijft ongewijzigd; uitdiensttredingen worden gemarkeerd met de kolom EMPLOYEE DELETED. Bij uitdiensttredingen kan het e-mailadres worden leeggemaakt of gewijzigd, en het e-mailadres van een uitgetreden persoon komt weer beschikbaar voor anderen. Alle andere regio\'s worden automatisch gesynchroniseerd door SuccessFactors.',
      importHint: 'Download de sjabloon, vul deze in en upload hem. Bij het uploaden wordt eerst een voorbeeld getoond dat niets opslaat. Datumnotatie MM/dd/jjjj.',
      openWizard: 'Bulkimport openen',
      wizardSubtitle: 'Upload de CSV van het personeelsbestand, controleer het resultaat en bevestig — er wordt pas in de laatste stap iets opgeslagen.',
      confirm: 'Import bevestigen',
      downloadErrors: 'Fouten downloaden (CSV)',
      received: 'Rijen',
      created: 'Aangemaakt',
      updated: 'Bijgewerkt',
      deactivated: 'Gedeactiveerd',
      skipped: 'Overgeslagen',
      disabled: 'De bulkimport Europa/VS is uitgeschakeld in de bron-instellingen.',
      previewNotice: 'Voorbeeld: er is nog niets opgeslagen. Dit zijn de aantallen die de echte import zal opleveren.',
      allOk: 'Alle rijen zijn zonder fouten verwerkt.',
      blockingErrorsNotice: 'Er zijn fouten die verdergaan verhinderen. Corrigeer het bestand en upload het opnieuw.',
      importError: 'Het bestand kon niet worden verwerkt.',
      importErrorTimeout: 'De server deed er te lang over om te reageren. De import kan aan de serverkant toch zijn voltooid — controleer het personeelsbestand voordat je het opnieuw probeert. Referentie: {{correlationId}}',
      ignoredColumnsNotice: 'Deze kolommen uit je bestand worden niet herkend en genegeerd: {{columns}}',
      confirmRecap: 'Er worden {{total}} rijen verwerkt: {{created}} nieuw, {{updated}} bijgewerkt, {{deactivated}} gedeactiveerd.',
      committed: 'Import voltooid: {{created}} nieuw, {{updated}} bijgewerkt, {{deactivated}} gedeactiveerd, {{skipped}} overgeslagen.',
      committedErrorsNotice: 'Sommige rijen hadden problemen tijdens het importeren. Bekijk de details voordat je deze gegevens vertrouwt.',
      paginationPage: 'Pagina {{page}} van {{total}}',
      errorColumn: 'Kolom',
      errorDetail: 'Detail fouten/overslagen',
      ouLabel: 'Regio van het bestand',
      ouPlaceholder: 'Selecteer een regio',
      ouEuropa: 'Europa',
      ouUsa: 'Verenigde Staten (VS)',
      ouCentral: 'Central',
      ouHint: 'Geldt voor alle rijen van het bestand. Wordt niet langer per rij in de CSV vastgelegd, om typ- of taalfouten te voorkomen.',
      ouRequired: 'Selecteer de regio voordat je het bestand uploadt.',
      errorCode: {
        'email-in-use-active': 'E-mailadres is al in gebruik door een actieve gebruiker, voer een ander geldig e-mailadres in.',
        'reactivation-email-in-use': 'Niet opnieuw geactiveerd: het e-mailadres is in gebruik door een actieve gebruiker, voer een ander geldig e-mailadres in.',
        'import-audit-failed': 'De upload is verwerkt, maar kon niet worden vastgelegd in het uploadlogboek. Neem contact op met support.',
        'user-audit-failed': 'De upload is verwerkt, maar het kon niet worden vastgelegd wie sommige personen heeft geüpload. Neem contact op met support.',
        'cache-not-cleared': 'De upload is verwerkt, maar de cache kon voor sommige personen niet worden gewist: hun gegevens kunnen tot een uur verouderd lijken.',
        'row-write-failed': 'Deze rij kon niet worden opgeslagen; neem contact op met support als het probleem zich blijft voordoen.',
      },
      col: {
        employeeDeleted: '1 deactiveert de persoon; 0 of leeg houdt deze actief. Wanneer iemand wordt gedeactiveerd, komt zijn of haar e-mail vrij voor andere gebruikers; als de persoon opnieuw wordt geactiveerd (0) en het e-mailadres al door een actieve gebruiker wordt gebruikt, wordt de persoon niet opnieuw geactiveerd en wordt de regel gemeld.',
        localId: 'Personeelsnummer van de medewerker. Dit is de sleutel — zonder dit kan de rij niet worden verwerkt.',
        firstName: 'Voornaam.',
        lastName: 'Achternaam.',
        secondLastName: 'Tweede achternaam (optioneel).',
        completeName: 'Volledige weergavenaam. Indien leeg, wordt deze samengesteld uit de drie voorgaande velden.',
        email: 'E-mail van de medewerker. Mag leeg zijn — het profiel blijft in het bestand totdat de persoon zich registreert. Bij UITDIENSTREGELS (EMPLOYEE DELETED = 1) wist een lege cel de e-mail van de persoon (die blijft zonder e-mail) en vervangt een nieuw e-mailadres het oude, mits geen andere actieve gebruiker het gebruikt; bij regels die geen uitdiensttreding zijn, verandert een lege cel niets.',
        bu: 'Business unit.',
        siteId: 'Locatie-/vestiging-ID.',
        site: 'Locatie-/vestigingsnaam.',
        orgDirectionId: 'ID van de organisatorische directie.',
        orgDirection: 'Naam van de organisatorische directie.',
        funcDirectionId: 'ID van de functionele directie.',
        funcDirection: 'Naam van de functionele directie.',
        departmentId: 'Afdelings-ID.',
        department: 'Afdelingsnaam.',
        jobPosition: 'Functie van de medewerker.',
        manager: 'Naam van de directe leidinggevende (alleen informatief).',
        managerId: 'Personeelsnummer van de directe leidinggevende. Koppelt de hiërarchie; de leidinggevende moet al in het bestand bestaan.',
        managerEmail: 'E-mail van de directe leidinggevende (alleen informatief).',
        hireDate: 'Datum in dienst, notatie MM/dd/jjjj.',
        birthDate: 'Geboortedatum, notatie MM/dd/jjjj.',
        notification: "YES of NO: of de persoon meldingen ontvangt. Leeg betekent 'niet ingesteld', niet NO.",
        country: 'Land van de persoon. Optioneel, maar zonder dit veld valt de persoon buiten het bereik van de landbeheerders.',
      },
    },
    title: 'Beheer',
    subtitle: 'Configureer het Erkenningsprogramma.',
    denied: 'Je hebt geen rechten voor deze sectie.',
    save: 'Opslaan',
    saving: 'Opslaan…',
    saved: 'Wijzigingen opgeslagen',
    saveError: 'De wijzigingen konden niet worden opgeslagen.',
    rowsPerPage: 'Regels per pagina',
    fundPanelTitle: 'Admin Kernprincipes — Erkenning',
    fundPanelSubtitle: 'Elke module staat op zichzelf. Zet hem aan of uit naargelang de behoeften van je organisatie.',
    pager: {
      showing: '{{range}} van {{total}} weergegeven',
      perPage: '{{size}} per pagina',
      all: 'Alle',
      prev: 'Vorige pagina',
      next: 'Volgende pagina',
      pageSize: 'Resultaten per pagina',
    },
    nav: {
      roles: 'Rollen en rechten configureren',
      points: 'Punten',
      moderation: 'Moderatie',
      winners: 'Winnaars',
      campaigns: 'Campagnes',
      reports: 'Rapportage',
      team: 'Team',
      dashboard: 'Dashboard',
      management: 'Beheer',
      notifications: 'Meldingen',
      views: 'Weergaven',
      docs: 'Documentatie',
      recap: 'Recap',
    },
    roles: {
      title: 'Rollen en rechten configureren',
      desc: 'Beheer beheerders, hun bereik per OU/land en hun rechtenmatrix.',
      searchEmail: 'Zoeken op e-mail…',
      empty: 'Er zijn geen beheerders om te tonen.',
      colAdmin: 'Beheerder',
      colRole: 'Rol',
      colScope: 'Bereik',
      colStatus: 'Status',
      allScopes: 'Alle',
      active: 'Actief',
      inactive: 'Inactief',
      edit: 'Bewerken',
      remove: 'Verwijderen',
      removeConfirmTitle: 'Brillamos-beheerder verwijderen',
      removeConfirmMsg: '"{{name}}" verwijderen als Brillamos-beheerder? Het account blijft bestaan als standaardmedewerker.',
      removeConfirm: 'Ja, verwijderen',
      removeError: 'De beheerdersrol kon niet worden verwijderd. Probeer het opnieuw.',
      status: 'Status',
      permMatrix: 'Rechtenmatrix',
      readOnlyConflict: '‘Alleen lezen’ kan niet samengaan met schrijfrechten (RN-R03). Nu aangevinkt: {{permisos}}. Zodra u een vakje wijzigt, wordt het opgelost; zo opslaan wordt door de server geweigerd.',
      addAdmin: 'Beheerder toevoegen',
      addTitle: 'Beheerder toevoegen',
      editTitle: 'Beheerder bewerken — {{name}}',
      searchPersonLabel: 'Medewerker zoeken',
      searchPersonPlaceholder: 'Naam of e-mail van de medewerker…',
      alreadyAdminNote: 'Deze persoon is al Erkenning-beheerder — bewerk de gegevens hieronder.',
      cannotEditGlobal: 'Deze persoon heeft al de rol Admin Algemeen. Die rol wordt hier niet beheerd.',
      selectRolePlaceholder: 'Selecteer een rol…',
      selectRoleFirst: 'Kies een rol voordat je opslaat.',
      accountActive: 'Account actief (toegang tot het platform)',
      accountActiveHint: 'Dit is het account van de persoon, niet de beheerdersrol. Uitgeschakeld kan die niet inloggen op het platform.',
      deactivateAccountTitle: 'Account deactiveren',
      deactivateAccountMsg: '{{name}} kan niet meer inloggen op het platform. De rol blijft behouden: het account wordt gedeactiveerd. Doorgaan?',
      deactivateAccountConfirm: 'Ja, account deactiveren',
      peopleLabel: 'Personen',
      peopleHint: 'Voeg zoveel personen toe als nodig: zoek ze en voeg ze een voor een toe, of plak meerdere e-mailadressen gescheiden door puntkomma of komma. Allemaal krijgen ze dezelfde rol, reikwijdte en rechten.',
      peopleCount: 'Geselecteerde personen: {{count}}',
      removeAllPeople: 'Alles verwijderen',
      removePerson: '{{name}} verwijderen',
      alreadyAdminTag: 'Al beheerder',
      alreadyAdminBulkNote: '{{count}} van deze personen zijn al Brillamos-beheerders: bij opslaan worden hun rol en rechten vervangen door die hieronder.',
      globalSkipped: '{{names}} is niet toegevoegd: rol Algemene Admin, die hier niet wordt beheerd.',
      resolvingEmails: '{{count}} e-mailadressen opzoeken…',
      emailsNotFound: 'Niemand gevonden met deze e-mailadressen: {{emails}}',
      bulkProgress: '{{done}} van {{total}} opslaan…',
      bulkDone: 'Rol toegewezen aan alle {{count}} personen.',
      bulkPartial: 'Toegewezen aan {{ok}} van {{total}}. Wie mislukte blijft in de lijst; controleer de reden en sla opnieuw op:',
      saveForPeople: 'Opslaan voor {{count}} personen',
      saveForbidden: 'Je hebt geen toestemming om deze wijziging te maken.',
      role: {
        AdminGlobal: 'Admin Algemeen',
        AdminBrillamos: 'Admin Erkenning',
        AdminOUBrillamos: 'Admin OU Erkenning',

        AdminOU: 'Admin OU Pulse',
      },
    },
    perm: {
      manageUsers: 'Gebruikers beheren',
      manageRecognitions: 'Erkenningen beheren',
      manageNotifications: 'Meldingen beheren',
      manageDocuments: 'Documenten beheren',
      manageWinners: 'Winnaars beheren',
      viewAnalytics: 'Analytics bekijken',
      viewReports: 'Rapportage bekijken',
      exportData: 'Gegevens exporteren',
      configureViews: 'Weergaven configureren',
      bulkCsv: 'Bulkverzending (CSV)',
      moderateContent: 'Inhoud modereren',
      manageCampaigns: 'Campagnes beheren',
      createCampaigns: 'Campagnes maken en beheren',
      readOnly: 'Alleen lezen',
      approveNominations: 'Winnaars bevestigen',
      managePoints: 'Beheer',
      manageRoles: 'Rollen en rechten configureren',
      manageBlockedWords: 'Geblokkeerde woorden beheren',
      managePointsConfig: 'Punten',
      manageRecap: 'Jaarlijkse Recap bewerken',
      delegateRecognition: 'Erkennen namens iemand anders',
      accessCatalogFundamentals: 'Catalogus Fundamentals',
      accessCatalogOus: 'Catalogus OUs',
    },
    points: {
      title: 'Punten',
      desc: 'Configureer punten per criterium (0-9), gespiegeld voor Staff/Frontline. Punten zijn nooit zichtbaar voor medewerkers.',
      empty: 'Geen puntencriteria geconfigureerd.',
      seg: { staff: 'Staff', frontline: 'Frontline' },
      segmentActive: 'Actief',
      segmentActiveHint: 'Indien uitgeschakeld, kent deze tabel (Staff of Frontline) geen punten toe, zelfs niet als er criteria zijn ingesteld.',
      lockedCampaign: 'De configuratie is niet meer bewerkbaar zodra een campagne is gestart.',
      campaignActiveWarning: 'De puntenconfiguratie kan niet worden bewerkt zolang er een actieve campagne is in deze organisatie-eenheid.',
      colCategory: 'Categorie',
      colCriterion: 'Criterium',
      colPoints: 'Punten',
      colActive: 'Actief',
      criterionActiveHint: 'Indien uitgeschakeld, kent dit criterium geen punten toe, zelfs niet wanneer eraan wordt voldaan.',
      colAccumulated: 'Totaal',
      accumulatedFooter: 'Beoordeelde nominaties',
      resetAccumulated: 'Terugzetten naar 0',
      resetAccumulatedConfirmTitle: 'Cumulatief totaal terugzetten',
      resetAccumulatedConfirmMessage: 'De teller "Totaal cumulatief" van deze OE en dit segment wordt teruggezet naar 0. De erkenningsgeschiedenis wordt NIET verwijderd; deze telt vanaf nu alleen niet meer mee. Deze actie kan niet ongedaan worden gemaakt.',
      resetAccumulatedSuccess: 'Het cumulatieve totaal is teruggezet naar 0.',
      resetAccumulatedError: 'Het cumulatieve totaal kon niet worden teruggezet.',
      accumulatedError: 'Het aantal nominaties kon niet worden geladen.',
      accumulatedDisabledHint: 'Met punten uitgeschakeld beoordeelt de engine niet, dus het totaal blijft nul, ook als er erkenningen zijn.',
      globalToggle: 'Punten van toepassing (globaal)',
      globalToggleHint: 'Schakelt het puntensysteem in of uit voor ALLE organisatie-eenheden, ongeacht wat elke eenheid afzonderlijk heeft ingesteld.',
      visibleToEmployees: 'Zichtbaar voor medewerkers',
      visibleToEmployeesHint: 'Toont op de post-it de punten van elke erkenning van deze OU. Nooit het totaal van een persoon.',
      visibleUnknown: 'De stand van de schakelaar kon niet worden gelezen. Er verandert niets tot dat wel kan.',
      visibleGdprBlocked: 'Deze OU valt onder de AVG: punten worden niet getoond, ook niet met de schakelaar aan.',
      globalOffHint: 'De globale schakelaar staat uit: geen enkele OU kent punten toe, ook al is de tabel actief.',
      ouPicker: 'Organisatie-eenheid',
      ouPickPlaceholder: 'Kies een eenheid…',
      pickOuFirst: 'Kies een organisatie-eenheid om de puntenconfiguratie te bekijken en te bewerken.',
      accumulatedNoKey: 'Dit criterium heeft geen canonieke sleutel en kan dus niet aan de telling worden gekoppeld.',
      globalOverriddenHint: 'Deze eenheid heeft een eigen uitzondering: hier staat de schakelaar {{estado}}, ongeacht de globale waarde.',
      globalOn: 'aan',
      globalOff: 'uit',

      globalUnknown: 'De globale schakelaar kon niet worden gelezen; de werkelijke stand is onbekend.',
      noOuInProfile: 'Aan je profiel is geen organisatie-eenheid toegewezen, dus er is geen puntenconfiguratie om te tonen. Vraag het aan de globale beheerder.',
      exportReport: 'Puntenrapport downloaden',
      exporting: 'Bezig met downloaden…',
      exportError: 'Het puntenrapport kon niet worden gegenereerd. Probeer het opnieuw.',
      exportEmpty: 'Er zijn geen puntenrijen om te exporteren binnen dit bereik.',
      exportTruncated: 'Het rapport is afgekapt bij {{tope}} rijen; beperk het bereik om alles te exporteren.',
      exportNamesUnresolved: 'Sommige namen konden niet worden opgezocht; die rijen bevatten hun identificatie.',
      exportColPerson: 'Persoon',
      exportColOu: 'Organisatie-eenheid',
      exportColPoints: 'Punten'
    },
    placeholder: {
      soon: 'Deze sectie is binnenkort beschikbaar.',
      tracked: 'Opvolging: {{req}}',
    },
    recognitions: {
      title: 'Erkenningen',
      descLong: 'Beheer de catalogus van Kernprincipes/Gewoonten: aanmaken, bewerken, activeren/deactiveren, koppelen aan campagne en microsite.',
      tabActive: 'Kernprincipes',
      tabTrash: 'Prullenbak',
      tabHabits: 'Daily Habits',
      newHabit: 'Nieuwe Daily Habit',
      habitSearchPlaceholder: 'Habit zoeken…',
      habitsEmpty: 'Er zijn geen Daily Habits in de catalogus.',
      colColor: 'Kleur',
      colNameEs: 'Naam (ES)',
      colNameEn: 'Naam (EN)',
      colParent: 'Bovenliggend fundament',
      colOuVisibility: 'Zichtbaarheid per OE',
      ouInherited: 'Geërfd van fundament',
      habitStatusAll: 'Alle',
      habitStatusActive: 'Actief',
      habitStatusInactive: 'Inactief',
      deleteHabitConfirm: 'Deze Daily Habit uit de catalogus verwijderen?',
      newHabitTitle: 'Nieuwe Daily Habit',
      editHabitTitle: 'Daily Habit bewerken',
      new: 'Nieuw Kernprincipe',
      searchPlaceholder: 'Zoeken op code of naam…',
      empty: 'De catalogus is leeg.',
      colCode: 'Code',
      colName: 'Naam',
      colHabits: 'Gewoonten',
      colBrillamos: 'Wij stralen',
      colMicrosite: 'Microsite',
      colStatus: 'Status',
      inBrillamos: 'In Wij stralen',
      notInBrillamos: 'Buiten',
      openMicrosite: 'Openen',
      edit: 'Bewerken',
      deleteConfirm: 'Dit Kernprincipe naar de prullenbak verplaatsen?',
      trashEmpty: 'De prullenbak is leeg.',
      newTitle: 'Nieuw Kernprincipe',
      editTitle: '{{code}} bewerken',
      needAllLangs: 'Vul de naam in alle 7 talen in.',
      fieldCode: 'Code',
      fieldOrder: 'Volgorde',
      fieldName: 'Naam',
      fieldShortName: 'Korte naam',
      fieldColor: 'Kleur',
      fieldMicrosite: 'URL van de microsite',
      fieldCampaignScope: 'Gekoppelde campagne',
      campaignScopeHint: 'Campagne-id (leeg = globale catalogus)',
      fieldBrillamos: 'Doet mee aan Samen Stralen',
      legacyCatalogWarning: 'Deze catalogus is tijdelijk: wijzigingen hier zijn nog niet zichtbaar in wat medewerkers zien bij het erkennen (P2-010).',
    },
    moderation: {
      desc: 'Geblokkeerde woorden en meldingenbox.',
      title: 'Moderatie',
      descLong: 'Meldingenbox met doorverwijzing, catalogus van geblokkeerde woorden en moderatieschakelaars.',
      contentTitle: 'Contentmoderatie',
      wordsTitle: 'Geblokkeerde Woorden',
      wordsDesc: 'Ze worden automatisch herkend en geblokkeerd bij het versturen van een erkenning.',
      wordsCounted: 'geblokkeerde woorden',
      manageWords: 'Beheren',
      wordsManagerDesc: 'Voeg woorden per taal toe, bewerk of verwijder ze. Geschikt voor meer dan 100 woorden.',
      newWord: 'Nieuw woord',
      region: 'Land/Regio',
      regionGlobal: 'Globaal (alle)',
      regionHint: 'Dezelfde taal kan per land of regio andere woorden hebben.',
      allRegions: 'Alle regio’s',
      searchWord: 'Zoeken…',
      editWord: 'Woord bewerken',
      word: 'Woord',
      wordPlaceholder: 'Bijv.: ongepast…',
      language: 'Taal',
      addWord: 'Toevoegen',
      wordsEmpty: 'Geen woorden komen overeen met het filter.',
      langOther: 'Overige',
      // RF-082 — tabel land→talen die bepaalt welke catalogus voor elke afzender geldt.
      countryLanguagesTitle: 'Landen en talen',
      countryLanguagesDesc: 'Bepaal welke talen in elk land worden gesproken. Een meertalig land (België: nl en fr) past de woorden van al zijn talen toe zonder ze twee keer vast te leggen. Landen in ISO-3166 (MX, ES, BE) en talen uit de 7 van het platform (es, en, pt, fr, de, nl, ro). Gebruik het veld Land/Regio van een woord om het tot één land te beperken.',
      countryLanguagesEmpty: 'De tabel met landen en talen is leeg.',
      regionsTitle: 'Regio’s',
      regionMembers: 'Landen erin',
      countryLanguagesInvalid: 'Controleer deze codes voordat je opslaat: {{codes}}. Het land is een ISO-code van 2 letters (MX) en de taal moet een van de 7 van het platform zijn (es, en, pt, fr, de, nl, ro), zonder landvariant.',
      countryLanguagesUnreadable: 'De tabel kon niet worden gelezen en kan dus niet worden opgeslagen: opslaan vervangt de hele tabel en wat niet zichtbaar is zou verdwijnen.',
      country: 'Land',
      languages: 'Talen',
      languagesPlaceholder: 'nl, fr',
      addCountry: 'Land toevoegen',
      countryPlaceholder: 'MX',
      autoTitle: 'Instellingen voor Automatische Moderatie',
      aiAutoBlock: 'Automatische blokkering door AI',
      aiAutoBlockHint: 'Indien aan, wordt elk waarderingsbericht bij het verzenden door AI (Azure AI Content Safety) gecontroleerd en geblokkeerd als het aanstootgevend is.',
      helpAria: 'Help',
      aiHelp: 'Controleert elk bericht bij het verzenden met AI (Azure AI Content Safety) en herkent toxiciteit in context (haat, bedreigingen, intimidatie). Vormt een aanvulling op de catalogus van geblokkeerde woorden: beide kunnen tegelijk aan staan. Vereist dat "Moderatie actief (globaal)" aan staat; met de globale schakelaar uit geldt deze laag niet.',
      globalHelp: 'Hoofdschakelaar van de moderatie. Als deze uit staat, wordt er NIETS gemodereerd: niet de AI-blokkering, niet de catalogus van geblokkeerde woorden, en er worden geen meldingen geaccepteerd. Zet hem aan zodat de andere lagen werken.',
      wordsHelp: 'Blokkeert exacte woorden bij het verzenden, ongeacht de context. Vormt een aanvulling op de AI-blokkering (die toxiciteit in context herkent). Beide lagen vereisen dat "Moderatie actief (globaal)" aan staat.',
      hideThreshold: 'Meldingsdrempel om te verbergen',
      notifyReporter: 'Melder op de hoogte stellen',
      aiPendingNote: 'Met automatische AI-blokkering aan worden waarderingsberichten bij het verzenden gecontroleerd door Azure AI Content Safety en geweigerd als ze de omgangsregels schenden. Het werkt samen met de catalogus van geblokkeerde woorden.',
      hideThresholdHint: 'Hoeveel meldingen nodig zijn om een waardering automatisch te verbergen. De waarde 1 is de geldende regel: verbergen bij de eerste melding.',
      notifyReporterHint: 'Slaat de voorkeur op en stuurt die mee met de moderatiegebeurtenis. De e-mail aan de melder verstuurt NotificationService zodra die melding bestaat.',
      advanced: 'Geavanceerde instellingen',
      globalEnabled: 'Moderatie actief (globaal)',
      reportEnabledGlobal: 'Melden standaard ingeschakeld',
      dailyReportLimit: 'Daglimiet voor meldingen',
      // RF-084 — uitzonderingen op "melden toestaan" per knoop, cascade Site -> BU -> OU -> globaal.
      overridesTitle: 'Melden per eenheid (cascade)',
      overridesDesc: 'Uitzonderingen op de globale waarde. De meest specifieke knoop wint: Site, dan BU, dan OU en de bovenliggende eenheden. Een eenheid zonder uitzondering erft die van de bovenliggende eenheid.',
      overridesNode: 'Eenheid, BU of Site',
      overridesNodePlaceholder: 'Kies een OU of typ een BU-/Site-id',
      overridesAllow: 'Toegestaan',
      overridesBlock: 'Geblokkeerd',
      overridesEmpty: 'Geen uitzonderingen: alle eenheden gebruiken de globale waarde.',
      overridesDuplicate: 'Er bestaat al een uitzondering voor “{{node}}”. Identificatiecodes zijn niet hoofdlettergevoelig: bewerk of verwijder de bestaande.',
      inboxTitle: 'Meldingenbox',
      inboxDesc: 'Meldingen van gebruikers. Bij verbergen verdwijnt de erkenning van de muur van wie hem ontving en uit de verzonden erkenningen van wie hem stuurde; hij wordt ook uit het medailleklassement gehaald en de punten worden geannuleerd.',
      searchName: 'Zoeken op naam…',
      filterAll: 'Alle',
      filterOu: 'OU: Alle',
      filterBu: 'BU: Alle',
      filterSite: 'Site: Alle',
      filterFrom: 'Van',
      filterTo: 'Tot',
      filterType: 'Type: Alle',
      type: { fundamentales: 'Kernprincipes', brillamos: 'Samen Stralen', diario: 'Dagelijkse Erkenning' },
      uiStatus: { pendiente: 'In afwachting', restaurado: 'Hersteld', eliminado: 'Verwijderd' },
      uiStatusPlural: { pendiente: 'In afwachting', restaurado: 'Herstelde', eliminado: 'Verwijderde' },
      status: { Publicado: 'Gepubliceerd', Pendiente: 'In afwachting', Resuelto: 'Opgelost', Desestimado: 'Afgewezen' },
      reportsEmpty: 'Geen meldingen komen overeen met het filter.',
      colReportedBy: 'Gemeld door',
      colRecognitionFrom: 'Erkenning van',
      colTo: 'Voor',
      colDetail: 'Detail',
      colReason: 'Reden',
      colDate: 'Datum',
      colStatus: 'Status',
      colActions: 'Acties',
      // RF-090 — envelopknop: schaalt de zaak op naar de OU-/landbeheerder, zonder wachten.
      notifyAdmin: 'Beheerder waarschuwen',
      notifyAdminHint: 'Stuurt meteen een bericht naar de beheerder van de eenheid van deze erkenning, zonder te wachten op het wekelijkse overzicht.',
      notifyAdminConfirm: 'Een bericht sturen naar de beheerder van de eenheid van {{name}}? Er gaat meteen een e-mail uit.',
      notifyAdminSent: 'Bericht naar de beheerder verstuurd.',
      notifyAdminError: 'Het bericht aan de beheerder kon niet worden verstuurd.',
      // RF-090 — voorbeeld van de ontvangers: de envelopknop meldde 'verzonden' terwijl niemand iets kreeg.
      notifyPreviewTitle: 'Dit bericht bereikt:',
      notifyPreviewLoading: 'Ontvangers worden opgezocht…',
      notifyPreviewEmpty: 'Er kon geen ontvanger worden gevonden.',
      notifyPreviewError: 'Kon niet nagaan wie het bericht zou bereiken.',
      notifyReason: {
        'sin-admins-en-la-ou': 'Deze eenheid heeft geen enkele geregistreerde beheerder, en er zijn geen globale beheerders om de zaak naar te escaleren.',
        'escalado-a-globales': 'De eenheid heeft geen eigen beheerder: de zaak wordt geëscaleerd naar de globale beheerders.',
        'admin-sin-correo': 'De beheerder heeft geen bruikbaar e-mailadres in de directory, dus er valt niemand aan te schrijven.',
        'directorio-no-responde': 'De gebruikersdirectory antwoordde niet: er is niet vast te stellen wie gewaarschuwd zou moeten worden.',
        'suprimido-por-allowlist': 'De verzending zou worden weggegooid: dit adres staat niet op de lijst met toegestane ontvangers van de notificatiedienst.',
        'allowlist-desconocida': 'De lijst met toegestane ontvangers kon niet worden gecontroleerd; de verzending kan spoorloos worden weggegooid.',
        desconocido: 'Het bericht kan niet worden verzonden om een reden die de dienst niet kon uitleggen.',
      },
      deleteLabel: 'Verwijderen',
      hideHint: 'Verbergt de erkenning van de muur, haalt hem uit het medailleklassement en annuleert de punten.',
      restore: 'Herstellen',
      reopen: 'Heropenen',
      reopenHint: 'Zet de zaak terug in de wachtrij als In behandeling en verbergt de waardering opnieuw.',
      viewDetail: 'Details bekijken',
      detailTitle: 'Details van de melding',
      whoReported: 'Wie meldde',
      whoWasReported: 'Wie werd gemeld',
      reportedRecognition: 'Gemelde erkenning',
      messageUnavailable: 'Tekst niet beschikbaar.',
      // RF-087 — doorverwijzing van de zaak: e-mail en OU worden altijd getoond, met markering als ze ontbreken.
      dataUnavailable: 'Niet beschikbaar',
      detailLoading: 'Laden…',
      detailError: 'De actuele contactgegevens konden niet worden geladen; getoond worden de gegevens van het moment van de melding.',
      chipOu: 'OU',
      chipBu: 'BU',
      chipSite: 'Site',
      colCampaign: 'Campagne',
      filterCampaign: 'Campagne: Alle',
    },
    winners: {
      // Task 2.5 — kaartraster voor Campagnebadges binnen Winnaars (AdminCampaignBadgeGrid).
      campaignBadges: {
        title: 'Campagne-badges',
        permanenceNote: 'Deze badges zijn permanent: ze worden niet aan- of uitgezet zoals streak-badges, maar blijven gekoppeld aan de campagne en het jaar waarvoor ze zijn toegekend.',
        empty: 'Nog geen campagne-badges.',
        edit: 'Bewerken',
        delete: 'Verwijderen',
        deleteConfirm: 'Campagnebadge "{{name}}" verwijderen? De naam in alle 7 talen, het icoon en het jaar gaan verloren. Dit kan niet ongedaan worden gemaakt.',
        add: '+ Badge toevoegen',
        editTitle: 'Campagnebadge bewerken',
        fieldTitle: 'Titel',
        fieldYearSubtitle: 'Jaar / Ondertitel',
        fieldYear: 'Jaar van de prijs',
        yearNone: 'Geen jaar',
        fieldYearHint: 'Wordt bij toekenning gecontroleerd: een badge van het ene jaar kan niet in een campagne van een ander jaar worden gegeven. "Geen jaar" schakelt de controle uit.',
        fieldImage: 'Afbeelding',
        imageUploadHintNew: 'Sla de badge eerst op om de afbeelding te kunnen uploaden.',
        imageFormatInvalid: 'Het afbeeldingsformaat is ongeldig. Gebruik PNG, JPG, WEBP of SVG.',
        previewTitle: 'Voorbeeld',
      },
      bulkTitle: 'Bulkbevestiging',
      bulkSelected: '{{count}} geselecteerd',
      bulkConfirm: '{{count}} bevestigen',
      bulkConfirming: 'Bezig met bevestigen…',
      bulkClear: 'Selectie wissen',
      bulkSelectAll: 'Alle openstaande op deze pagina selecteren',
      bulkSelectOne: '{{name}} selecteren',
      bulkFailed: '{{count}} konden niet worden bevestigd. De rest wel; probeer het alleen met die opnieuw.',
      editTitle: 'Winnaar bewerken — {{nombre}}',
      actionError: 'De actie kon niet worden voltooid.',
      badExtension: 'Formaat niet ondersteund. Toegestaan: {{ext}}',
      // No son «Área»/«Site»: el backend resuelve esas dos columnas con el PUESTO y el
      // DEPARTAMENTO de la ficha de la persona (ver AdminWinners.tsx).
      colPuesto: 'Functie',
      colDepto: 'Afdeling',
      colFundamental: 'Fundamental',
      colStatus: 'Status',
      colUser: 'Gebruiker',
      colUserNomina: 'Personeelsnummer: {{nomina}}',
      colSite: "Site",
      colEmail: "E-mail",
      exportSheetName: "Winnaars",
      exportTitle: "Winnaars",
      exportSubtitle: "Geregistreerde winnaars met de toegepaste filters",
      colYear: 'Jaar',
      colBadge: 'Badge',
      badgeNone: 'Geen badge',
      exportFiltered: 'Download de winnaars van de huidige filters als Excel',
      exportEmpty: 'Geen winnaars om te exporteren met deze filters',
      exporting: 'Bezig met exporteren…',
      exportError: 'De download kon niet worden voltooid. Probeer het opnieuw.',
      confirmAction: 'Bevestigen als winnaar',
      confirmDelete1: '{{nombre}} uit de winnaarslijst verwijderen?',
      confirmDelete2: 'Dit kan niet ongedaan worden gemaakt en wordt vastgelegd. Bevestigen?',
      deleteTitle: 'Winnaar verwijderen',
      deleteConfirm: 'Verwijderen',
      countryAll: 'Land: alle',
      editAction: 'Bewerken',
      editClosed: 'Buiten de bewerkingsperiode.',
      editWindowNote: 'Je kunt een winnaar tot 1 maand na het uploaden bewerken. De algemeen beheerder kan elke winnaar van de afgelopen 3 jaar bewerken.',
      exportNominations: 'Nominaties exporteren',
      exportWinners: 'Winnaars exporteren',
      exportNominationsEmpty: 'Er zijn geen nominaties om te exporteren voor deze campagne.',
      exportPending: 'De export wordt in het volgende pakket aangesloten.',
      filterCountry: 'Land',
      filterFundamental: 'Fundamental',
      filterYear: 'Jaar',
      filtersToggle: 'Filters',
      flowHint: 'Winnaars worden via een bestand geladen. De werkwijze: upload de sjabloon → verschijnt hier → bevestig als definitieve winnaar.',
      fundamentalAll: 'Fundamental: alle',
      fundamentalNone: 'Geen fundamental',
      importErrorsTitle: 'Geweigerde rijen',
      importSummary: '{{importados}} van {{total}} rijen geïmporteerd · {{rechazados}} geweigerd.',
      manageTitle: 'Beheer van winnaars',
      moduleHint: 'Zet aan om winnaars te kunnen uploaden en badges toe te kennen.',
      moduleOffWarn: 'Winnaarsmodule uitgeschakeld. Deze instelling wordt voorlopig alleen opgeslagen en verandert nog niets voor gebruikers.',
      moduleSaveError: 'De wijziging van de winnaarsmodule kon niet worden opgeslagen. Probeer het opnieuw.',
      moduleTitle: 'Winnaarsmodule',
      needsCsv: 'Dit is een binair Excel-werkboek en kan niet worden gelezen. Open het en sla het op als CSV (UTF-8) voordat je het uploadt.',
      noResults: 'Geen winnaars die aan het filter voldoen.',
      ouAll: 'OU: alle',
      pagerInfo: 'Pagina {{page}} van {{paginas}} · {{total}} winnaars',
      searchByName: 'Zoeken op naam…',
      statusConfirmed: '✓ Bevestigd',
      statusPending: '⏳ In afwachting',
      uploadFile: 'Excel uploaden',
      uploadCampaign: 'Campagne van de lijst',
      uploadMode: 'Editie van de lijst',
      uploadModeCurrent: 'Huidig',
      uploadModeHistoric: 'Historisch',
      uploadOpen: 'Lijst uploaden',
      uploadOpenHint: 'Opent de wizard om de winnaarslijst te uploaden, huidig of historisch.',
      uploadModalTitle: 'Winnaarslijst uploaden',
      uploadModalToggleHint: 'Kies “Huidig” als de lijst hoort bij een campagne die nu actief is op de site. Kies “Historisch” om prijzen uit eerdere jaren te laden die niet als campagne zijn vastgelegd.',
      uploadBadge: 'Badge',
      uploadBadgeHint: 'Elke rij in het bestand krijgt DEZE badge. Kies de badge voordat je het bestand uploadt.',
      uploadBadgePick: 'Kies de badge…',
      uploadBadgeClarify: 'De badge is geen campagne: het is de afbeelding die de persoon te zien krijgt als gewonnen prijs (bijvoorbeeld een medaille of trofee).',
      pickBadgeFirst: 'Kies eerst de badge die de winnaars in dit bestand gaan ontvangen.',
      uploadHistoricWarning: 'Historische gegevens worden direct opgeslagen, zonder koppeling aan een campagne. Controleer naam, e-mail en badge voordat je uploadt.',
      helpOpen: 'Hulp bij het uploaden van de lijst',
      helpModalTitle: 'Hoe upload ik de winnaarslijst?',
      helpIntroVigente: 'Huidig: gebruik dit als de prijs hoort bij een campagne die op de site staat en nu actief is. Je kiest de campagne en de badge (de afbeelding die als gewonnen prijs wordt getoond) en downloadt de sjabloon: die vraagt alleen om het e-mailadres of personeelsnummer van de persoon. Naam, jaar en OE/locatie kent het systeem al — die hoef je niet in te vullen.',
      helpIntroHistorico: 'Historisch: gebruik dit als de prijs komt van een oude campagne die niet meer op de site staat, of waarvan je geen gegevens meer hebt. Je kiest GEEN campagne: in plaats daarvan kies je ÉÉN badge (de afbeelding die als gewonnen prijs wordt getoond, geen campagnenaam), die aan IEDEREEN in het bestand wordt gegeven. Download de sjabloon met 2 kolommen (Naam en E-mail of personeelsnummer), vul die in en upload hem.',
      helpDirectorio: 'Het e-mailadres of het personeelsnummer moet voorkomen in het adresboek van het bedrijf. Wordt geen van beide gevonden, dan wordt alleen die rij geweigerd; de rest van het bestand wordt gewoon geladen. Heeft iemand geen e-mailadres (bijvoorbeeld fabriekspersoneel), vul dan het personeelsnummer in diezelfde kolom in — het e-mailadres is dan niet nodig.',
      helpNoDownload: 'Als je een bestand probeert te downloaden en er zijn geen gegevens om te tonen, wordt er niets gedownload: je krijgt in plaats daarvan een melding op het scherm.',
      downloadTemplateHint: 'Download een leeg Excel-bestand met de juiste kolommen voor deze modus, in jouw taal.',
      downloadTemplateCurrent: 'Huidige sjabloon downloaden',
      downloadTemplateHistoric: 'Historische sjabloon downloaden',
      uploadFileHint: 'Upload het ingevulde Excel-bestand met de gegevens van de lijst.',
      importWizard: {
        subtitle: 'Upload de lijst, controleer het resultaat voor je bevestigt, en download de fouten als iets misgaat.',
        colNombreDesc: 'Naam van de winnaar, zoals die getoond wordt.',
        colNombreDescVigente: 'Naam van de winnaar. Je mag dit leeg laten: vul je niets in, dan wordt de naam gebruikt die al voor deze persoon geregistreerd staat.',
        colEmailDesc: 'E-mail OF personeelsnummer van de persoon — één van beide is genoeg; identificeert wie de prijs ontvangt.',
        colFundamentalDesc: 'Erkend grondbeginsel (naam in elke taal, of catalogus-code). Wordt genegeerd als het met geen enkele overeenkomt.',
        badgePreviewHint: 'Zo ziet de badge eruit — precies wat elke winnaar in dit bestand gaat ontvangen.',
        dropHint: 'Sleep je Excel- of CSV-bestand hierheen, of klik om het te kiezen.',
        reviewHint: 'Dit is alleen een VALIDATIE: er wordt nog niets opgeslagen. Bekijk de samenvatting en ga zo nodig terug om een gecorrigeerd bestand te kiezen.',
        previewPending: 'Bestand valideren…',
        noErrors: 'Geen fouten — alle rijen zijn geldig.',
        fileLevelError: 'Bestand/selectie',
        confirmPending: 'Opslaan…',
      },
      filterEstado: 'Status',
      estadoAll: 'Status: alle',
      uploadCampaignPick: 'Kies de campagne…',
      pickCampaignFirst: 'Kies eerst de campagne waartoe de lijst behoort.',
      exportNominationsCatalogError: 'De Fundamentals/Habits-catalogus kon niet worden geladen: de export kan onvolledig zijn. Probeer het opnieuw.',
      yearAll: 'Jaar: alle',
      desc: 'Register van winnaars van Samen Stralen.',
      title: 'Winnaars',
      descLong: 'Winnaars per campagne/OU. Handmatig aanmaken en CSV-import van de historie met feedback per regel.',
      filterCampaign: 'Campagne',
      campaignIdHint: 'Campagne-id',
      filterOu: 'OU',
      ouHint: 'OU-id',
      add: 'Winnaar toevoegen',
      addTitle: 'Nieuwe winnaar',
      fieldCampaign: 'Campagne',
      fieldUser: 'Gebruiker',
      fieldName: 'Naam',
      fieldOuName: 'OU',
      fieldCountry: 'Land',
      fieldPosition: 'Positie',
      save: 'Opslaan',
      importTitle: 'CSV-import',
      importHint: 'Download het sjabloon, vul het in en upload het. De import is idempotent per campagne + gebruiker.',
      downloadTemplate: 'Sjabloon downloaden',
      uploadCsv: 'CSV uploaden',
      templateError: 'Het sjabloon kon niet worden gedownload.',
      importError: 'De import kon niet worden verwerkt.',
      deleteError: 'Deze winnaar kon niet worden verwijderd.',
      totalRows: 'Totaal aantal regels',
      imported: 'Geïmporteerd',
      rejected: 'Afgewezen',
      row: 'Regel',
      reason: 'Reden',
      empty: 'Er zijn geen winnaars voor deze filters.',
      colPosition: 'Positie',
      colName: 'Naam',
      colOu: 'OU',
      colCountry: 'Land',
      colCrossed: 'Gekruiste oorsprong',
      colDate: 'Geregistreerd',
      // Task 16 — kolomkoppen van de ruwe nominatie-export (i18n, geen vast Spaans meer).
      nominationsExport: {
        // De `nominee*`-sleutels bevatten de persoon die HEEFT GENOMINEERD (het Nominee_*-blok van
        // de DTO komt uit Recognition.EmisorSnapshot). De genomineerde persoon staat in het
        // `candidate*`-blok hieronder.
        nomineeName: 'Indiener: Naam',
        nomineeEmail: 'Indiener: E-mail',
        nomineeEmployeeId: 'Indiener: Personeelsnr.',
        nomineeOu: 'Indiener: OU',
        nomineeBu: 'Indiener: BU',
        nomineeSite: 'Indiener: Site',
        nomineeDepartment: 'Indiener: Functie',
        onBehalfOfName: 'Namens: Naam',
        onBehalfOfEmail: 'Namens: E-mail',
        onBehalfOfEmployeeId: 'Namens: Personeelsnr.',
        onBehalfOfOu: 'Namens: OU',
        onBehalfOfBu: 'Namens: BU',
        onBehalfOfSite: 'Namens: Site',
        onBehalfOfDepartment: 'Namens: Functie',
        candidateName: 'Kandidaat: Naam',
        candidateEmail: 'Kandidaat: E-mail',
        candidateEmployeeId: 'Kandidaat: Personeelsnr.',
        candidateOu: 'Kandidaat: OU',
        candidateBu: 'Kandidaat: BU',
        candidateSite: 'Kandidaat: Site',
        candidateDepartment: 'Kandidaat: Functie',
        date: 'Datum',
        year: 'Jaar',
        month: 'Maand',
        habitPrefix: 'Gewoonte',
        comment: 'Opmerking',
        streakBadge: 'Reeksbadge',
        fromDayToDay: 'Komt uit dagelijkse herkenning',
        status: 'Status',
        type: 'Type',
        audienceNominee: 'Doelgroep van de indiener',
        audienceCandidate: 'Doelgroep van de kandidaat',
        points: 'Punten',
        retiredHabitsGroup: 'Overige / verwijderde gewoontes',
      },
    },
    campaigns: {
      desc: 'Wizard voor erkenningscampagnes.',
      statusDivider: 'Campagnestatus',
      title: 'Campagnes',
      descLong: 'Lijst met campagnes en wizard in 5 stappen: Info, Doelgroep, Configuratie, Documenten en Publicatie.',
      filterAll: 'Alle',
      status: {
        Borrador: 'Concept', Activa: 'Actief', Finalizada: 'Beëindigd', PendienteAprobacion: 'In afwachting van goedkeuring',
        // Bug UAT #114 — «Activa» significaba dos cosas: corriendo, o marcada activa
        // pero fuera de su ventana de fechas (el colaborador no la ve).
        ActivaVencida: 'Actief · buiten periode',
        ActivaPorIniciar: 'Actief · nog niet gestart',
        // ADR 0014 — estado visible de la pestaña Brillamos (Activa con inicio futuro).
        PorIniciar: 'Nog niet gestart',
        ActivaVencidaHint: 'De campagne staat nog als actief, maar de periode is voorbij: medewerkers binnen het bereik zien de campagne niet.',
        ActivaPorIniciarHint: 'De campagne is actief maar de startdatum is nog niet bereikt.',
      },
      approvals: 'Goedkeuringen',
      new: 'Nieuwe campagne',
      empty: 'Er zijn geen campagnes.',
      colName: 'Naam',
      colType: 'Type',
      colStatus: 'Status',
      colScope: 'Bereik',
      allScopes: 'Alle OU’s',
      editBtn: 'Bewerken',
      duplicate: 'Dupliceren',
      panic: 'Campagne stoppen',
      deactivateConfirmTitle: 'OU-uitzondering stoppen',
      deactivateConfirmMsg: 'Deze OU-uitzondering nu stoppen? Ze geldt daarna meteen niet meer voor haar bereik.',
      panicConfirm: 'Deze campagne onmiddellijk stoppen?',
      type: { Fundamentales: 'Kernprincipes', Brillamos: 'Wij stralen', Personalizada: 'Aangepast' },
      wizardEditTitle: 'Campagne bewerken',
      wizardNewTitle: 'Nieuwe campagne',
      wizardSub: 'Doorloop de 6 stappen om de campagne aan te maken of te bewerken.',
      backToList: 'Terug naar de lijst',
      step: { info: 'Info', design: 'Ontwerp', audience: 'Doelgroep', config: 'Configuratie', documents: 'Documenten', publish: 'Publiceren' },
      tabFundamentales: 'Fundamentals',
      tabBrillamos: 'Shine Together',
      tabPersonalizadas: 'Aangepast',
      fundActiveTitle: 'Altijd actief',
      fundRules: 'Verzendregels',
      fundActiveDesc: 'Fundamentals is de basis van het erkenningsprogramma. Het kan niet worden uitgeschakeld, alleen de regels ervan configureren.',
      fundConfigNote: 'Gedetailleerde verzendregels en limieten worden beheerd in de sectie Beheer.',
      globalPanic: 'Alle campagnes stoppen',
      globalPanicConfirm: 'Alle actieve Shine Together-campagnes onmiddellijk beëindigen? Deze actie kan niet ongedaan worden gemaakt.',
      globalPanicDone: '{{count}} campagne(s) beëindigd.',
      docCategoria: 'Categorie',
      docCatNone: 'Geen categorie',
      fieldType: 'Type campagne',
      fieldName: 'Naam',
      fieldDescription: 'Beschrijving',
      fieldSlug: 'Slug van de landingspagina',
      fieldScope: 'Bereik (OU’s)',
      fieldExclusions: 'Uitsluitingen',
      fieldStart: 'Startdatum',
      fieldEnd: 'Einddatum',
      fieldTimezone: 'Tijdzone',
      fieldStreakMinimum: 'Reeksminimum van de campagne',
      streakMinimumInherit: 'Gebruik de globale',
      streakMinimumHint: 'Verzendingen die deze campagne vraagt om reeks op te bouwen in de periode (1-20). Leeg = het globale minimum uit Beheer geldt.',
      streakMinimumLocked: 'De campagne is al gestart: het reeksminimum kan niet wijzigen zonder de lopende periode opnieuw te beoordelen.',
      fieldRecognitionsLimitOwn: 'Verzendlimiet van de campagne',
      recognitionsLimitOwnInherit: 'Gebruikt de globale waarde',
      recognitionsLimitNotApplicable: 'Niet van toepassing (geen verzendlimiet)',
      recognitionsLimitNotApplicableShort: 'Geen limiet',
      fieldSameFundamentalLimit: 'Keer zelfde fundamental aan dezelfde persoon',
      sameFundamentalInherit: 'Gebruikt de globale waarde',
      sameFundamentalNotApplicable: 'Niet van toepassing (geen limiet)',
      sameFundamentalNotApplicableShort: 'Geen limiet',
      recognitionsLimitOwnHint: 'Erkenningen die deze campagne per periode toestaat. Leeg = de globale Gestión-limiet geldt. Op elk moment aanpasbaar, ook als de campagne al actief is.',
      visibility: 'Zichtbaarheid',
      postSendTitle: 'Bewerken en Anti-Spoiler',
      visSender: 'Afzender tonen',
      visFundamental: 'Kernprincipe tonen',
      visText: 'Tekst tonen',
      visHabit: 'Gewoonte tonen',
      visSent: 'Teller van verzonden',
      visReceived: 'Teller van ontvangen',
      visAnonymous: 'Anoniem toestaan',
      visBulk: 'CSV-bulkupload',
      visReactions: 'Reacties (👏❤️😊🎉👍)',
      visCampaignTag: 'Campagnelabel tonen',
      visFromFundamentals: 'Verzenden vanuit Fundamentals toestaan',
      visSendingDisabled: 'Versturen van waarderingen uitschakelen',
      anonymousOverrideLabel: 'Anonieme erkenningen',
      anonymousOverrideInherit: 'Overnemen van Gestión',
      anonymousOverrideAllow: 'Toestaan',
      anonymousOverrideDeny: 'Niet toestaan',
      anonymousOverrideHint: 'Geldt ALLEEN voor deze campagne. Bij "Overnemen van Gestión" gebruikt deze campagne de algemene instelling.',
      points: 'Punten',
      pointsLocked: 'De punten zijn onveranderlijk: de campagne is al gestart.',
      pointsHint: 'Alleen Europa; de frontend toont de punten nooit.',
      applyPoints: 'De campagne kent punten toe',
      brillamosRecurringDesc: 'Terugkerende nominatiecampagne op basis van Fundamentals.',
      paisScheduleTitle: 'Tijden en Datums per Land',
      paisScheduleIntro: 'Configureer verschillende tijden of datums per land. Zonder waarde geldt het globale venster.',
      paisScheduleInfoIntro: "Toont de geldende datums en tijden van de actieve campagnes van elke OU, zodat duidelijk is wanneer erkenning tussen OU's mogelijk is. Alleen ter informatie.",
      paisStateOn: "Actief",
      paisStateOff: "Gestopt",
      paisStateNoCampaign: "Geen campagne",
      paisCol: 'Land',
      paisOpen: 'Openingstijd',
      paisClose: 'Sluitingstijd',
      paisActive: 'Actief',
      paisClearHours: 'Rooster wissen',
      paisOverrideBadge: 'OE-campagne',
      paisOverrideWins: 'Heeft voorrang op deze rij: {{alcance}}.',
      paisOverrideNoSend: 'Verzenden uitgeschakeld',
      paisOverrideDates: 'Data {{inicio}} → {{fin}}',
      paisOverrideHours: 'Tijden {{inicio}}–{{fin}}',
      paisScheduleNoActive: "Er is geen actieve Brillamos Juntos-campagne: zodra er een is, verschijnen hier de datums en tijden per land.",
      saveDraftFirst: 'Sla het concept op om de documenten te beheren.',
      saveDraft: 'Concept opslaan',
      saveDraftLater: 'Het concept wordt opgeslagen zodra de configuratie klaar is. Gebruik ‘Volgende’ om door de stappen te gaan.',
      dates: 'Datums',
      publishRequirements: 'Vereist een naam in alle 7 talen, minstens één OU in het bereik en een begin- en einddatum. Opslaan wordt actief zodra de configuratie compleet is.',
      valNameAllLangs: 'Voer de naam in alle 7 talen in.',
      valScope: 'Selecteer minstens één organisatie-eenheid in het bereik.',
      scopeConflict: "Deze eenheden zitten al in een actieve campagne: {{campanas}}. Haal ze uit het bereik of beëindig die campagne.",
      valScopeConflict: "Het bereik botst met een actieve campagne: {{campanas}}.",
      scopeConflictPartial: "Er zijn meer actieve campagnes dan konden worden gecontroleerd: de conflictcontrole kan onvolledig zijn.",
      scopeEmpty: "U hebt geen organisatie-eenheden binnen uw bereik om campagnes te maken. Vraag een globale beheerder om u een bereik toe te wijzen.",
      outOfScopeHint: "Deze campagne bevat organisatie-eenheden buiten uw bereik: alleen een beheerder die ze allemaal dekt, kan deze bewerken.",
      valScopeExcludesOwn: "Je kunt je eigen organisatie-eenheid niet uitsluiten van het bereik.",
      valStart: 'Voer de startdatum van de campagne in.',
      valEnd: 'Voer de einddatum van de campagne in.',
      valTimezone: 'Selecteer de tijdzone van de campagne.',
      valDateOrder: 'De einddatum moet later zijn dan de startdatum.',
      valPastDate: "De campagnedatums mogen niet vóór vandaag liggen.",
      designMenu: 'Pictogram en titel in het zijmenu',
      designMenuHint: 'Zo verschijnt de campagne in de zijbalk van het platform voor gebruikers.',
      designIcon: 'Pictogram',
      designMenuTitle: 'Menutitel',
      designMenuTitlePh: 'bijv. LATAM-innovatie',
      designSections: 'Landingssecties',
      designSectionsHint: 'De banner en het nominatieformulier zijn altijd aanwezig. Schakel de optionele secties in.',
      designShowStreak: 'Erkenningsreeks',
      designShowRecent: 'Recente erkenningen',
      designBrillamosLocked: 'De identiteit van Shine Together is onveranderlijk: het ontwerp kan niet worden bewerkt.',
      approvalSent: 'Goedkeuringsverzoek verstuurd.',
      submitApproval: 'Ter goedkeuring versturen',
      submitApprovalConfirmTitle: 'Ter goedkeuring versturen',
      submitApprovalConfirmMsg: 'Deze campagne ter goedkeuring versturen? De Admin General moet ze beoordelen voordat ze actief wordt.',
      prev: 'Vorige',
      next: 'Volgende',
      docLang: 'Taal',
      docUrl: 'URL van het document',
      docTitle: 'Titel',
      addDoc: 'Document toevoegen',
      docCategoryRequired: 'Kies een categorie voordat je het document toevoegt.',
      docTitleRequired: 'Vul de titel in alle 7 talen in voordat je het document toevoegt.',
      docsEmpty: 'Er zijn geen documenten.',
      docsFallbackNote: 'Als hier geen documenten worden geüpload, toont deze campagne de documenten uit de sectie Documentatie van het beheer.',
      approvalsTitle: 'Openstaande goedkeuringen',
      approvalsSub: 'Campagnes die op jouw goedkeuring wachten (AdminGlobal).',
      approvalsEmpty: 'Er zijn geen openstaande goedkeuringen.',
      colCampaign: 'Campagne',
      requestedBy: 'Aangevraagd door',
      approve: 'Goedkeuren',
      approveConfirmTitle: 'Campagne goedkeuren',
      approveConfirmMsg: 'Deze campagne goedkeuren? Ze wordt actief en zichtbaar voor haar bereik.',
      reject: 'Afwijzen',
      rejectReason: 'Reden voor afwijzing (verplicht)',
      rejectConfirm: 'Afwijzing bevestigen',
      viewDetail: 'Details bekijken',
      bannerDesign: 'Bannerontwerp',
      bannerScopeLabel: 'Deze banner geldt alleen voor deze campagne; zonder configuratie wordt de algemene banner van het programma gebruikt.',
      bannerDesignHint: 'Wissel hierboven van taal om de titel, ondertitel en het logo van die taal te bewerken — het voorbeeld werkt live bij.',
      bannerTitle1: 'Titel (regel 1)',
      bannerTitle2: 'Titel (regel 2)',
      bannerSubtitle: 'Ondertitel',
      bannerLogoNote: 'Het uploaden van de logo-afbeelding (PNG per taal) komt binnenkort.',
      bannerLogo: 'Logo (afbeelding voor deze taal)',
      bannerLogoUpload: 'PNG uploaden',
      bannerLogoReset: 'Standaard herstellen',
      bannerLogoHint: 'Aanbevolen: transparante PNG ~4:3. Standaard wordt het Fundamentals-logo getoond.',
      bannerLogoErrPng: 'Het logo moet een PNG zijn.',
      bannerLogoErrSize: 'De PNG mag niet groter zijn dan 500 KB.',
      bannerPreview: 'Voorbeeld',
      bannerPreviewEmpty: 'Bannertitel',
      bannerCta: 'Erken iemand',
      brillamosBannerTitle: 'Shine Together-banner',
      brillamosBannerHint: 'Pas de ondertitel en het logo van de Shine Together-hero per taal aan. De voorbeeldweergave werkt live bij.',
      brillamosBannerLogoHint: 'Aanbevolen: transparante PNG. Standaard wordt het Shine-logo getoond.',
      entryPoints: 'Erkenningsmodus (entry points)',
      entry: { A: 'Entry A — Klassiek formulier', B: 'Entry B — Interactieve post-it', both: 'Beide zichtbaar (A/B-test)' },
      commentRequired: 'Opmerking verplicht',
      vista: 'Weergave:',
      vistaGlobal: 'Globale Admin',
      vistaOu: 'OU-Admin / Ambassadeur',
      rulesTitle: 'Verzendregels',
      brillamosRulesIntro: 'Deze regels gelden alleen voor Shine Together. Een leeg veld erft de globale waarde uit Beheer.',
      ruleMultiPersona: 'Multi-persoon',
      ruleMultiFundamental: 'Multi-fundamenteel',
      ruleBulkCsv: 'CSV-bulkupload',
      ruleReactions: 'Reacties op de muur',
      ruleSendingDisabled: 'Verzenden uitschakelen',
      ruleAnonymousEnabled: 'Anonieme erkenningen toestaan',
      anonymousGestionHint: 'Geldt voor alles (Fundamentals, Brillamos en aangepaste campagnes), tenzij een campagne in de Configuratiestap van de wizard een eigen instelling opgeeft. Heeft geen invloed op de automatische AVG-anonimisering in Europa.',
      ruleMinChars: 'Min. tekens',
      moderationTitle: 'Moderatie',
      modPostEdit: 'Bewerken na verzenden',
      modPostEditDescription: 'Bewerken na verzenden: de afzender kan zijn waarderingen bewerken of verwijderen zolang de campagne open is.',
      moderationNote: 'De Rapporteren-knop en het woordfilter worden beheerd in de sectie Moderatie.',
      postEditPerCampaignNote: '‘Bewerken na verzenden’ stel je per campagne in (stap 5 van de wizard) en, voor Kernprincipes, op hun tabblad. Er geldt geen termijn meer.',
      modAntiSpoiler: 'Anti-Spoilermodus',
      modAntiSpoilerDescription: 'Anti-Spoiler-modus: verbergt ontvangen waarderingen tot de campagne afloopt. Alleen de afzender ziet ze.',
      antiSpoilerPerCampaignNote: '‘Anti-Spoilermodus’ stel je per campagne in (stap 5 van de wizard) en beschermt niet meer zodra de campagne wordt afgesloten. Voor Kernprincipes op hun tabblad; daar zet je hem handmatig uit.',
      multiEnvioPerCampaignNote: '‘Multi-persoon’, ‘Multi-fundamenteel’ en ‘Fundamentals per erk.’ stel je per campagne in (stap 5 van de wizard).',
      multiEnvioEuropaAviso: 'Deze campagne bevat OU\'s in Europa (AVG): meerdere personen of meerdere Fundamentals toestaan valt onder de verantwoordelijkheid van wie de campagne configureert.',
      multiEnvioNoLimitHint: 'Staat ‘Fundamentals per erk.’ uit, dan is er geen limiet op Fundamentals.',
      entryPointsPerCampaignNote: 'De erkenningsmodus stel je per campagne in (stap 5 van de wizard).',
      resetToGlobal: 'Herstellen (overnemen van globaal)',
      streakTitle: 'Reeks-instellingen (Fundamenten)',
      streakActive: 'Reeks actief',
      streakSentNote: 'De reeks wordt berekend op basis van VERZONDEN erkenningen.',
      streakInProfile: 'Toon reeks in profiel',
      badgesActive: 'Badges actief',
      streakPeriod: 'Periode',
      periodWeekly: 'Wekelijks',
      periodMonthly: 'Maandelijks',
      periodDaily: 'Dagelijks',
      limitsTitle: 'Limieten (Limietbeheer)',
      limitsActive: 'Limieten actief',
      limitName: 'Naam',
      limitDescription: 'Beschrijving',
      limitRecognitionsDesc: 'Maximum erkenningen',
      limitFundamentalsDesc: 'Max selecteerbaar per inzending',
      limitValue: 'Limiet',
      limitFrequency: 'Frequentie',
      limitActiveCol: 'Actief',
      limitRecognitions: 'Erkenningen per periode',
      limitFundamentals: 'Fundamentals per erk.',
      perSubmission: 'Per inzending',
      readonlyTitle: 'Algemene configuratie — Fundamentals (standaard toegepast)',
      readonlyBadge: 'Alleen-lezen',
      readonlyNote: 'Als je een uitzondering per OU wilt toevoegen, gaat deze door goedkeuring van de Globale Admin.',
      colDate: 'Datum',
      exc: {
        title: 'Uitzonderingen per OU',
        intro: 'Puntuele uitzonderingen op de basisconfiguratie voor een specifiek OU/BU/Site-bereik. Elke uitzondering gaat via goedkeuring van de Global Admin.',
        new: 'Nieuwe uitzondering per OU',
        colException: 'Uitzondering',
        colScope: 'OU / BU / Site',
        colState: 'Status uitzondering',
        fullOu: 'Hele OU',
        sites: '{{count}} sites',
        scopePopTitle: 'Sites in bereik',
        stateActive: 'Actief',
        stateInactive: 'Inactief',
        toggleHint: 'Alleen een goedgekeurde uitzondering kan worden in- of uitgeschakeld.',
        edit: 'Bewerken',
        delete: 'Verwijderen',
        empty: 'Nog geen uitzonderingen per OU.',
        deleteTitle: 'Uitzondering verwijderen',
        deleteMsg: 'Deze uitzondering per OU wordt permanent verwijderd. Deze actie kan niet ongedaan worden gemaakt.',
        deleteConfirm: 'Verwijderen',
        summaryTope: 'Limiet: {{max}} recos / {{freq}}',
        summaryDisable: 'Verzenden uitschakelen',
        disableTitle: 'Verzenden uitschakelen (override)',
        disableNote: 'Blokkeert tijdelijk het versturen van erkenningen voor het geselecteerde bereik, zonder het programma uit te schakelen. Vereist goedkeuring van de globale beheerder.',
        summarySchedule: 'Beperkte tijden',
        summaryVisibility: 'Zichtbaarheid',
        summaryBanner: 'Banner',
        approvalsTitle: 'Goedkeuringen',
        approvalsColSolicitante: 'Aanvrager',
        approvalsColAprobador: 'Goedkeurder',
        approvalsColFecha: 'Datum',
        approvalsColEstado: 'Status',
        approved: 'Goedgekeurd',
        pending: 'In behandeling',
        rejected: 'Afgewezen',
        approvalsEmpty: 'Nog geen uitzonderingen om goed te keuren.',
        pendingBanner: 'Je hebt {{count}} uitzondering(en) die op je goedkeuring wachten.',
        approve: 'Goedkeuren',
        reject: 'Afwijzen',
        rejectReason: 'Reden voor afwijzing (verplicht)',
        rejectConfirm: 'Afwijzing bevestigen',
        back: 'Uitzonderingen per OU',
        wizardTitle: 'Uitzondering per OU — Fundamentals',
        wizardTitleBrillamos: 'OU-uitzondering — Samen Schitteren',
        stepScope: 'Bereik',
        stepSchedule: 'Schema',
        stepBanner: 'Banner',
        // Bug UAT #114 — la «campaña por OU» sobreescribe una campaña activa; sin una debajo no hace nada.
        baseCampaignTitle: 'Basiscampagne',
        baseCampaignHint: 'Een OU-uitzondering werkt niet op zichzelf: die OVERSCHRIJFT delen van een actieve campagne voor jouw bereik. Als geen actieve campagne die OUs dekt, heeft deze uitzondering geen enkel effect. Heb je een volledige eigen campagne voor de OU nodig, maak die dan aan bij Campagnes, niet hier.',
        baseCampaignLabel: 'Campagne die wordt overschreven',
        baseCampaignNone: 'Niet opgegeven (geldt voor de actieve campagne die het bereik dekt)',
        baseCampaignNinguna: 'Er is geen actieve campagne van Samen Schitteren. Maak en activeer er eerst een, anders geldt deze uitzondering voor niemand.',
        baseCampaignRequerida: 'Kies de basiscampagne om te kunnen opslaan: zonder die geldt de uitzondering voor niemand.',
        baseCampaignVentana: 'De basiscampagne loopt van {{inicio}} tot {{fin}}. Deze data horen bij de campagne en worden hier niet gewijzigd.',
        baseCampaignSinVentana: 'De basiscampagne heeft geen looptijd ingesteld.',
        scheduleWindow: 'Lokale datum en tijd van de uitzondering',
        scheduleStart: 'Start uitzondering',
        scheduleEnd: 'Einde uitzondering',
        scheduleTz: 'Tijdzone',
        scheduleRestrictTitle: 'Erkenningen uitschakelen',
        scheduleRestrictNote: 'Indien actief kunnen er geen erkenningen worden verstuurd buiten de voor dit bereik ingestelde datum en tijd. Vereist goedkeuring van de globale beheerder.',
        scheduleWindowNota: 'Als je een venster instelt, worden verzendingen binnen dit bereik daartoe beperkt. Laat het leeg om niets te beperken.',
        scheduleInvalid: 'Het tijdvenster vereist een begin- en einddatum/-tijd, en het einde moet na het begin liggen.',
        bannerTitle: 'Shine Together-banner (override)',
        bannerIntro: 'Overschrijft de ondertitel en het logo van de Shine Together-banner alleen voor het bereik van deze uitzondering. Als je hier geen enkele taal bewerkt, blijft de globale banner ongewijzigd.',
        bannerScopeLabel: 'Deze banner geldt alleen voor het bereik van deze uitzondering, niet voor de globale Shine Together-banner.',
        stepDocs: 'Documenten',
        stepVisibility: 'Zichtbaarheid',
        scopeIntro: 'Bepaal het organisatorische bereik.',
        docsIntro: 'Voeg documenten toe die specifiek zijn voor deze uitzondering per OU.',
        entryPoints: 'Entry Points',
        entryPointMode: 'Ingeschakelde verzendwegen (override)',
        entryPointModeApp: 'Alleen formulier',
        entryPointModePostit: 'Alleen interactieve post-it',
        entryPointModeAmbos: 'Beide',
        reglasEnCampanaNote: 'In Brillamos stel je ‘Erkenningsmodus’, ‘Multi-persoon’ en ‘Multi-fundamenteel’ per campagne in (stap 5 van de wizard); die gaan voor op deze uitzondering.',
        visTitle: 'Zichtbaarheid van de erkenning (override)',
        visIntro: 'Stel in welke informatie aan de gebruiker wordt getoond bij het ontvangen of bekijken van een erkenning.',
        visText: 'Tekst/opmerking van de erkenning tonen',
        visFundamental: 'Toegewezen fundamental tonen',
        visSender: 'Naam van de afzender tonen',
        visHabit: 'Geselecteerde Daily Habit tonen',
        visRanking: 'Ranglijst van andere OUs tonen',
        visMultiFund: 'Meerdere Fundamentals per erkenning toestaan',
        maxFundamentales: 'Max. Fundamentals per erkenning',
        rulesTitle: 'Verzendregels (override)',
        ruleMultiPersona: 'Meerdere personen',
        ruleComment: 'Opmerking verplicht',
        ruleMinChars: 'Min. tekens',
        ruleCsv: 'CSV-upload',
        modTitle: 'Moderatie (override)',
        modReport: 'Knop Rapporteren',
        modEditDelete: 'Knoppen Bewerken en Verwijderen (alleen verzonden)',
        streakTitle: 'Reeks (override)',
        streakMin: 'Min. verzendingen/week',
        streakPeriod: 'Periode',
        limitsTitle: 'Limieten (override)',
        limitMax: 'Max. recos',
        limitFreq: 'Frequentie',
        approvalRequiredTitle: 'Goedkeuring vereist',
        approvalRequiredMsg: 'Alle wijzigingen moeten door de Global Admin worden goedgekeurd voordat ze van kracht worden.',
      },
      // C2/P17 — Frecuencia declarativa; el vocabulario sale del Excel del cliente.
      fieldFrecuencia: 'Frequentie',
      frecuenciaPlaceholder: 'Bijv. Maandelijks, Elke 3 vergaderingen…',
      frecuencia: {
        mensual: 'Maandelijks',
        trimestral: 'Per kwartaal',
        cadaNReuniones: 'Elke 3 vergaderingen',
        porEvento: 'Per gebeurtenis',
      },
      // C2/P18-bis — deshacer un panico accidental (24 h, misma OU libre).
      undoPanic: 'Campagne heractiveren',
      // Ticket 04 — borrar borradores y pendientes de aprobación (Brillamos).
      deleteBtn: 'Verwijderen',
      deleteConfirmTitle: 'Campagne verwijderen?',
      deleteConfirm: '‘{{name}}’ wordt verwijderd. Dit kan niet ongedaan worden gemaakt.',
      deleteConfirmPending: '‘{{name}}’ wordt verwijderd en de goedkeuringsaanvraag ingetrokken. Dit kan niet ongedaan worden gemaakt.',
      deleteDone: 'Campagne verwijderd.',
      approvalCampaignGone: 'Deze campagne bestaat niet meer.',
      undoPanicConfirm: 'Deze campagne wordt heractiveerd en weer zichtbaar in haar bereik. Alleen binnen 24 uur mogelijk. Doorgaan?',
      // C2/P19 — meta de participantes; la ayuda repite la DEFINICIÓN a propósito.
      fieldMetaParticipantes: "Deelnemersdoel",
      metaParticipantesInherit: "Geen doel",
      metaParticipantesHelp: "Verschillende personen die deelnemen, door te erkennen of erkend te worden. Leeg = geen doel.",
      tooltip: {
        entryPoints: 'Hoe medewerkers iemand kunnen waarderen: klassiek formulier, interactieve post-it, of beide tegelijk.',
        ruleMultiPersona: 'Hiermee kun je meer dan één persoon als ontvanger opnemen in dezelfde waardering.',
        ruleMultiFundamental: 'Hiermee kun je meer dan één Fundamental markeren in dezelfde waardering.',
        commentRequired: 'Vereist een opmerking om de waardering te kunnen versturen.',
        ruleBulkCsv: 'Schakelt de bulkupload van waarderingen via een CSV-bestand in.',
        ruleReactions: 'Hiermee kunnen andere mensen met emoji\'s reageren op een waardering.',
        ruleSendingDisabled: 'Schakelt het versturen van waarderingen voor dit bereik volledig uit, zonder gevolgen voor reeds verzonden waarderingen.',
        ruleAnonymousEnabled: 'Hiermee kun je een waardering versturen zonder de naam van de afzender te tonen.',
        modPostEdit: 'Laat de afzender een verzonden waardering bewerken of verwijderen. In een campagne alleen zolang die open is; beheerders kunnen het altijd. Handig om een fout in de tekst te herstellen zonder hulp te vragen.',
        modAntiSpoiler: 'Zolang de campagne open is, ziet alleen de afzender de waarderingen die de deelnemers ontvangen: niet de ontvanger en ook niet diens collega’s, uit welke campagne ze ook komen. Hij eindigt wanneer de campagne wordt afgesloten. Gebruik het als de campagne de meest gewaardeerde mensen beloont: zo weet niemand vóór de prijsuitreiking hoeveel hij er heeft.',
        antiSpoiler: 'Zolang hij aanstaat, ziet alleen de afzender waarderingen zonder campagne. Hij stopt niet vanzelf: je moet hem handmatig uitzetten.',
        streakActive: 'Activeert de wekelijkse reeksteller van waarderingen voor deze campagne.',
        dailyHabitsMandatory: 'Vereist het markeren van een dagelijkse gewoonte zodat de waardering meetelt voor de reeks.',
        streakInProfile: 'Toont de huidige reeks op het openbare profiel van de gebruiker.',
        badgesActive: 'Activeert het toekennen van badges bij het behalen van reeksdoelen.',
        limitsActive: 'Activeert de hieronder ingestelde verzendlimieten, per waardering en per Fundamental.',
        recognitionsLimitActive: 'Past de limiet voor waarderingen per periode toe op dit bereik.',
        recognitionsLimitDisabled: 'Vink "Niet van toepassing" aan zodat deze campagne GEEN totale verzendlimiet heeft: een persoon kan in de periode zoveel waarderingen sturen als gewenst, ongeacht de globale limiet in Beheer. Laat het uitgevinkt (en het veld leeg) om de globale limiet te gebruiken.',
        streakMinimum: 'Minimumaantal waarderingen dat een persoon in de periode moet VERSTUREN om die voor de reeks te laten meetellen (1-20). Overschrijft het globale minimum uit Beheer alleen voor deze campagne; leeg = het globale geldt. Kan niet worden gewijzigd zodra de campagne is gestart.',
        recognitionsLimitOwn: 'Maximaal TOTAAL aantal waarderingen dat een persoon in de periode kan versturen (aan wie dan ook, welk fundamental dan ook). Overschrijft de globale limiet uit Beheer alleen voor deze campagne; leeg = het globale geldt. Op elk moment aanpasbaar, ook nadat de campagne is gestart.',
        sameFundamentalLimit: 'Hoe vaak een persoon een ander op HETZELFDE fundamental in de periode kan waarderen (aan dezelfde persoon). Overschrijft de globale waarde uit Beheer alleen voor deze campagne; leeg = het globale geldt. In Europa blijft het wettelijke minimum (AVG) behouden.',
        sameFundamentalLimitDisabled: 'Vink "Niet van toepassing" aan om hetzelfde fundamental aan dezelfde persoon ZONDER limiet te herhalen, ongeacht het globale. Laat het uitgevinkt (en het veld leeg) om het globale te gebruiken. In Europa blijft de wettelijke limiet behouden, ook indien aangevinkt.',
        fundamentalsLimitActive: 'Past de limiet voor Fundamentals per verzending toe op dit bereik.',
        designShowStreak: 'Toont het reeksblok op de landingspagina van deze campagne.',
        designShowRecent: 'Toont recente waarderingen op de landingspagina van deze campagne.',
        visSender: 'Toont de naam van wie de waardering verstuurt.',
        visFundamental: 'Toont het Fundamental dat aan de waardering is toegewezen.',
        visText: 'Toont de tekst of opmerking van de waardering.',
        visHabit: 'Toont het geselecteerde Daily Habit, indien van toepassing.',
        visSent: 'Toont het tabblad met verzonden waarderingen.',
        visReceived: 'Toont het tabblad met ontvangen waarderingen.',
        visBulk: 'Schakelt de CSV-bulkupload alleen voor deze campagne in.',
        visReactions: 'Schakelt emoji-reacties alleen voor deze campagne in.',
        visCampaignTag: 'Toont het label met de campagnenaam op elke post-it.',
        visFromFundamentals: 'Hiermee kun je deze waardering starten vanaf het Fundamentals-scherm.',
        visSendingDisabled: 'Schakelt het versturen van waarderingen alleen voor deze campagne uit.',
        applyPoints: 'Waarderingen in deze campagne leveren inwisselbare punten op. Kan niet meer worden uitgeschakeld zodra de campagne is gestart.',
        visRanking: 'Toont de ranglijst in vergelijking met andere OU\'s.',
        visMultiFund: 'Hiermee kun je meer dan één Fundamental markeren, als uitzondering voor deze OU.',
        modReport: 'Hiermee kun je een ongepaste waardering melden.',
        modEditDelete: 'Schakelt het bewerken en verwijderen van een reeds verzonden waardering in, alleen voor deze OU. De backend behandelt beide rechten als één schakelaar.',
        scheduleEnabled: 'Beperkt het versturen van waarderingen tot het hierboven ingestelde tijdvenster.',
        disableSend: 'Blokkeert het versturen van waarderingen voor dit specifieke bereik.',
        paisActive: 'Indien uitgeschakeld, is de campagne niet langer actief voor dit land, ook al zijn de ingestelde datum en het tijdvenster nog geldig.',
        paisApplySchedule: 'Staat dit uit, dan blijven de datum en tijd van deze rij opgeslagen maar worden ze NIET toegepast: het land heeft geen tijdsbeperking. Handig om een venster klaar te zetten en later aan te zetten zonder opnieuw te typen.',
        gestStreakEnabled: "Globale waarde: schakelt het tellen van de erkenningsreeks in. Elk programma of elke campagne kan een eigen waarde instellen.",
        gestWrappedByOu: "Hoofdschakelaar voor het jaaroverzicht (Wrapped). Uit: niemand ziet het; aan: elke OU ziet het binnen het zichtbaarheidsvenster van haar configuratie in Overzicht.",
        gestAllowPromote: "Maakt het mogelijk een erkenning uit Fundamentals ook naar Brillamos te sturen: toont het selectievakje bij Erkennen en de ⭐ op de muur en in het profiel.",
        gestStreakPerPersonCap: "Beperkt hoeveel 1:1-erkenningen aan dezelfde persoon meetellen voor de reeks (misbruikpreventie). Groepserkenningen tellen altijd mee. Het maximum stel je hieronder in.",
        gestAvatarEnabled: "Laat mensen die via de webapp binnenkomen een gekleurde avatar aanpassen. Wie via Teams binnenkomt, behoudt de profielfoto.",
        gestAvatarSelector: "Toont de avatarkiezer direct na de registratie. Vereist dat de aanpasbare avatar aan staat.",
        gestPanic: "Globale kill switch: stopt direct het versturen van erkenningen in alle actieve campagnes (Brillamos Juntos en Fundamentals), zonder de al verzonden erkenningen te raken. Kan alleen worden ingeschakeld als er minstens één actieve Brillamos-campagne is.",
      },
      tooltipAria: 'Help',
    },
    reports: { desc: 'Rapportage en analytics van het programma.' },
    translate: {
      button: 'Vertalen naar de andere talen',
      buttonFrom: 'Vertalen vanuit {{lang}} naar de andere talen',
      loading: 'Vertalen…',
      hint: 'Vul minstens één taal in om te vertalen.',
      error: 'Automatisch vertalen is mislukt.',
      sessionExpired: 'Je sessie is verlopen. Herlaad de pagina en meld je opnieuw aan.',
    },
    misSolicitudes: {
      title: "Mijn campagneaanvragen",
      desc: "De status van wat je hebt voorgesteld. Je kunt een aanvraag intrekken zolang die in behandeling is, en opnieuw indienen als die is afgewezen.",
      empty: "Je hebt nog geen aanvragen verstuurd.",
      colCampana: "Campagne",
      colFecha: "Aanvraagdatum",
      colEstado: "Status",
      colComentario: "Opmerking",
      colAcciones: "Acties",
      editar: "Bewerken",
      retirar: "Aanvraag intrekken",
      reenviar: "Opnieuw indienen",
      estado: {
        pendiente: "In behandeling",
        aprobada: "Goedgekeurd",
        rechazada: "Afgewezen",
      },
    },
    management: {
      desc: 'Verzendregels, limieten en reeks.',
      title: 'Beheer',
      descLong: 'Globale instellingen: beschrijving van de reeks ×7, badges, globale schakelaars en freeze. Atomair opslaan.',
      fixValidation: 'Corrigeer de validaties voordat je opslaat.',
      streakDescription: 'Beschrijving van de reeks',
      fundamentalsTitle: 'Beschikbare Fundamentals',
      fundamentalsDesc: 'Welke Fundamentals worden aangeboden bij het waarderen. Eén verwijderen wist hem niet uit de catalogus: hij verschijnt alleen niet meer in dit programma.',
      fundamentalsLastOne: 'Dit is de laatste beschikbare: als u hem verwijdert, kan niemand nog een waardering versturen.',
      avatarTitle: 'Avatarinstellingen (Frontline)',
      avatarDesc: 'Frontline-gebruikers die via de webapp inloggen kunnen een kleuravatar aanpassen. Wie via Teams binnenkomt houdt zijn profielfoto.',
      avatarEnabled: 'Aanpasbare avatar actief',
      avatarSelector: 'Kiezer tonen na registratie',
      avatarColors: 'Beschikbare avatars:',
      placeholderTitle: 'Instelbare omschrijving van het tekstveld',
      placeholderDesc: 'De hulptekst van het berichtveld bij het waarderen. Elke taal die u leeg laat gebruikt de standaardtekst.',
      placeholderLabel: 'Hulptekst van het bericht',
      panicTitle: 'Noodknop — Brillamos Juntos',
      panicDesc: 'Schakelt het versturen van waarderingen in alle actieve campagnes onmiddellijk uit. Geldt zowel voor Shine Together als voor Waarderen (Fundamentals). Alleen Algemeen Beheerder.',
      panicToggle: 'Globale Kill Switch Brillamos',
      panicActiveHint: 'Versturen staat UIT: niemand kan op dit moment waarderingen versturen.',
      panicSameSwitchHint: 'Dit is een globale schakelaar: zolang deze aan staat, kan geen enkele instelling per programma of per campagne het versturen weer aanzetten.',
      panicNoActiveCampaign: 'Deze schakelaar wordt beschikbaar zodra er ten minste één Shine Together-campagne actief is (RN-C08). Er is er nu geen, dus er zijn geen campagne-inzendingen om te stoppen.',
      needAllLangs: 'Vul alle 7 talen in.',
      globalToggles: 'Globale schakelaars',
      streakEnabled: 'Reeks actief',
      multinomination: 'Multinominatie',
      dailyHabitsMandatory: 'Dagelijkse gewoonten verplicht',
      antiSpoiler: 'Anti-spoiler',
      antiSpoilerTitle: 'Anti-spoilermodus (prijsuitreiking)',
      antiSpoilerDesc: 'Verbergt tijdens de jaarlijkse prijsuitreiking tijdelijk profielen en waarderingen van anderen, zodat de winnaars niet worden verklapt.',
      antiSpoilerActivo: 'Anti-spoiler actief',
      antiSpoilerFrom: 'Van',
      antiSpoilerTo: 'Tot',
      antiSpoilerHint: 'Zolang de modus actief is, kunnen medewerkers geen profielen van collega’s of details van waarderingen van anderen zien.',
      antiSpoilerSinVentana: 'Zonder datums beschermt de modus zolang de schakelaar aanstaat.',
      antiSpoilerVentanaInvertida: '‘Van’ ligt na ‘Tot’: zo beschermt het venster nooit. Corrigeer dit om te kunnen opslaan.',
      wrappedByOu: 'Wrapped per OU',
      reactionsEnabled: 'Reacties (👏❤️😊🎉👍)',
      allowPromoteToBrillamos: 'Verzenden naar Brillamos toestaan',
      allowPostEdit: 'Bewerken na verzenden',
      postEditTitle: 'Verzonden waarderingen bewerken',
      postEditDesc: 'Laat de afzender het bericht van een al verzonden waardering bewerken. Standaard uit.',
      postEditWindow: 'Bewerkvenster',
      postEditWindowOpt: { '24h': '24 uur', '48h': '48 uur', '7d': '7 dagen', unlimited: 'Geen limiet' },
      streakPerPersonCapEnabled: 'Limiet per persoon (reeks)',
      streakPerPersonCap: 'Max. per persoon (reeks)',
      weeklyMinimum: 'Minimum per periode',
      periodicity: 'Periodiciteit',
      period: { weekly: 'Wekelijks', monthly: 'Maandelijks' },
      periodicityHint: 'Het minimum geldt voor de gekozen periode: bij Maandelijks loopt de reeks op of breekt per kalendermaand, niet per week.',
      periodicityMonthlyWarning: 'Bij Maandelijks telt de reeks opeenvolgende MAANDEN en de app laat dat al zo zien (widget, Profiel, Wrapped en drempels). Er resten TWEE Product-beslissingen voordat je dit in productie aanzet: RF-038 definieert de badgedrempels in weken (1/4/8/12/20), dus die van 4 haal je pas na 4 maanden; en de antimisbruiklimiet van 2 erkenningen per persoon geldt niet meer per week maar per maand, waardoor een hoog minimum in kleine teams onhaalbaar kan worden.',
      freezeFrom: 'Freeze vanaf',
      freezeTo: 'Freeze tot',
      badges: 'Badges',
      noBadges: 'Er zijn geen badges geconfigureerd.',
      badge: 'Badge',
      weeksRequired: '{{count}} weken',
      weeksRequiredOne: '{{count}} week',
      weeksRequiredMany: '{{count}} weken',
      badgeName: 'Naam van de badge',
      badgeIcon: 'Pictogram',
      badgeColor: 'Kleur',
      weeks: 'Vereiste weken',
      notApplicable: 'Niet van toepassing',
      iconFormatInvalid: 'Ongeldig afbeeldingsformaat. Gebruik PNG, JPG, WEBP of SVG.',
      addBadge: '+ Badge toevoegen',
      editBadge: 'Bewerken',
      deleteBadge: 'Verwijderen',
      deleteBadgeConfirm: 'Badge ‘{{name}}’ verwijderen? De naam in alle 7 talen, het pictogram en de drempel gaan verloren. Het verwijderen gaat in bij het opslaan.',
      badgeActive: 'Actief',
      badgeInactive: 'Inactief',
      imageUploadHintNew: 'Sla de badge eerst op om het pictogram te kunnen uploaden.',
      previewTitle: 'Voorbeeld',
      saveBadgeChanges: 'Wijzigingen opslaan',
    },
    // FASE 7 (demo-pariteit, H-93/H-94/H-95) — Admin › Meldingen (REQ-135).
    notifications: {
      title: 'Meldingsinstellingen',
      desc: 'Stel in welke e-mailmeldingen worden verzonden en op welk organisatieniveau. Waarden die op dit niveau niet zijn gedefinieerd, worden overgeërfd van het volgende.',
      precedenceTitle: 'Hoe de configuratie wordt bepaald',
      precedence1: 'Voorrang: Site > BU > OU > Global. De waarde van het meest specifieke niveau wint.',
      precedence2: 'Een schakelaar op «Overgeërfd» staat niet uit: hij neemt de waarde van het onderliggende niveau over. Alleen wat u hier definieert wordt opgeslagen.',
      precedence3: 'Elke persoon kan daarnaast eigen e-mails uitzetten via het profiel; die voorkeur zet nooit weer aan wat hier is uitgeschakeld.',
      scopeTitle: 'Configuratieniveau',
      scopeUnit: 'Eenheid',
      scopePick: 'Selecteer een eenheid…',
      scopeRequired: 'Selecteer een eenheid om de configuratie te bekijken en te bewerken.',
      scopeOuContext: 'OU van de eenheid',
      scopeOuFirst: 'Selecteer eerst een OU…',
      unsavedLock: 'Er zijn niet-opgeslagen wijzigingen; het niveau blijft vast tot u opslaat of verwerpt.',
      discard: 'Wijzigingen verwerpen',
      scope: { global: 'Global (hele tenant)', ou: 'OU', bu: 'Business Unit', site: 'Site' },
      group: { email: 'E-mail', categories: 'Soorten meldingen', summary: 'Periodieke samenvatting', blocked: 'Geblokkeerde e-mails' },
      blocked: {
        desc: 'Adressen die geen enkele e-mail van het programma ontvangen, wat hun persoonlijke instellingen ook zeggen.',
        scopeWarning: 'De blokkade geldt voor de HELE tenant, niet alleen voor dit niveau: een hier geblokkeerd adres is in alle OUs geblokkeerd. Ze gaat ook boven de hoofdschakelaar.',
        placeholder: 'naam@bedrijf.com',
        add: 'Blokkeren',
        remove: 'Blokkade van {{email}} opheffen',
        empty: 'Geen geblokkeerde e-mails.',
      },
      design: {
        title: 'E-mailontwerp',
        desc: 'Zo zien ze er nu uit: de Fundamentals gebruiken een warme stijl en Shine Together een donkere met sterren. Het ontwerp van elke e-mail stel je in de sjabloon zelf in, niet hier.',
        fund: { name: 'Fundamentals', style: 'Warme stijl · Crème/Oranje' },
        shine: { name: '✨ Shine Together', style: 'Donkere stijl · Sterren/Paars' },
      },
      broadcast: {
        title: 'Systeemmeldingen',
        desc: 'Voor onderhoud, storingen of eenmalige berichten. Wordt verstuurd met de al ontworpen sjabloon: schrijf alleen het bericht.',
        overridesHint: '🔴 Deze melding bereikt IEDEREEN, ook wie zijn meldingen heeft uitgezet. Het is geen programma-inhoud maar informatie over het hulpmiddel.',
        kindLabel: 'Soort melding',
        kind: { maintenance: 'Gepland onderhoud', suspension: 'Tijdelijke storing', restored: 'Dienst hersteld', general: 'Algemene melding' },
        subject: 'Onderwerp',
        subjectPlaceholder: 'Gepland onderhoud — zaterdag 2 uur',
        message: 'Bericht',
        messagePlaceholder: 'Bericht voor de gebruikers...',
        everyone: 'Iedereen',
        singleOu: 'Eén specifieke OU',
        chooseOu: 'Kies een OU',
        send: 'Melding nu versturen',
        error: 'De melding kon niet worden verstuurd.',
        sentSummary: 'Verstuurd naar {{sent}} van {{recipients}} personen.',
        skipped: '· {{count}} zonder herleidbare identiteit hebben hem niet gekregen.',
      },
      channel: { inapp: 'Bel', email: 'E-mail', teams: 'Teams' },
      tables: {
        shine: '✨ Meldingen — Shine Together',
        admin: '🛡️ Meldingen — Admin',
        colType: 'Type',
        colSubject: 'Onderwerp (ES)',
        colLanguages: 'Talen',
        editSubject: 'Onderwerp van ‘{{row}}’ in alle 7 talen bewerken',
        subjectByLanguage: 'Onderwerp per taal',
        close: 'Sluiten',
        saveSubject: 'Onderwerp opslaan',
        nineRows: 'Negen rijen en niet dertien: vier van de rijen in het ontwerp horen bij geen enkele melding die het systeem vandaag verstuurt.',
        rows: {
          'campaign-new': { name: 'Nieuwe campagne gestart', trigger: 'Een beheerder activeert een campagne' },
          'campaign-ending': { name: 'Campagne loopt af', trigger: 'Laatste dagen om te nomineren' },
          'recognition-sent': { name: 'Waardering naar Shine Together gestuurd', trigger: 'Bevestiging dat die meetelt voor de campagne' },
          'ranking-position': { name: 'Positie in de ranglijst', trigger: 'Je stijgt op de ranglijst' },
          'campaign-approval': { name: 'Campagneaanvraag per locatie', trigger: 'Een OU-beheerder maakt een aanvraag → Global admin' },
          'moderation-case-alert': { name: 'Moderatiemelding', trigger: 'Er staat een nieuwe melding open voor de OU-beheerder' },
          'moderation-educational': { name: 'Gemelde boodschap, bericht aan de afzender', trigger: 'Laat de afzender van de waardering weten dat die gemeld is' },
          'low-participation-alert': { name: 'Waarschuwing lage deelname', trigger: 'Een campagne zit onder de deelnamedrempel' },
          'pending-nomination-manager': { name: 'Openstaande nominatie (leidinggevende)', trigger: 'Een nominatie moet worden goedgekeurd' },
        },
      },
      master: {
        label: 'E-mailmeldingen',
        desc: 'Hoofdschakelaar: staat deze uit, dan wordt binnen dit bereik geen enkele programma-e-mail verzonden. Heeft geen invloed op Teams of de bel.',
      },
      cat: {
        recognitionReceivedEnabled: { label: 'Ontvangen erkenningen', desc: 'Melding aan de persoon wanneer iemand hen erkent.' },
        streakAndBadgesEnabled: { label: 'Reeksen en badges', desc: 'Herinneringen aan reeksen en vrijgespeelde badges.' },
        campaignsEnabled: { label: 'Campagnes', desc: 'Nieuwe campagne, aflopende campagne, winnaars en goedkeuringen.' },
        digestEnabled: { label: 'Wekelijkse samenvatting', desc: 'Digest met de opgebouwde activiteit van de week.' },
      },
      monthly: {
        label: 'Maandelijkse samenvatting',
        desc: 'Standaard uit. Zet dit alleen aan als deze eenheid ook een maandelijkse samenvatting wil.',
      },
      masterOffHint: 'De afzonderlijke soorten werken alleen met de hoofdschakelaar aan.',
      inherited: 'Overgeërfd',
      inApp: { label: 'In-app-meldingen (belletje)', desc: 'Het belletje in het portaal. Het hangt niet af van de e-mailschakelaar: het is een apart kanaal.' },
      teams: { label: 'Teams Activity Feed', desc: 'De melding in de Teams-activiteitenfeed, voor wie een bedrijfsaccount heeft.' },
      frequency: {
        label: 'Verzendfrequentie (e-mail)',
        desc: 'Hoe vaak meldingen worden gebundeld in een samenvatting. E-mails per gebeurtenis worden niet beïnvloed.',
        opt: {
          immediate: 'Direct (per gebeurtenis)',
          daily: 'Dagelijkse samenvatting',
          weekly: 'Wekelijkse samenvatting',
          biweekly: 'Tweewekelijkse samenvatting',
        },
        immediateHint: 'Met ‘Direct’ wordt er geen samenvatting verstuurd, ook al blijft de categorie aan: elke melding gaat apart.',
      },
      resetToInherited: 'Terug naar overgeërfd',
      active: 'actief',
      saved: 'Wijzigingen opgeslagen!',
      loadError: 'De configuratie van dit niveau kon niet worden geladen.',
      saveError: 'De configuratie kon niet worden opgeslagen. Probeer het opnieuw.',
    },
    views: {
      title: 'Gebruikersweergaven',
      desc: 'Weergaven die zichtbaar zijn voor de medewerker en microsites.',
      descLong: 'Welke weergaven elke OU aan haar mensen aanbiedt. Desktop + mobiel.',
      scope: 'Configuratieniveau',
      scopeGlobal: 'Globaal (alle OUs)',
      unsavedLock: 'Sla de wijzigingen op of verwerp ze voordat u van niveau wisselt.',
      cancelChanges: 'Wijzigingen annuleren',
      infoAria: 'Hulp over {{label}}',
      micrositesTitle: 'Microsite-URLs per Fundamental',
      micrositesDesc: 'Externe link met meer info over elk Fundamental. Laat leeg als er geen microsite is.',
      card: {
        medallero: { label: 'Medaillebord', desc: 'Verzonden + ontvangen' },
        perfilUsuario: { label: 'Gebruikersprofiel', desc: 'Ontvangen nieuw→oud' },
        enviarReconocimiento: {
          label: 'Waardering versturen', desc: 'Volgens instelling van de beheerder',
          tooltip: 'Toont de knop en het formulier om een collega te waarderen. Wordt gecombineerd met de algemene verzendschakelaar: staat die uit, dan verschijnt deze weergave niet, ook al staat hij hier aan.',
        },
        historicoPorAnio: {
          label: 'Historie per jaar', desc: 'Huidig jaar eerst',
          tooltip: 'Laat de geschiedenis van waarderingen zien, gegroepeerd per jaar, met het huidige jaar eerst. Hangt ook af van of de actieve campagne de historie heeft ingeschakeld.',
        },
        leaderboard: {
          label: 'Leaderboard', desc: 'Ranglijst',
          tooltip: 'Toont de ranglijst van wie de meeste waarderingen heeft verstuurd of ontvangen. Dit is de enige weergave die standaard uitstaat.',
        },
        feedActividad: { label: 'Activiteitenfeed', desc: 'Recente tijdlijn' },
        resumenMensual: {
          label: 'Maandoverzicht', desc: 'Wrap-up in Spotify-stijl',
          tooltip: 'Schakelt het overzicht in Spotify-stijl in met de cijfers van de periode per medewerker. Alleen zichtbaar als Wrapped is ingeschakeld voor de OU en de campagne al is afgesloten.',
        },
        busquedaCompaneros: {
          label: 'Collega’s zoeken', desc: 'Medaillebord van anderen bekijken',
          tooltip: 'Laat toe om andere collega’s te zoeken en hun medaillebord te bekijken. Wordt automatisch verborgen zolang de Anti-Spoiler-modus actief is, zodat verrassingen vóór een prijsuitreiking niet worden verklapt.',
        },
        vistaFundamentales: {
          label: 'Fundamentals-weergave', desc: 'Info over elk fundamental',
          tooltip: 'Toont de constellatie met informatie over elk cultuur-Fundamental binnen het Brillamos Juntos-scherm.',
        },
        banderaReportar: {
          label: 'Meldvlag', desc: 'Ongepaste waarderingen melden',
          tooltip: 'Voegt een knop toe waarmee medewerkers een ongepaste waardering kunnen melden. Hangt ook af van of de meldvlag is ingeschakeld bij Moderatie.',
        },
        recordatorioDiario: { label: 'Dagelijkse herinnering', desc: 'Dagelijks zetje om te waarderen' },
        verATuEquipo: {
          label: 'Je team bekijken', desc: 'Alleen leiders/managers',
          tooltip: 'Laat leidinggevenden en managers de waarderingen zien van de mensen die aan hen rapporteren. Geldt alleen voor wie als leidinggevende in het organogram staat en de rechten voor teamstatistieken heeft.',
        },
      },
      compose: {
        sending: 'Hangt ook af van de noodknop: met versturen uit verschijnt deze weergave niet, ook al staat hij hier aan.',
        campaign: 'Hangt ook af van de historie-schakelaar van de actieve campagne (RN-PR09).',
        wrapped: 'Hangt ook af van of de OU Wrapped aan heeft staan en of haar campagne is afgesloten.',
        antiSpoiler: 'Hangt ook af van de Anti-Spoilermodus: zolang dat venster actief is, blijft deze weergave verborgen.',
        report: 'Hangt ook af van de schakelaar ‘Meldknop’ in de sectie Moderatie.',
        manager: 'Hangt ook af van leidinggevende zijn in het organigram en de teammetrieken-rechten hebben.',
      },
    },
    docs: {
      desc: 'Bedrijfs- en juridische documenten.',
      legalTab: 'Juridische basis',
      privacyTab: 'Privacyverklaring',
      corpTab: 'Zakelijk',
      pillsTab: 'Gebruikers-pills',
      bibliotecaTab: 'Bibliotheek',
      legalesTab: 'Juridische docs',
      gestionTitle: 'Documentatiebeheer',
      gestionDesc: 'Configureer de snelkoppelingen voor gebruikers, beheer de bestandsbibliotheek en de verplichte juridische documenten.',
      pills: {
        nueva: 'Pill toevoegen',
        sectionTitle: 'Snelle toegang (Pills)',
        sectionSubtitle: 'Snelle-toegangscapsules die zichtbaar zijn in de gebruikersinterface. Stel de naam, het pictogram, de kleur en de inhoud in die ze bij een klik openen.',
        editar: 'Pill bewerken',
        titulo: 'Titel',
        tipo: 'Type',
        tipos: { documento: 'Document', url: 'Link', video: 'Video' },
        icono: 'Pictogram',
        color: 'Kleur',
        orden: 'Volgorde',
        documento: 'Bedrijfsdocument',
        elegirDocumento: 'Document kiezen…',
        sinDocumentos: 'Geen bedrijfsdocumenten beschikbaar. Upload ze op het tabblad Zakelijk.',
        url: 'Doel-URL',
        visibilidad: 'Zichtbaarheid per OE',
        visibilidadHint: 'Geen OE geselecteerd = zichtbaar voor alle eenheden.',
        activa: 'Actieve pill (zichtbaar in de rail)',
        activaSi: 'Actief',
        activaNo: 'Inactief',
        estado: 'Status',
        vistaPrevia: 'Voorbeeld',
        nombre: 'Naam',
        tipoContenido: 'Inhoudstype',
        documentoColumna: 'Gekoppeld document',
        documentoNoEncontrado: 'Document niet gevonden',
        documentoAlcanceIncompleto: "Dekt niet alle OU's van deze pill",
        sinTitulo: 'Zonder titel',
        todas: 'Alle',
        vacio: 'Nog geen snelkoppelingen geconfigureerd.',
        eliminar: 'Pill verwijderen',
        eliminarConfirm: 'Deze snelkoppeling uit de rail verwijderen?',
        errorCargar: 'Kan de snelkoppelingen niet laden.',
        errorGuardar: 'Kan de snelkoppeling niet opslaan.',
        errorEliminar: 'Kan de snelkoppeling niet verwijderen.',
      },
      corp: {
        firstLogin: 'Eerste login',
        versionEs: 'Versie ES',
        versionEn: 'Versie EN',
        subirVersion: 'Uploaden',
        reemplazar: 'Vervangen',
        verVersion: 'Versie bekijken',
        quitarVersion: 'Versie verwijderen',
        triggerUpdate: 'Update activeren',
        ousActivas: 'Actieve OU-eenheden',
        nombre: 'Documentnaam',
        tipo: 'Type',
        visibilidad: 'Zichtbaarheid per OE',
        idiomas: 'Talen',
        idiomasHint: 'Geen selectie = alle talen.',
        versionesPorIdioma: 'Versies per taal',
        versionesPorIdiomaCount: 'Versies ({{count}}/{{total}})',
        archivo: 'PDF-bestand',
        elegirArchivo: 'PDF kiezen…',
        subir: 'Document uploaden',
        agregarDocumento: 'Document toevoegen',
        subirArchivo: 'Bestand uploaden',
        libType: { todos: 'Alle', pdf: 'PDF', video: 'Video', imagen: 'Afbeelding' },
        filterType: 'Type',
        nombreArchivo: 'Bestandsnaam',
        idioma: 'Taal',
        pillAsignado: 'Toegewezen pill',
        subido: 'Geüpload',
        documento: 'Document',
        actualizado: 'Bijgewerkt',
        mediaKind: 'Bestandstype',
        externalUrl: 'Externe URL',
        externalUrlHint: 'Plak de video- of afbeeldingslink (Teams, SharePoint, enz.).',
        requiereUrl: 'Voer een geldige externe URL in.',
        abrir: 'Openen',
        dropMain: 'Sleep bestanden hierheen of klik om te uploaden',
        dropSub: 'PDF · Max. 25 MB per bestand',
        subidoOk: 'Document geüpload.',
        errorSubir: 'Het document kon niet worden geüpload.',
        lista: 'Geüploade documenten',
        listaCount: '{{count}} documenten geconfigureerd',
        legalInfo: 'Deze documenten worden getoond in het verplichte acceptatievenster. Eerste aanmelding activeert ze bij de eerste toegang. Update activeren toont ze opnieuw, ook als de gebruiker ze al heeft geaccepteerd. Expliciete acceptatie is vereist om door te gaan.',
        searchPlaceholder: 'Bestand zoeken…',
        filterLang: 'Filteren op taal',
        filterLangAll: 'Alle talen',
        noResults: 'Geen documenten komen overeen met het filter.',
        vacio: 'Er zijn nog geen zakelijke documenten.',
        fecha: 'Datum',
        acciones: 'Acties',
        descargar: 'Downloaden',
        editar: 'Bewerken',
        eliminar: 'Verwijderen',
        guardar: 'Wijzigingen opslaan',
        cancelar: 'Annuleren',
        eliminarConfirm: 'Dit document uit de repository verwijderen?',
        errorEliminar: 'Het document kon niet worden verwijderd.',
        errorActualizar: 'Het document kon niet worden bijgewerkt.',
        errorCargar: 'De lijst kon niet worden geladen.',
        soloPdf: 'Alleen PDF tot 25 MB is toegestaan.',
        requiereNombre: 'Voer een naam in.',
        requiereOu: 'Selecteer minstens één OE.',
        requiereArchivo: 'Kies een PDF-bestand.',
        tipos: {
          PoliticaPrivacidad: 'Privacybeleid',
          BasesLegales: 'Juridische voorwaarden',
          GuiaUsuario: 'Gebruikershandleiding',
          Premios: 'Prijzen',
          CookiesPolicy: 'Cookiebeleid',
          LegalNotice: 'Juridische kennisgeving',
        },
      },
      currentVersion: 'Huidige versie',
      noVersionYet: 'Er is nog geen versie gepubliceerd',
      newVersionLabel: 'Nieuwe versie om te publiceren',
      loadError: 'Het concept kon niet worden geladen.',
      titleLabel: 'Titel',
      sectionHeading: 'Kop',
      sectionBody: 'Inhoud',
      addSection: 'Sectie toevoegen',
      removeSection: 'Sectie verwijderen',
      saveDraft: 'Concept opslaan',
      publish: 'Publiceren',
      publishConfirm: 'Je staat op het punt een nieuwe versie te publiceren. Alle gebruikers moeten deze opnieuw accepteren voordat ze kunnen erkennen. Doorgaan?',
      missingLanguages: 'Ontbrekende talen: {{languages}}',
      draftSaved: 'Concept opgeslagen',
      published: 'Versie gepubliceerd',
      saveError: 'Het concept kon niet worden opgeslagen.',
      publishError: 'De versie kon niet worden gepubliceerd.',
    },
    recap: {
      title: 'Jaarlijkse Recap',
      desc: 'Configureer de Recap-ervaring per editie. De achtergronden en pictogrammen zijn per slide configureerbaar; de gebruikersgegevens (erkenningen, meest ontvangen Kernprincipe, fan nr. 1, reeks) worden automatisch door het platform ingevoegd.',
      deniedRole: 'Het beheer van de Recap is voorbehouden aan Admin Algemeen en Admin Kernprincipes.',
      fixValidation: 'Vul de verplichte teksten in voordat je opslaat.',
      noEditions: 'Er zijn nog geen Recap-edities.',
      createFirst: 'De eerste editie aanmaken',
      edition: 'Editie',
      editionName: 'Naam die zichtbaar is voor de gebruiker',
      newEdition: 'Nieuwe editie',
      newConfig: 'Nieuwe configuratie',
      newConfigName: 'Recap {{year}} · nieuwe configuratie',
      newEditionTitle: 'Nieuwe editie van het overzicht',
      newEditionYear: 'Jaar van de editie',
      newEditionYearRange: 'Kies een jaar tussen {{min}} en {{max}}.',
      newEditionFutureWarn: 'Een editie van {{year}} ziet niemand vóór dat jaar.',
      newEditionExisting: 'Er zijn al configuraties voor {{year}}: er wordt nog een gemaakt, inactief.',
      newEditionCreate: 'Editie maken',
      delete: 'Verwijderen',
      deleteAria: 'Configuratie {{name}} verwijderen',
      deleteTitle: 'Configuratie verwijderen',
      deleteConfirm: '“{{name}}” ({{year}}) wordt verwijderd: ze verdwijnt uit de geschiedenis en de keuzelijst. Doorgaan?',
      deleteBlockedActive: 'Alleen edities in Concept kunnen worden verwijderd. Zet „Recap actief” op Inactief en sla eerst op.',
      deleteError: 'De configuratie kon niet worden verwijderd.',
      vistasOff: 'Het Overzicht staat uit in Weergaven voor {{ous}}: zet het aan zodat het zichtbaar is.',
      gestionOff: 'Het Overzicht staat uit in Beheer (“Overzicht per OU”): zet het aan zodat het zichtbaar is.',
      gestionOffCreate: 'Zolang het Overzicht uit staat in Beheer (“Overzicht per OU”), kunnen er geen edities of configuraties worden aangemaakt.',
      configsHint: 'Elke configuratie heeft een eigen OE-bereik, status, periode en melding. Meerdere kunnen tegelijk actief zijn zolang ze geen OE’s delen; ligt een OE binnen een andere (MEXICO en een van de fabrieken), dan ziet elke medewerker de meest specifieke voor zijn of haar OE.',
      openConfig: 'Configuratie {{name}} openen',
      scope: 'OU-bereik',
      scopeGlobal: 'Globaal (alle)',
      active: 'Recap actief',
      activeOn: 'Actief',
      activeOff: 'Inactief',
      visibleFrom: 'Begin van zichtbaarheid',
      visibleTo: 'Einde van zichtbaarheid',
      notification: 'Melding',
      notifiedAt: 'Verstuurd {{date}}',
      neverNotified: 'Niet gemeld',
      difusionLockHint: 'Dit Recap is al aangekondigd. U kunt het bereik en het zichtbaarheidsvenster VERBREDEN, maar niet verkleinen: een OU verwijderen of de data inkorten zou mensen uitsluiten die al bericht kregen. De rest blijft bewerkbaar.',
      slidesTitle: 'Slide-configuratie ({{count}} slides)',
      slidesHint: 'De pictogrammen van Kernprincipes en de gebruikersgegevens worden automatisch ingevoegd. Hier configureer je alleen de visuele laag en de teksten.',
      i18nHint: 'Meertalig: de titel van elke slide wordt via de knop Bewerken in alle 7 talen vastgelegd.',
      slidesFor: 'Dia’s configureren voor',
      slidesForGlobal: 'Globaal (alle OU’s)',
      slidesForGlobalNote: 'Basisconfiguratie: wordt gebruikt door alle OU’s zonder eigen configuratie.',
      slidesForCustomNote: '{{ou}} heeft een eigen diaconfiguratie; die geldt ook voor sub-OU’s zonder eigen configuratie.',
      slidesForInheritedNote: '{{ou}} gebruikt de configuratie van {{from}}. Als je een dia aan- of uitzet, wordt een configuratie alleen voor {{ou}} gemaakt.',
      slidesForRemoveCustom: 'Eigen configuratie verwijderen',
      customizedOus: 'OU’s met een eigen configuratie:',
      customizedOuCount: '{{count}} dia’s',
      lastSlideOn: 'Er moet minstens één dia aan blijven.',
      colSlide: 'Slide',
      colPreview: 'Voorbeeld',
      colTitle: 'Titel',
      colActive: 'Actief',
      colActions: 'Acties',
      edit: 'Bewerken',
      titleMissing: 'Zonder titel',
      needAllLangs: 'Er ontbreken nog talen (alle 7 zijn vereist).',
      slides: {
        portada:    { name: 'Voorblad',                    hint: 'Welkomstscherm' },
        numeros:    { name: 'Jouw jaar in cijfers',        hint: 'Ontvangen + verzonden' },
        define:     { name: 'Wat jou kenmerkt',            hint: 'Meest ontvangen Kernprincipe (automatische waarde)' },
        mensaje:    { name: 'Het bericht',                 hint: 'Langste erkenning (automatische waarde)' },
        quienes:    { name: 'Wie jou waardeerde',          hint: 'Totalen en personen (automatische waarde)' },
        red:        { name: 'Jouw netwerk',                hint: 'Verschillende gebieden die jou waardeerden (automatische waarde)' },
        constancia: { name: 'Jouw consistentie',           hint: 'Reeks van weken (automatische waarde)' },
        reto:       { name: 'Jouw uitdaging voor volgend jaar', hint: 'Minst getoonde Kernprincipe en oproep tot actie' },
        ganador:    { name: 'Jaarwinnaar',                 hint: 'Als de gebruiker won: echte badge uit de sectie Winnaars' },
      },
      notifyTitle: 'Recap-melding',
      notifyDesc: 'Laat de medewerkers in het geselecteerde bereik weten dat hun Recap {{year}} klaarstaat.',
      preview: 'Voorbeeld',
      send: 'Melding versturen',
      notifyNeedsActive: 'Activeer de editie om er een melding over te kunnen sturen.',
      notifyError: 'De melding kon niet worden verstuurd.',
      previewNote: 'Zo wordt de editie doorlopen: alleen de actieve slides, met hun achtergronden en titels. De cijfers zijn van de gebruiker die hem opent.',
      genericTitle: 'Generiek bericht (terugval)',
      genericDesc: 'Wordt getoond wanneer de gebruiker geen erkenningen heeft in de periode of binnenkomt voordat de Recap zichtbaar is.',
      genericTitleLabel: 'Titel van het generieke bericht',
      genericDescLabel: 'Ondertitel / beschrijving',
      genericNote: 'Dit bericht is de terugval: wie gegevens heeft, ziet zijn gepersonaliseerde Recap.',
      imageUrlPlaceholder: 'URL van de afbeelding (PNG / JPG)',
      historyTitle: 'Historie van Recap en jaarwinnaars',
      historyDesc: 'Geregistreerde edities en de bijbehorende jaarwinnaars.',
      colEdition: 'Editie',
      colYear: 'Jaar',
      colScope: 'Bereik',
      colSlides: 'Slides',
      colWinners: 'Jaarwinnaars',
      colStatus: 'Status',
      winnersCount: '{{count}} winnaars',
      status: { activa: 'Actief', completada: 'Beëindigd', borrador: 'Concept', programada: 'Gepland' },
      editorTitle: 'Slide {{index}} bewerken',
      editorDescData: 'Configureer de titel (7 talen), de achtergrond en de tekst bij de dynamische waarde. Het voorbeeld werkt bij tijdens het typen.',
      editorDescIcon: 'Configureer de titel (7 talen), de achtergrond en het pictogram van de slide. Het voorbeeld werkt bij tijdens het typen.',
      titleLangs: 'Titel (7 talen)',
      titlePlaceholder: 'Titel in {{lang}}',
      autoIcon: 'Het pictogram van deze slide is automatisch: het gebruikt de echte badge van de winnaar uit de sectie Winnaars.',
      icon: 'Pictogram',
      iconPlaceholder: 'Emoji of afbeeldings-URL',
      numberLabels: 'Tekst onder de cijfers',
      numberLabelsHint: 'De cijfers berekent het platform; hier bepaal je het woord eronder.',
      numberLabelPlaceholder: 'Bijv.: ontvangen',
      background: 'Achtergrond',
      uploadPhoto: 'Foto uploaden',
      uploadingPhoto: 'Bezig met uploaden…',
      removePhoto: 'Foto verwijderen',
      photoHint: 'PNG · aanbevolen formaat 1080 × 1920 px · max. 5 MB. De foto ligt over de kleur, die als reserve blijft.',
      photoErrPng: 'De achtergrond moet een PNG-afbeelding zijn.',
      photoErrSize: 'De afbeelding is groter dan 5 MB.',
      photoErrUpload: 'De afbeelding kon niet worden geüpload. Probeer het opnieuw.',
      photoErrNotPng: 'Het bestand heeft de extensie .png, maar is eigenlijk {{formato}}. Sla het op als PNG en upload het opnieuw.',
      photoErrRejected: 'De server heeft de afbeelding geweigerd: {{motivo}}',
      photoErrUnavailable: 'Achtergronden uploaden is in deze omgeving nog niet beschikbaar (404). Neem contact op met support.',
      photoErrForbidden: 'Je hebt geen toestemming om Recap-achtergronden te uploaden.',
      photoErrUploadCode: 'De afbeelding kon niet worden geüpload (code {{codigo}}). Probeer het opnieuw; neem anders contact op met support.',
      previewLabel: 'Voorbeeld',
      previewDataNote: 'De getoonde cijfers zijn van de gebruiker die zijn Recap opent.',
      apply: 'Toepassen',
    },
  },
  // ── WP-16 REQ-140 — Juridische modals ──
  legal: {
    privacy: 'Privacybeleid',
    legal: 'Deelnamevoorwaarden van het Programma',
    reachedEnd: 'Je bent aan het einde gekomen!',
    scrollHint: 'Scroll naar het einde om te accepteren',
    accept: 'Ik ga akkoord',
    acceptError: 'We konden je akkoord niet vastleggen. Controleer je verbinding en probeer het opnieuw; blijft het probleem bestaan, neem dan contact op met support.',
    loadError: 'Het document kon niet worden geladen.',
    pdfError: 'Het PDF-document kan niet worden weergegeven.',
    retry: 'Opnieuw proberen',
    openInNewTab: 'Openen in een nieuw tabblad',
  },
  // ── WP-16 REQ-139 — Standalone registratie Frontline ──
  register: {
    backToLogin: '← Terug naar aanmelden',
    entraTitle: 'Heb je al een werk-e-mail?',
    entraSub: 'Je hoeft je niet te registreren — log direct in met je Sigma-account.',
    title: 'Registratie',
    subtitle: 'Maak je toegang tot het Erkenningsprogramma aan.',
    fullName: 'Volledige naam',
    email: 'E-mailadres',
    ou: 'Organisatie-eenheid',
    selectOu: 'Selecteer je OU',
    startDate: 'Datum van indiensttreding bij Sigma',
    employeeId: 'Personeelsnummer',
    bu: 'Business unit',
    site: 'Werklocatie',
    department: 'Afdeling',
    selectBu: 'Selecteer je Business unit',
    selectSite: 'Selecteer je werklocatie',
    selectDepartment: 'Selecteer je afdeling',
    errName: 'Vul je volledige naam in.',
    errEmail: 'Vul een geldig e-mailadres in.',
    errOu: 'Selecteer je OU.',
    errCatalogs: 'Vul business unit, locatie en afdeling in.',
    errStartDate: 'Vul je datum van indiensttreding in.',
    errEmployeeId: 'Vul je personeelsnummer in.',
    catalogsError: 'De catalogi konden niet worden geladen.',
    submit: 'Registreren',
    submitError: 'De registratie kon niet worden voltooid.',
    checkEmailTitle: 'Controleer je e-mail',
    checkEmailSub: 'We hebben een verificatielink naar {{email}} gestuurd.',
    verified: 'E-mail geverifieerd',
    allSet: 'Alles staat klaar!',
    allSetSub: "Je account is succesvol ingesteld. Je kunt nu je collega's waarderen.",
    password: 'Wachtwoord (min. 8 tekens)',
    confirmPassword: 'Bevestig wachtwoord',
    errPassword: 'Het wachtwoord moet tussen 8 en 256 tekens lang zijn.',
    errPasswordMatch: 'De wachtwoorden komen niet overeen.',
    errLegal: 'Je moet de Deelnamevoorwaarden accepteren.',
    errLegalVersion: 'Het juridische document kon niet worden geladen. Probeer het opnieuw.',
    errPrivacy: 'Je moet het Privacybeleid accepteren.',
    errLocalId: 'Voer je Local ID in (max. 8 cijfers).',
    errDepartment: 'Selecteer je afdeling.',
    acceptPrivacy: 'Ik heb het gelezen en accepteer het',
    acceptLegalBases: 'Ik heb het gelezen en accepteer de',
    privacyLink: 'Privacybeleid',
    legalLink: 'Deelnamevoorwaarden',
    localId: 'Local ID',
    policyPlaceholder: 'Lees het volledige document. Zodra je het einde bereikt, kun je het accepteren.',
    createdTitle: 'Account aangemaakt',
    createdSub: 'Je kunt nu inloggen met je e-mail en wachtwoord. Eenmaal binnen kun je je avatar kiezen.',
    checkEmailHint: 'Open de link om je e-mailadres te bevestigen en te kunnen inloggen. De link verloopt over 24 uur.',
    resend: 'E-mail opnieuw versturen',
    resendDone: 'Als je account nog moet worden geverifieerd, hebben we je een nieuwe link gestuurd (24 uur geldig). Controleer ook je spammap. Als je hem al hebt geverifieerd, log dan in met je e-mailadres en wachtwoord.',
    errOuNotFound: 'We hebben die organisatie niet gevonden. Kies een andere uit de lijst.',
    errOuUnavailable: 'Registratie is niet beschikbaar voor de geselecteerde organisatie.',
    errNoMatch: 'We konden je gegevens niet valideren met de bedrijfsregistraties. Controleer of je organisatie-eenheid en je personeelsnummer (of je Local ID, als je in Europa werkt) juist zijn. Als je je al hebt geregistreerd, log dan in of herstel je wachtwoord. Blijft het probleem bestaan, neem dan contact op met HR.',
    errEmailInUse: 'Er is al een account gekoppeld aan dit e-mailadres.',
    corporateEmail: 'Dit is een zakelijk e-mailadres en je hebt al toegang via de Sigma-aanmelding (SSO), dus je kunt het niet gebruiken om je te registreren. Log in met je Sigma-account.',
    errNetwork: 'Geen verbinding mogelijk. Controleer je verbinding en probeer het opnieuw.',
    errTooMany: 'Te veel pogingen. Wacht even en probeer het opnieuw.',
    errServer: 'Er is aan onze kant iets misgegaan en de registratie kon niet worden voltooid. Probeer het over een paar minuten opnieuw. Blijft het probleem bestaan, geef dan deze referentie door aan support: {{referencia}}.',
    verifyConfirmTitle: 'Bevestig je e-mailadres',
    verifyConfirmSub: 'Druk op de knop om de verificatie van je e-mailadres af te ronden en je account te activeren.',
    verifyConfirmCta: 'Mijn e-mailadres bevestigen',
    verifyAlready: 'Je e-mailadres is al geverifieerd',
    verifyAlreadySub: 'Je hoeft verder niets te doen: je kunt nu inloggen.',
    verifyTemporary: 'We konden je e-mailadres nu niet verifiëren',
    verifyTemporarySub: 'De link is nog steeds geldig. Controleer je verbinding en probeer het opnieuw.',
    verifyRetry: 'Opnieuw proberen',
    errPayrollTaken: 'Er is al een account gekoppeld aan dit personeelsnummer.',
    payrollTakenAction: 'Als je je al eerder hebt geregistreerd, kun je direct inloggen op je account of een nieuw wachtwoord aanvragen als je het niet meer weet.',
    payrollTakenRecover: 'Wachtwoord herstellen',
    linkInvalidTitle: 'De link is niet meer geldig',
    linkInvalidBody: 'Sorry, deze bevestigingslink is verlopen of om veiligheidsredenen ongeldig gemaakt.',
    linkInvalidHint: 'Heb je deze toegang aangevraagd, vraag dan een nieuwe aan via onze applicatie. Herken je deze website niet, dan kun je dit bericht gerust negeren.',
    linkInvalidCta: 'Naar de startpagina',
    checkEmailWrong: 'Niet je e-mailadres? Pas het aan',
    verifyEmailTaken: 'Dit e-mailadres is al geregistreerd',
    verifyEmailTakenSub: 'Iemand anders heeft datzelfde e-mailadres eerder geverifieerd. Is het van jou, log dan in of herstel je wachtwoord; zo niet, registreer je opnieuw met je eigen e-mailadres.',
  },
  // ── Inloggen (RF-002) ──
  login: {
    title: 'Inloggen',
    subtitle: 'Erkenningsprogramma',
    entraRouteTitle: 'Log in met je werk-e-mail',
    entraRouteSub: 'Gebruik je Sigma-account (Entra ID).',
    entra: 'Inloggen met Sigma-e-mail',
    frontlineRouteTitle: 'Geen werk-e-mail?',
    frontlineRouteSub: 'Log in met je e-mail en wachtwoord.',
    email: 'E-mail',
    password: 'Wachtwoord',
    submit: 'Inloggen',
    submitting: 'Bezig met inloggen…',
    or: 'of',
    toRegister: 'Nog geen account? Registreer je',
    noAccountLede: 'Geen institutioneel account?',
    noAccountSub: 'Gebruik een persoonlijk e-mailadres',
    alreadyRegisteredLede: 'Al geregistreerd?',
    hasInstitutionalEmailLede: 'Heb je een werk-e-mail?',
    register: 'Registreer je',
    back: 'Terug',
    forgot: 'Wachtwoord vergeten?',
    forgotIntro: 'Vul je e-mailadres in en we sturen je een link om een nieuw wachtwoord aan te maken.',
    forgotSubmit: 'Stuur me de link',
    forgotSent: 'Als dat e-mailadres geregistreerd is, hebben we je een link gestuurd. Die verloopt over 60 minuten.',
    resendVerification: 'Geen verificatiemail ontvangen?',
    resendIntro: 'Vul je e-mailadres in en we sturen je een nieuwe verificatielink.',
    resendSubmit: 'E-mail opnieuw versturen',
    resendSent: 'Als je account nog moet worden geverifieerd, hebben we je een nieuwe link gestuurd (24 uur geldig). Controleer ook je spammap. Als je hem al hebt geverifieerd, log dan in met je e-mailadres en wachtwoord.',
    errNotVerified: 'Je e-mailadres is nog niet geverifieerd. Open de link die we je hebben gestuurd of vraag een nieuwe aan via ‘Geen verificatiemail ontvangen?’.',
    errInactive: 'Je account is gedeactiveerd. Neem contact op met HR.',
    errTempExpired: 'Je tijdelijke wachtwoord is verlopen. Vraag een nieuw aan bij HR.',
    errNetwork: 'Geen verbinding mogelijk. Controleer je verbinding en probeer het opnieuw.',
    corporateEmailHint: 'Dit is een zakelijk e-mailadres: log in met je Sigma-account, zonder wachtwoord.',
    errRequired: 'Vul je e-mail en wachtwoord in.',
    errCredentials: 'Onjuiste e-mail of wachtwoord.',
  },
  // ── Gemeenschappelijke landingspagina (regel #3) ──
  landing: {
    question: 'Welke Fundamentals gaan we vandaag erkennen?',
    subtitle: 'Kies een ruimte om je Fundamentals te beleven',
    cardPulso: 'Post Meeting Pulse',
    cardShine: 'Shine Together',
    pulsoHover: 'Hoe was je team in de laatste meeting? Vertel wat je opviel 💬',
    shineHover: 'Wil je zien wie er schittert en een collega nomineren?',
  },
  // Restablecimiento de contrasena Frontline (/app/restablecer)
  activate: {
    errTemporary: 'We konden je account nu niet activeren. Controleer je verbinding en probeer het opnieuw; je link is nog steeds geldig.',
  },
  reset: {
    titleTemporary: 'Kies je definitieve wachtwoord',
    subtitleTemporary: 'Je bent ingelogd met een tijdelijk wachtwoord. Kies een nieuw wachtwoord om verder te gaan.',
    errTemporary: 'We konden je verzoek nu niet verwerken. Controleer je verbinding en probeer het opnieuw; je link is nog steeds geldig.',
    title: 'Maak je nieuwe wachtwoord aan',
    subtitle: 'Kies een wachtwoord om weer in te loggen.',
    password: 'Nieuw wachtwoord (min. 8 tekens)',
    confirmPassword: 'Wachtwoord bevestigen',
    submit: 'Mijn wachtwoord wijzigen',
    errPassword: 'Het wachtwoord moet minstens 8 tekens lang zijn.',
    errPasswordMatch: 'De wachtwoorden komen niet overeen.',
    errInvalidLink: 'De link is ongeldig of verlopen. Vraag een nieuwe aan via de inlogpagina.',
    doneTitle: 'Wachtwoord bijgewerkt',
    doneSub: 'Je kunt nu inloggen met je e-mailadres en je nieuwe wachtwoord.',
    noToken: 'Ongeldige link',
    noTokenSub: 'De link is ongeldig of onvolledig. Controleer de e-mail die je hebt ontvangen.',
  },
  auth: {
    retryIn: 'Je kunt het over {{seconds}} s opnieuw proberen',
    contactHR: 'Als je problemen hebt met registreren, neem dan contact op met je Human Capital-team.',
    errorTitle: 'We konden niet doorgaan',
  },
  // ── WP-16 REQ-141 — Avatar ──
  avatar: {
    title: 'Kies je avatar',
    subtitle: 'Kies de afbeelding die jou vertegenwoordigt.',
    loading: 'Avatars laden…',
    empty: 'Er zijn nog geen avatars beschikbaar.',
    loadError: 'Avatars konden niet worden geladen.',
    saveError: 'Je avatar kon niet worden opgeslagen.',
    saved: 'Avatar opgeslagen',
    confirm: 'Bevestigen',
    required: 'Kies je avatar om door te gaan.',
    unavailable: 'Die avatar is niet meer beschikbaar. Kies een andere.',
    change: 'Avatar wijzigen',
    continueWithout: 'Doorgaan zonder avatar',
  },
  // ── WP-08 — Rapportage van Erkenning ──
  reports: {
    title: 'Rapportage',
    subtitle: 'Analyse van het Erkenningsprogramma. Toont nooit punten.',
    emptyScope: 'Er is geen organisatie-eenheid binnen uw bereik aan u toegewezen.',
    tabs: {
      daily: 'Reco Diario',
      shine: 'Brillamos Juntos',
      heatmap: 'Heatmap',
      network: 'ONA-netwerk',
      generational: 'Demografisch',
      leaders: 'Leiders',
      moderation: 'Moderatie',
      campaigns: 'Historie',
    },
    common: {
      loading: 'Rapportage laden…',
      error: 'Het rapport kon niet worden geladen.',
      empty: 'Er zijn geen gegevens voor de geselecteerde filters.',
      retry: 'Opnieuw proberen',
      suppressedNote: 'Sommige totalen zijn verborgen door de anonimiteitsdrempel (minder dan 5).',
      suppressedNoteHelp: 'Als een groep minder dan 5 personen telt, worden de uitgesplitste cijfers niet gepubliceerd: bij zo weinig zou het gegeven iemand herleidbaar maken. Het is geen fout en er ontbreekt geen informatie.',
      colScope: 'Bereik (eenheden)',
      colScopeHelp: 'Organisatie-eenheden waarop de campagne gericht was.',
      colAudienceHelp: 'Aantal medewerkers waarop de campagne gericht was. Dit is de noemer van de deelnamegraad.',
      scopeAll: 'Hele organisatie',
      scopeMore: '+{{n}} meer',
      masked: 'Verborgen vanwege anonimiteit',
      showingRange: '{{desde}}–{{hasta}} van {{total}}',
      pageSize: 'Rijen per pagina',
      perPage: '{{n}} per pagina',
      exportExcel: 'Exporteren naar Excel',
      yes: 'Ja',
      no: 'Nee',
    },
    context: {
      unifiedTitle: 'Uniforme statistieken',
      unifiedText: '— Dagelijkse Erkenning en Shine Together gebruiken dezelfde tellogica. De cijfers zijn consistent tussen modules.',
      auditTitle: 'Auditing actief.',
      auditText: 'Elke download wordt vastgelegd met je gebruiker, het tabblad en de datum.',
      showing: 'Weergave:',
      wholeOrg: 'de hele organisatie',
    },
    filters: {
      allFundamentals: 'Alle Fundamentals',
      allOus: "Alle OU's",
      site: 'Site',
      allSites: 'Alle sites',
      dateFrom: 'Van',
      dateTo: 'Tot',
      reset: 'Wissen',
      ou: 'Eenheid',
      fundamental: 'Fundamentals',
      dateRange: 'Datums',
      remove: 'Filter {{filter}} verwijderen',
      person: 'Persoon',
      personPlaceholder: 'Persoon zoeken…',
      openCalendar: "Kalender openen",
      personClear: 'Geselecteerde persoon verwijderen',
      personNoResults: 'Geen overeenkomsten in de directory',
      personSearching: 'Bezig met zoeken…',
      personError: 'De directory kon niet worden geraadpleegd',
    },
    notApplicable: {
      title_one: 'Het filter {{filtros}} is niet van toepassing op dit onderdeel.',
      // `title_few` — inert alias van `title_other`, alleen aanwezig voor sleutelpariteit met `ro`.
      title_few: 'De filters {{filtros}} zijn niet van toepassing op dit onderdeel.',
      title_other: 'De filters {{filtros}} zijn niet van toepassing op dit onderdeel.',
      and: 'en',
      reason: {
        embudo: 'De trechter verdeelt de hele populatie over Vaste, Incidentele en Inactieve gebruikers; beperkt tot één persoon zou het geen verdeling meer zijn.',
        historico: 'Deze cijfers zijn "ooit", niet van de gekozen periode: ze tellen iedereen die ooit iemand heeft erkend, in de hele geschiedenis op het platform.',
        audienciaCampana: 'Deze indicator wordt berekend over de doelgroep die de campagne heeft opgeroepen, die gelijk blijft ongeacht de gekozen Fundamentals of de gekozen persoon.',
        porBanda: 'De verdeling groepeert personen per generatieband; met één geselecteerde persoon zou er nog maar één band overblijven, en zou het geen verdeling meer zijn.',
        porOu: 'Deze weergave groepeert op organisatie-eenheid, niet op persoon.',
        redOu: 'De knooppunten van het netwerk zijn organisatie-eenheden, geen personen.',
        promedioPulso: 'Deze tabel komt uit de gemiddelde Pulso-scores (1-4) per generatie en Fundamental, niet uit het aantal erkenningen of de personeelstelling: geen van beide filters beperkt ze.',
        resumenCampana: 'Deze indicator komt uit de samenvatting van de hele campagne: de backend ondersteunt geen beperking tot één persoon (wel tot Fundamentals).',
        casosReportados: 'Dit rapport toont gerapporteerde CASES, en de reden schrijft degene die rapporteert: die is niet gekoppeld aan een Fundamental van de erkenning. De OU, het datumbereik en de persoon beperken deze tabel wel.',
        campanaFinalizada: "De gekozen campagne is afgerond: ze wordt volledig getoond, van begin tot einde.",
      },
    },
    daily: {
      title: 'Dagelijkse Erkenning',
      subtitle: 'Alleen erkenningen uit de dagelijkse praktijk, zonder campagnes: gekozen vs. vorige periode, deelnametrechter en tops.',
      // T-05 — el tab respeta el rango del filtro, así que la comparativa ya no es «semana»
      // fija: es el periodo elegido contra el anterior equivalente. Sin rango, sigue siendo
      // la semana en curso, que es el valor por omisión que pide la Especificación.
      thisPeriod: 'Gekozen periode',
      prevPeriod: 'Vorige periode',
      vsPrev: '{{variacion}} t.o.v. vorige periode · {{previo}}',
      fundamentalDistribution: 'Verdeling per Fundamental',
      totalSentTitle: 'Totaal verzonden erkenningen',
      totalSentHint: 'Som van alle in de periode verzonden erkenningen',
      retiredFundamental: 'Ingetrokken fundamental',
      unresolvedFundamental: 'Fundamental (catalogus niet beschikbaar)',
      retiredFundamentalHint: 'Fundamental verwijderd uit de catalogus: het blijft in de historie omdat er erkenningen mee waren, maar het kan niet meer worden gekozen.',
      adoptionStaff: 'Staff-gebruikers',
      adoptionFrontline: 'Frontline-gebruikers',
      adoptionTotal: 'Gebruikers totaal',
      noActivity: 'Geen activiteit',
      adoptionHint: '{{reconocedores}} van {{plantilla}} hebben iemand erkend',
      adoptionTotalHint: '{{pct}} van het totale personeelsbestand ({{plantilla}})',
      noActivityHint: 'Hebben nog nooit een erkenning verzonden',
      variation: 'Verschil',
      sparkAria: 'Dagelijkse trend voor {{label}}: {{dias}} dagen, van {{primero}} tot {{ultimo}}',
      uniquePeople: 'Unieke personen',
      pares: 'Collega\'s',
      lideres: 'Leidinggevenden',
      groupRecognitions: 'Groepserkenningen',
      groupRecognitionsHint: 'van {{total}} verzonden · aan 2 of meer personen',
      funnel: 'Deelnametrechter',
      funnelRange: 'Periode: {{from}} – {{to}}',
      funnelPeople: '{{count}} personen',
      topPeople: 'Top gewaardeerde personen',
      topRecognizers: 'Top waarderende personen',
      topFundamentals: 'Top kernprincipes',
      // E6 — botón de export multi-hoja (7 hojas) del tab completo.
      exportMultiSheet: 'Dagelijks exporteren (6 tabbladen)',
      colStage: 'Fase',
      // C2 — las ocho columnas de los Top-10 de la maqueta.
      colName: "Naam",
      colDepto: "Afdeling",
      colOu: "OU",
      colFundamental: "Fundament",
      colRecos: 'Erkenningen',
      colEnviados: "Verzonden",
      colCrossOu: "Tussen OU",
      colType: "Type",
      crossOu: {
        si: "Ja",
        no: "Nee",
        desconocido: "—",
      },
      // Las 4 columnas que el Excel comparte con «Brillamos Juntos» (`excelPlantillaTeal.ts`, el
      // mismo constructor arma las hojas de ranking de los dos reportes) y que la pantalla del
      // Diario no pinta.
      colEmail: 'E-mail',
      colEmployeeId: 'Personeelsnummer',
      colRecognitions: 'Erkenningen',
      colDominantType: 'Dominant type',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Reconocimiento Diario (`dailyExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `01 - Reconocimiento Diario.xlsx`
      // (auditoría 2026-09-05). El libro entero sale en el idioma de quien descarga.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Managementsamenvatting',
        sheetDefinitions: 'Definities',
        sheetFunnel: 'Adoptietrechter',
        sheetTopRecognized: 'Top Erkenden',
        sheetTopRecognizers: 'Top Erkenners',
        sheetAllRecognitions: 'Alle erkenningen',
        sheetReceived: 'Ontvangen erkenningen',
        summaryTitle: 'Dagelijkse Erkenning — Fundamentals van elke dag',
        summarySubtitle: 'Indicatoren van de gekozen periode: wie erkent, wie erkend wordt en hoe vaak.',
        definitionsTitle: 'Wat betekent elk gegeven?',
        definitionsSubtitle: 'Uitleg in gewone taal, voor iedereen die dit bestand downloadt, zonder kennis van data.',
        funnelTitle: 'Adoptietrechter',
        funnelSubtitle: 'Segmentatie op basis van hoe vaak er erkenningen zijn verstuurd in de periode ({{rango}}), als maandgemiddelde.',
        funnelEmpty: 'Geen gegevens: er zijn geen erkenningen in de periode.',
        topRecognizedTitle: 'Meest erkend',
        topRecognizersTitle: 'Top erkenners',
        rankingSubtitle: 'Ranglijst berekend op de erkenningen van deze periode.',
        topRecognizersEmpty: 'Geen gegevens: niemand heeft in deze periode een erkenning verstuurd.',
        allRecognitionsTitle: 'Alle erkenningen',
        allRecognitionsSubtitle: 'Ruwe details van de dagelijkse praktijk in de periode, zonder campagne-inzendingen: één rij per erkende kandidaat. De kolomnamen behouden hun oorspronkelijke vorm zodat de draaitabellen van de commissie blijven werken.',
        allRecognitionsNoRange: 'Geen gegevens: het exacte bereik van de periode kon niet worden bepaald, omdat het totaal is onderdrukt door de anonimiteitsdrempel en het filter geen expliciete datums bevat.',
        receivedTitle: 'Ontvangen erkenningen',
        receivedSubtitle: 'Erkenningen in de periode ontvangen door personen van de geselecteerde OU’s, ongeacht de OU van de afzender: één rij per erkende persoon. Bij een groepserkenning verschijnen alleen de personen van die OU’s.',
        receivedAllOus: 'Geen records: met alle OU’s is het ontvangene gelijk aan het verzondene en staat het al in ‘Alle erkenningen’. Selecteer een of meer OU’s om hier te zien wat ze ontvingen.',
        metaPeriod: 'Periode',
        metaFilters: 'Toegepaste filters',
        metaFunnelMonth: 'Trechterperiode',
        metaGenerated: 'Gegenereerd',
        colKpi: 'KPI',
        colValue: 'Waarde',
        colDetail: 'Detail',
        colDatum: 'Gegeven',
        colWhatIs: 'Wat het is',
        colHowCalculated: 'Hoe het wordt berekend',
        colPercentOfTotal: '% van het totaal',
        colSegment: 'Segment',
        colPeople: 'Personen',
        colAdministrative: 'Kantoor',
        colOperational: 'Operationeel',
        colFundamental: 'Fundamental',
        colRank: '#',
        colArea: 'Gebied',
        colSite: 'Locatie',
        headcountTitle: 'Personeelsbestand',
        headcountTotal: 'Totaal',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Personen',
        kpiPeers: 'Collega’s (unieke erkenningen tussen collega’s)',
        kpiLeaders: 'Leidinggevenden (unieke erkenningen waarbij een leidinggevende betrokken is)',
        datumTeamRecognitions: 'Erkenningen aan teams',
        datumAudienceStaff: 'Doelgroep Staff (kantoor)',
        datumAudienceFrontline: 'Doelgroep Frontline (operationeel)',
        datumComparison: 'Vorige periode en variatie',
        datumRankings: 'Top Erkenden / Top Erkenners',
        datumLeader: 'Leidinggevende',
        whatRecognitionsMade: 'Hoeveel erkenningen er in totaal zijn verstuurd tijdens de periode, met de toegepaste filters.',
        calcRecognitionsMade: 'De erkenningen uit de dagelijkse praktijk met een datum binnen de gekozen periode worden opgeteld. Die bij een campagne horen, worden geteld in het rapport «We stralen samen».',
        whatUniqueRecognized: 'Hoeveel verschillende personen minstens één erkenning hebben ontvangen. Wie er vijf ontving telt maar één keer.',
        calcUniqueRecognized: 'De verschillende personen die in de periode als ontvanger voorkomen worden geteld.',
        whatTeamRecognitions: 'Een erkenning is een groepserkenning wanneer die meer dan één ontvanger heeft.',
        calcTeamRecognitions: 'De kolom «Recognition type» van het blad «Alle erkenningen» markeert elke rij als Individual of Grupal.',
        whatPeers: 'Erkenningen waarbij noch de verzender noch de ontvanger mensen aanstuurt: collega naar collega, leidinggevende naar leidinggevende, manager naar manager.',
        calcPeers: 'De erkenningen tussen collega’s binnen de periode worden gefilterd.',
        whatLeaders: 'Erkenningen waarbij minstens één persoon met mensen onder zich betrokken is.',
        calcLeaders: 'De erkenningen waarbij de verzender of de ontvanger de rol van leidinggevende, supervisor of manager heeft worden gefilterd.',
        whatStaffAdoption: 'Van alle kantoormedewerkers (Staff) het percentage dat in de periode al iemand heeft erkend.',
        calcStaffAdoption: 'Staff-medewerkers met minstens één verstuurde erkenning in de periode, gedeeld door het totale Staff-bestand binnen het bereik.',
        whatFrontlineAdoption: 'Van alle medewerkers in productie of op locatie (Frontline) het percentage dat in de periode al iemand heeft erkend.',
        calcFrontlineAdoption: 'Frontline-medewerkers met minstens één verstuurde erkenning in de periode, gedeeld door het totale Frontline-bestand binnen het bereik.',
        whatTotalUsers: 'Hoeveel mensen binnen het bereik ooit minstens één erkenning hebben verstuurd, sinds ze een account hebben.',
        calcTotalUsers: 'Personen met minstens één verstuurde erkenning in hun hele historie. Dit hangt niet af van de gekozen periode: het komt uit de dagelijkse telling.',
        whatNoActivity: 'Personen die nog nooit één erkenning hebben verstuurd sinds ze een account hebben.',
        calcNoActivity: 'Het totale personeelsbestand binnen het bereik min de personen met minstens één verstuurde erkenning in hun hele historie.',
        whatAudienceStaff: 'Personen met een zakelijk Entra ID-account.',
        whatAudienceFrontline: 'Personen die zich op het platform registreren met hun eigen e-mailadres.',
        whatPrevPeriod: 'Erkenningen die zijn verstuurd in dezelfde dagen direct vóór de gekozen periode.',
        whatVariation: 'Hoeveel het volume aan erkenningen is gestegen of gedaald ten opzichte van de gelijkwaardige vorige periode.',
        calcVariation: 'De vorige periode bestaat uit dezelfde dagen direct vóór de gekozen periode. De variatie is het verschil tussen beide, gedeeld door het totaal van de vorige periode.',
        whatFunnel: 'Segmenteert het bereik op verzendfrequentie in de gekozen periode, dezelfde als hierboven: Regelmatig (gemiddeld vier keer of meer per maand), Incidenteel (minstens één keer, onder dat gemiddelde) en Inactief (geen). Voor periodes korter dan een maand geldt de drempel van één maand. Elke fase wordt uitgesplitst naar kantoor en operationeel.',
        calcFunnel: 'Het percentage en de kolom Personen worden berekend over het personeelsbestand binnen het bereik. Kantoor en operationeel tellen diezelfde personen naar functietype en blijven leeg als die indeling niet beschikbaar is.',
        whatRankings: 'De meest erkende personen en degenen die het meest erkennen in de periode, tot 200 in elke lijst.',
        calcRankings: 'Gesorteerd op het aantal ontvangen of verstuurde erkenningen. Wie de anonimiteitsdrempel niet haalt verschijnt gemaskeerd.',
        whatAllRecognitions: 'Ruwe details van de periode, één rij per kandidaat: de volledige blokken Nominee, OnBehalfOf en Candidate, de datum, de matrix van actieve Habits en de auditvlaggen. Personen worden niet gemaskeerd: dit is de werkbron van de commissie, en de anonimiteitsdrempel geldt voor de samengevatte rapporten. Het bevat ook erkenningen uit lopende Shine Together-campagnes, want het dagrapport telt ze allemaal.',
        calcAllRecognitions: 'Volledige lijst van de erkenningen in de periode. De Habit-kolommen bevatten alleen de Habits die op het moment van exporteren actief zijn in de catalogus. De kolom Reco_ID blijft leeg omdat het systeem nog geen unieke identificatie per rij genereert.',
        whatGroupRecognitions: 'Hoeveel van de verzonden erkenningen naar twee of meer personen gingen. Elke groepserkenning telt één keer, ongeacht hoeveel personen ze erkent.',
        calcGroupRecognitions: 'Erkenningen met twee of meer erkende personen worden geteld. ‘Alle erkenningen’ heeft één rij per erkende persoon en kan dus meer rijen hebben dan het totaal aan verzonden erkenningen.',
        whatReceived: 'Detail van wat personen van de in het filter geselecteerde OU’s ontvingen, ook als degene die hen erkende tot een andere OU behoort (Cross-OU-erkenningen).',
        calcReceived: 'Elke erkende persoon wiens OU tot de geselecteerde behoort (inclusief onderliggende eenheden) wordt opgenomen. Een persoon zonder OU telt mee met de OU van degene die hem of haar erkende. Met alle OU’s blijft het blad zonder records.',
        noteLeader: 'Een rol geldt als leidinggevende wanneer er mensen aan rapporteren.',
        masked: 'Verborgen om anonimiteit',
      },
    },
    shine: {
      pointsAwarded: 'Toegekende punten',
      pointsAwardedHint: '{{nominaciones}} nominaties · {{personas}} personen',
      personaNoFiltraCampanas: 'Het filter Persoon geldt niet voor de campagnelijst: die wordt beperkt op OE en status.',
      personaEnElReporte: "Met Persoon toont het rapport wat die persoon in de campagne heeft verzonden of ontvangen; „Uitgevoerde erkenningen” en de ranglijst tellen alleen wat zij heeft verzonden.",
      title: 'Samen Stralen',
      subtitle: 'Nominatieranking van de campagne en live-KPI’s.',
      recognitionsMade: 'Uitgevoerde erkenningen',
      uniqueRecognized: 'Unieke erkende personen',
      uniqueRecognizers: 'Unieke personen die erkennen',
      participationRate: 'Deelnamepercentage',
      totalHeadcount: 'Totale personeelsbestand',
      // E6 — reemplaza al export de una sola hoja: ahora arma las 7 hojas del Excel de Brillamos.
      exportMultiSheet: 'Shine exporteren (7 tabbladen)',
      exporting: 'Bezig met exporteren…',
      exportError: 'De download kon niet worden voltooid. Probeer het opnieuw.',
      exportTooLarge: 'Het rapport bevat meer dan 200.000 rijen per blad. Beperk de periode of de filters en exporteer opnieuw.',
      winnersFormat: 'Formaat van de winnaarsexport',
      datesFromCampaign: "De datums zijn aangepast aan de looptijd van de gekozen campagne; u kunt ze wijzigen.",
      rankingCountsPeople: "De kaarten tellen erkenningen en de ranglijst telt personen: een groepserkenning telt boven één keer en hier één keer per persoon, dus de cijfers kunnen verschillen.",
      winnersOnlyExpired: "Beschikbaar zodra de campagne is verlopen: daarvoor zijn er geen winnaars.",
      winnersEmpty: "Deze campagne heeft nog geen geregistreerde winnaars.",
      formatRaw: 'Ruw',
      formatCascaded: 'Gecascadeerd',
      exportWinners: 'Winnaars exporteren',
      colPos: 'Positie',
      kpiTotal: 'Totaal',
      kpiParticipants: 'Deelnemers',
      kpiParticipation: 'Deelname',
      kpiAvgPerPerson: 'Gemiddelde per persoon',
      // T-10 — el tab es POR CAMPAÑA (confirmado con Adriana, 18-ago-2026): sin una elegida
      // los indicadores no pueden acotarse y se pide elegir, en vez de pintar los del scope.
      campaignSelector: 'Campagne',
      campaignScope: "Bereik van de campagne:",
      allCampaigns: "Alle campagnes",
      scopeOnlyCoversAll: "Deze campagne omvat alleen {{alcance}}; andere OU's zijn niet in dit rapport opgenomen.",
      scopeOnlyCoversSome: "Deze campagne omvat alleen {{alcance}}. Buiten haar bereik: {{fuera}}.",
      campaignStatusLabel: "Campagnestatus",
      campaignStatus: { activa: "Actief", finalizada: "Verlopen" },
      noCampaigns: "Geen campagnes met deze status voor de gekozen OU's",
      campaignsForbidden: 'Je hebt geen toestemming om campagnes te bekijken',
      campaignsLoadError: 'De campagnes konden niet worden geladen',
      filtersHelp: "Kies eerst de OU: de lijst met campagnes hangt ervan af. Daarna de status en de campagne, die leidend is: de cijfers komen uit haar bereik. Site, Fundamental en persoon verfijnen binnen dat bereik. Het datumbereik geldt alleen voor actieve campagnes; een verlopen campagne wordt volledig gerapporteerd.",
      filtersHelpAria: "Hoe de filters met de campagne samenwerken",
      modalidadSelector: 'Shine Together-filter',
      daysLeft: 'Resterende dagen',
      activeOus: 'Actieve OUs',
      modalidadTodos: 'Alle genomineerden',
      modalidadPersonaUnica: 'Alleen één ontvanger',

      modalidadGrupal: 'Alleen groep (team)',
      modalidadCrossOu: 'Cross-OU',
      pickCampaign: "Selecteer eerst een campagne.",
      habitsRanking: 'Ranglijst Daily Habits',
      colHabit: 'Daily Habit',
      colRecognitions: 'Waarderingen',
      colName: 'Naam',
      colBu: 'BU',
      colDept: 'Afd.',
      colOrigin: 'Bron',
      filterHabitsByFundamental: 'Gewoonten filteren op Fundamental',
      allFundamentals: 'Alle Fundamentals',
      colCount: 'Erkenningen',
      colOu: 'OU',
      colCountry: 'Land',
      colBadge: 'Badge',
      colCrossed: 'Gekruiste oorsprong',
      // Tarea 16 — las 6 columnas nuevas de "Top Reconocidos"/"Top Reconocedores" (11 columnas
      // exactas de la plantilla real del cliente). `colCrossOu` reusa la misma
      // traducción que ya usa `reports.daily` para el mismo dato.
      colEmail: 'E-mail',
      colEmployeeId: 'Personeelsnummer',
      colCrossOu: 'Tussen OU',
      colDominantType: 'Dominant type',
      // Fix round 1 (Tarea 14) — reubicadas desde un bloque `shine` de nivel superior huérfano
      // (nunca se leía: el tab completo usa `reports.shine.*`), que quedaba fuera de `reports` y
      // duplicaba estas mismas 10 claves con el contenido correcto. Sin esto, `tarjetasDeAdopcion`
      // y el banner de filtros aplicados pintaban la clave cruda en vez del texto traducido.
      adoptionStaff: 'Staff-gebruikers',
      adoptionFrontline: 'Frontline-gebruikers',
      adoptionTotal: 'Gebruikers totaal',
      noActivity: 'Geen activiteit',
      adoptionHint: '{{reconocedores}} van {{plantilla}} hebben genomineerd',
      adoptionTotalHint: '{{pct}} van het totale bestand ({{plantilla}})',
      noActivityHint: 'Hebben nog nooit genomineerd',
      clearAll: 'Alles wissen',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Brillamos Juntos (`brillamosExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `02 - Campana brillamos juntos.xlsx`
      // (auditoría 2026-09-05): nombres de hoja, banners, metadatos, encabezados de tabla y el
      // glosario completo de «Definiciones». El libro entero sale en el idioma de quien descarga.
      //
      // Las etiquetas de dato que la pantalla ya usa (`recognitionsMade`, `uniqueRecognized`,
      // `adoptionStaff`, `colName`, `colEmail`…) NO se repiten aquí: se reusan de arriba para que
      // la celda del Excel y la columna de la tabla digan lo mismo.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        kpiCrossOu: 'OE-overstijgende erkenningen',
        whatCrossOu: 'Erkenningen waarbij minstens één erkende persoon tot een andere OE behoort dan wie erkent.',
        calcCrossOu: 'Eén keer per erkenning geteld: één erkende persoon uit een andere OE volstaat. Is de OE van een erkende persoon onbekend, dan telt dat niet als overschrijding.',
        datumAwardsPoints: 'De campagne kent punten toe',
        whatAwardsPoints: '{{valor}}. Geeft aan of de erkenningen van deze campagne punten opleveren voor de erkende personen.',
        calcAwardsPoints: 'Uit de campagne-instellingen („Punten toekennen”). Alleen puntenbeheerders zien punten.',
        sheetReceivedRecognitions: 'Alle ontvangen erkenningen',
        receivedRecognitionsTitle: 'Alle ontvangen erkenningen',
        receivedRecognitionsSubtitle: "Dezelfde kolommen als «Alle erkenningen», met wat de personen van de gefilterde OU (of de OU van wie exporteert) in alle Brillamos-campagnes van de periode ontvingen. De kolom Campaign zegt welke.",
        sheetSummary: 'Managementsamenvatting',
        sheetDefinitions: 'Definities',
        sheetDistribution: 'Verdeling Fundamental',
        sheetFunnel: 'Adoptietrechter',
        sheetTopRecognized: 'Meest erkend',
        sheetTopRecognizers: 'Meest erkennend',
        sheetAllRecognitions: 'Alle erkenningen',
        summaryTitle: 'Campagne Samen Schitteren',
        definitionsTitle: 'Wat betekent elk gegeven?',
        definitionsSubtitle: 'Uitleg in eenvoudige taal, voor iedereen die dit bestand downloadt, zonder kennis van data.',
        distributionTitle: 'Verdeling per Fundamental',
        distributionSubtitle: 'Aandeel berekend op basis van de erkenningen van deze campagne.',
        distributionChart: 'Erkenningen per Fundamental',
        distributionNote: 'Eén erkenning kan meer dan één Fundamental of meer dan één Habit bevatten, en elk daarvan telt apart mee: de sommen in deze tabel hoeven niet overeen te komen met het campagnetotaal of met het aantal van hun Fundamental.',
        distributionEmpty: 'Geen gegevens: de campagne heeft in deze periode geen erkenningen met een geregistreerde Fundamental.',
        funnelTitle: 'Adoptietrechter',
        funnelSubtitle: 'Segmentatie berekend op basis van hoe vaak er in de campagneperiode erkenningen zijn verstuurd.',
        funnelEmpty: 'Geen gegevens: de campagne heeft in deze periode geen erkenningen.',
        topRecognizedTitle: 'Meest erkende personen',
        topRecognizersTitle: 'Meest erkennende personen',
        rankingSubtitle: 'Ranglijst berekend op basis van de erkenningen van deze campagne.',
        topRecognizersEmpty: 'Geen gegevens: niemand heeft binnen deze campagne erkenning gegeven.',
        allRecognitionsTitle: 'Alle erkenningen',
        allRecognitionsSubtitle: 'Ruwe campagnedetails: één rij per erkende kandidaat. De kolomnamen blijven in hun oorspronkelijke vorm zodat de draaitabellen van de commissie blijven werken.',
        metaPeriod: 'Periode',
        metaFilters: 'Toegepaste filters',
        metaScope: 'Bereik',
        whatPointsAwarded: 'Som van de geldige punten die de campagne aan elke erkende persoon heeft toegekend, binnen de periode en het bereik van het rapport. Alleen puntenbeheerders.',
        noPoints: "Geen punten",
        metaGenerated: 'Gegenereerd',
        colKpi: 'KPI',
        colValue: 'Waarde',
        colDetail: 'Detail',
        colDatum: 'Gegeven',
        colWhatIs: 'Wat het is',
        colHowCalculated: 'Hoe het wordt berekend',
        colFundamentals: 'Fundamentals',
        colPercentOfTotal: '% van totaal',
        colSegment: 'Segment',
        colPeople: 'Personen',
        colAdministrative: 'Kantoor',
        colOperational: 'Productie',
        // El Fundamental de una fila del ranking. Clave propia y no la de `reports.daily`:
        // `brillamosExcel.ts` resuelve todo su texto bajo `reports.shine`.
        colFundamental: 'Fundamental',
        colRank: '#',
        colArea: 'Gebied',
        colSite: 'Locatie',
        headcountTitle: 'Personeelsbestand',
        headcountTotal: 'Totaal',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Personen',
        kpiPeers: 'Collega\'s (unieke erkenningen tussen gelijken)',
        kpiLeaders: 'Leidinggevenden (unieke erkenningen waarbij een leidinggevende betrokken is)',
        kpiTotalSent: 'Totaal verstuurde erkenningen',
        kpiIndividual: 'Totaal erkenningen aan één persoon',
        kpiGroup: 'Totaal erkenningen aan groepen',
        kpiPeopleInGroup: "Personen erkend in groepserkenningen",
        whatPeopleInGroup: "Hoeveel personen de groepserkenningen ontvingen: een groepserkenning aan 5 personen telt 5.",
        calcPeopleInGroup: "Som van de ontvangers van elke erkenning met meer dan één, met dezelfde filters als de andere KPI’s.",
        kpiTotalNominations: "Totaal nominaties (één per erkende persoon)",
        whatTotalNominations: "Aan één persoon + Personen erkend in groepserkenningen. Het is de eenheid van het blad «Alle erkenningen», dat één rij per persoon heeft.",
        calcTotalNominations: "Totaal erkenningen aan één persoon + Personen erkend in groepserkenningen. Niet te verwarren met «Totaal verzonden erkenningen» (= één persoon + groep), dat elke erkenning één keer telt. «Alle erkenningen» toont ook verborgen of gemelde nominaties (met hun Status) en die uit een andere campagne kwamen via «naar Samen Stralen sturen»; de kolom Reco_ID groepeert de rijen van dezelfde erkenning.",
        datumTeamRecognitions: 'Erkenningen aan teams',
        datumAudienceStaff: 'Doelgroep Staff (kantoor)',
        datumAudienceFrontline: 'Doelgroep Frontline (productie)',
        datumLeader: 'Leidinggevende',
        whatRecognitionsMade: 'Hoeveel erkenningen er in totaal binnen de campagne zijn verstuurd, met de toegepaste filters.',
        calcRecognitionsMade: 'Alle erkenningen met een datum binnen de campagneperiode worden opgeteld.',
        whatUniqueRecognized: 'Hoeveel verschillende personen minstens één erkenning hebben ontvangen. Wie er vijf ontving, telt één keer.',
        calcUniqueRecognized: 'De verschillende personen die in de periode als ontvanger voorkomen, worden geteld.',
        whatTeamRecognitions: 'Een erkenning is een groepserkenning wanneer die meer dan één ontvanger heeft.',
        calcTeamRecognitions: 'Erkenningen met twee of meer ontvangers worden geteld.',
        whatIndividual: 'Erkenningen van de campagne die aan één persoon zijn gericht.',
        calcIndividual: 'Erkenningen met precies één ontvanger worden geteld.',
        whatPeers: 'Erkenningen waarbij noch de gever noch de ontvanger mensen aanstuurt: medewerker naar medewerker, leidinggevende naar leidinggevende, manager naar manager.',
        calcPeers: 'De erkenningen tussen gelijken binnen deze campagne worden gefilterd.',
        whatLeaders: 'Erkenningen waarbij minstens één persoon met mensen onder zich betrokken is.',
        calcLeaders: 'De erkenningen worden gefilterd waarbij de gever of de ontvanger een rol als leidinggevende, supervisor of manager heeft.',
        whatStaffAdoption: 'Van alle kantoormedewerkers (Staff) het aandeel dat in deze campagne al iemand heeft erkend.',
        calcStaffAdoption: 'Staff-medewerkers met minstens één verstuurde erkenning in de campagne, gedeeld door het totaal aantal Staff-medewerkers in hun doelgroep.',
        whatFrontlineAdoption: 'Van alle medewerkers in productie of op locatie (Frontline) het aandeel dat in deze campagne al iemand heeft erkend.',
        calcFrontlineAdoption: 'Frontline-medewerkers met minstens één verstuurde erkenning in de campagne, gedeeld door het totaal aantal Frontline-medewerkers in hun doelgroep.',
        whatTotalUsers: 'Hoeveel personen uit de doelgroep van de campagne er binnen die campagne minstens één erkenning hebben verstuurd.',
        calcTotalUsers: 'Personen met minstens één verstuurde erkenning in de campagneperiode. Dit is geen historische telling over de hele looptijd van het account.',
        whatNoActivity: 'Personen uit de doelgroep die tijdens de campagne geen enkele erkenning hebben verstuurd.',
        calcNoActivity: 'Doelgroep van de campagne min de personen met minstens één daarin verstuurde erkenning.',
        whatAudienceStaff: 'Personen met een zakelijk Entra ID-account.',
        whatAudienceFrontline: 'Personen die zich met hun eigen e-mailadres op het platform registreren.',
        whatParticipationRate: 'Aandeel van de doelgroep dat aan de campagne heeft deelgenomen door minstens één erkenning te sturen.',
        calcParticipationRate: 'Deelnemers gedeeld door de doelgroep van de campagne.',
        whatUniqueRecognizers: 'Verschillende personen die binnen deze campagne minstens één erkenning hebben verstuurd.',
        calcUniqueRecognizers: 'Telling van de verschillende verzenders in de erkenningen van de campagne.',
        whatDistribution: 'Hiërarchie met twee niveaus: elke Fundamental met het aandeel in het campagnetotaal en daaronder, ingesprongen, de Dagelijkse gewoonten met het aandeel dat zij binnen die Fundamental vertegenwoordigen.',
        calcDistribution: 'Het aandeel van een Fundamental is het aantal erkenningen gedeeld door het campagnetotaal. Dat van een Habit is het aantal erkenningen gedeeld door het totaal van de bijbehorende Fundamental.',
        whatFunnel: 'Segmenteert de doelgroep van de campagne naar frequentie: Vaste gebruikers (vier of meer per maand), Incidentele gebruikers (één tot drie) en Inactieven (geen). Elke fase wordt bovendien uitgesplitst naar Kantoor en Productie.',
        calcFunnel: 'Het percentage en de kolom Personen worden berekend over de doelgroep van de campagne, niet over de hele organisatie. Kantoor en Productie tellen dezelfde personen per functietype en blijven leeg als die indeling niet beschikbaar is.',
        whatAllRecognitions: 'Ruwe campagnedetails, één rij per kandidaat: de volledige blokken Nominee, OnBehalfOf en Candidate, de datum, de matrix met actieve Habits en de auditindicatoren. Personen worden niet gemaskeerd: dit is de werkbron van de commissie, en de anonimiteitsdrempel geldt voor geaggregeerde rapporten.',
        calcAllRecognitions: 'Volledige lijst van de erkenningen in de periode. De Habit-kolommen bevatten alleen de Habits die op het moment van exporteren actief zijn in de catalogus. De kolom Reco_ID blijft leeg omdat het systeem nog geen unieke identificatie per rij genereert.',
        noteLeader: 'Een rol geldt als leidinggevende zodra er medewerkers onder vallen.',
        masked: 'Verborgen wegens anonimiteit',
        crossOuCount: '{{count}} OU\'s',
      },
    },
    history: {
      selectCampaign: 'Kies een campagne',
      colName: 'Naam',
      // C2 — «Históricos por Campaña» (rep-panel-historicos).
        colType: "Type",
        colStatus: "Status",
        colRecognitions: "Erkenningen",
        colExpiration: "Einddatum",
        colActions: "Acties",
        status: {
        activo: "Actief",
          expirado: "Verlopen",
          borrador: "Concept",
        },
      // P18-ter — GLOBAAL campagnerapport (allemaal, niet één), naar het voorbeeld van 03 - Historicos.xlsx.
      kpiTotalCampaigns: 'Totaal aantal campagnes',
      kpiTotalRecognitions: 'Totaal aantal erkenningen',
      kpiAudienceTotal: 'Totale doelgroep',
      kpiParticipantsTotal: 'Deelnemers',
      kpiParticipantsStaff: 'Deelnemers Staff',
      kpiParticipantsFrontline: 'Deelnemers Frontline',
      kpiParticipationRate: 'Deelnamepercentage',
      kpiAvgPerParticipant: 'Gemiddeld aantal erkenningen per deelnemer',
      colDescription: 'Beschrijving',
      colParticipants: 'Deelnemers',
      colParticipantsStaff: 'Deelnemers Staff',
      colParticipantsFrontline: 'Deelnemers Frontline',
      colDuration: 'Duur van de campagne',
      colFrequency: 'Frequentie',
      colGoalPercent: '% van het doel',
      downloadGlobalExcel: 'Globaal rapport downloaden',
      downloadGlobalError: 'Het globale rapport kon niet worden gedownload.',
      // Historisch Excel (`historicosExcel.ts`) — tekst die UITSLUITEND bij het bestand hoort:
      // bladnamen, banner, metadata en woordenlijst. Datalabels worden niet herhaald: de `kpi*`/
      // `col*`-sleutels hierboven worden hergebruikt, zodat bestand en scherm hetzelfde zeggen.
      excel: {
        sheetSummary: 'Managementsamenvatting',
        sheetDefinitions: 'Definities',
        sheetCampaigns: 'Historische campagnes',
        summaryTitle: 'Historie per campagne',
        summarySubtitle: 'Bundelt de historie van de erkenningscampagnes: doelgroep, deelname en het aantal erkenningen per campagne.',
        campaignsSubtitle: 'Vergelijkend detail per campagne.',
        definitionsTitle: 'Wat betekent elk gegeven?',
        definitionsSubtitle: 'Uitleg in eenvoudige taal, afgestemd op de managementsamenvatting en met de meetwijze van elke KPI.',
        metaFilter: 'Toegepast filter',
        metaGenerated: 'Gegenereerd',
        filterAllCampaigns: 'Alle campagnes',
        colKpi: 'KPI',
        colValue: 'Waarde',
        colNote: 'Toelichting / definitie',
        colDatum: 'Gegeven',
        colWhatIs: 'Wat het is',
        colHowMeasured: 'Hoe het wordt gemeten',
        colHowCalculated: 'Hoe het wordt berekend',
        colComparedTo: 'Vergeleken met',
        colWhereShown: 'Waar het staat',
        colAudienceOu: 'Doelgroep OU',
        whereSummary: 'Managementsamenvatting',
        whereSummaryCampaigns: 'Managementsamenvatting / Historische campagnes',
        datumStaffFrontline: 'Deelnemers Staff / Deelnemers Frontline',
        durationDays_one: '{{count}} dag',
        durationDays_few: '{{count}} dagen',
        durationDays_other: '{{count}} dagen',
        whatCampaigns: 'Aantal campagnes in de historie of in het toegepaste filter.',
        measuredCampaigns: 'Geteld wordt elke campagne die met een geldige naam in de historie staat.',
        calcCampaigns: 'Telling van unieke campagnes binnen de reikwijdte van het rapport.',
        vsCampaigns: 'Tegen alle beschikbare campagnes of tegen eerdere peilmomenten.',
        whatRecognitions: 'Erkenningen die binnen de gekozen reikwijdte zijn opgebouwd.',
        measuredRecognitions: 'Geteld wordt elke erkenning die bij de opgenomen campagnes is vastgelegd.',
        calcRecognitions: 'Som van alle erkenningen van de gefilterde campagnes.',
        vsRecognitions: 'Tegen andere campagnes, eerdere perioden of het gestelde doel.',
        whatAudience: 'Aantal medewerkers op wie de campagne was gericht.',
        measuredAudience: 'Gemeten met de doelgroep die in de campagne-instellingen is vastgelegd.',
        calcAudience: 'Alle in aanmerking komende medewerkers binnen de OU, het land, de BU of de ingestelde reikwijdte.',
        vsAudience: 'Basis voor de deelname; 100% staat gelijk aan de volledige doelgroep.',
        whatParticipants: 'Verschillende personen die deelnamen met ten minste één verzonden erkenning.',
        measuredParticipants: 'Geteld worden unieke personen die ten minste één erkenning verzonden.',
        calcParticipants: 'Unieke telling van verzenders met een of meer erkenningen.',
        vsParticipants: 'Tegen de totale doelgroep en tegen vergelijkbare campagnes.',
        whatStaffFrontline: 'Van de deelnemers: hoeveel op kantoor werken (Staff) en hoeveel op de vloer (Frontline).',
        measuredStaffFrontline: 'Het huidige segment van elke persoon telt op het moment van het rapport, niet dat van de deelname.',
        calcStaffFrontline: 'Telling van deelnemers naar het segment in hun profiel in de directory.',
        vsStaffFrontline: 'Tegen het totaal aantal deelnemers op dezelfde rij.',
        whatRate: 'Aandeel van de doelgroep dat daadwerkelijk deelnam.',
        measuredRate: 'Gemeten als het aandeel deelnemers van de totale doelgroep.',
        calcRate: 'Deelnemers / totale doelgroep.',
        vsRate: 'Tegen het deelnamedoel; 100% betekent dat de hele doelgroep deelnam.',
        whatAvg: 'Gemiddeld aantal erkenningen per actieve deelnemer.',
        measuredAvg: 'Gemeten onder de personen die ten minste één erkenning verzonden.',
        calcAvg: 'Totaal aantal erkenningen / deelnemers.',
        vsAvg: 'Tegen andere campagnes of tegen het verwachte gemiddelde per deelnemer.',
      },
    },
    headcount: {
      notaPeriodo: "Referentie voor de periode: de KPI's hierboven worden over dit personeelsbestand berekend.",
      notaAdopcion: "Dit is de noemer van de adoptie: van dit bestand, hoeveel mensen hebben genomineerd.",
      title: 'Personeelsbestand',
      updatedOn: 'Personeelsbestand bijgewerkt: {{fecha}}',
      updatedOnTitle: 'Personeelsbestand bijgewerkt',
      sourceLatam: 'LATAM: {{fecha}}',
      sourceEuropa: 'Europa: {{fecha}}',
      sourceUsa: 'VS: {{fecha}}',
      sinDato: 'Geen gegevens',
      hint: 'Laatste import van op het platform geregistreerde gebruikers',
      total: 'Totaal personen',
      staff: 'Staff',
      frontline: 'Frontline',
    },
    heatmap: {
      title: 'Heatmap OU × Kernprincipe',
      subtitle: 'Volume erkenningen per OU en kernprincipe. De kleurintensiteit toont de relatieve concentratie binnen elke kolom.',
      ou: 'Organisatie-eenheid',
      // C2 — la columna Total que la maqueta cierra en el mapa de calor.
      total: 'Totaal',
    },
    network: {
      title: 'ONA-netwerk',
      subtitle: 'Erkenningsstroom tussen eenheden (overkoepelende samenwerking).',
      ous: 'Eenheden',
      flows: 'Stromen',
      legendCross: 'Cross-OU-stroom',
      legendInternal: 'Interne stroom',
      legendNode: 'Eenheid (grootte = volume)',
      // C2 — la tabla de flujos que pide la maqueta, en vez del grafo SVG.
      colFlow: 'Stroom (Van → Naar)',
      colRecognitions: 'Erkenningen',
      // C2/C4 (2026-08-13) — reemplaza a `colIntensity`: la spec descartó el % de Intensidad y lo
      // sustituyó por el Fundamental más reconocido de la relación (`OnaEdgeDto.fundamentalDominante`).
      colDominantFundamental: 'Erkenningsvolume',
      colDominantFundamentalHelp: 'De lengte van de balk geeft het erkenningsvolume van de stroom weer; de kleur toont welk Kernprincipe daarin het vaakst werd erkend.',
    },
    // 2026-09-04 — hoja "Definiciones" del Excel Demográfico, calcada de la plantilla del cliente
    // (`04 - Demografico.xlsx`): banner, las 4 columnas del glosario y una definición por cada dato
    // que el archivo realmente trae. Vivían como literales en español dentro de
    // `DemograficoExportButton.tsx`, así que la hoja salía en español aunque el resto del libro
    // fuera en el idioma de quien descarga.
    definitions: {
      title: 'Wat betekent elk gegeven?',
      subtitle: 'Uitleg in eenvoudige taal voor iedereen die dit bestand downloadt, zonder kennis van data.',
      colData: 'Gegeven',
      colWhat: 'Wat het is',
      colHow: 'Hoe het wordt berekend',
      colVs: 'Vergeleken met',
      percentTotalWhat: 'Welk deel van het totale actieve personeelsbestand tot elke generatie behoort.',
      percentTotalHow: 'Actieve personen van die generatie, over alle OU\'s binnen het bereik, gedeeld door het totale actieve personeelsbestand met een bekende generatieband.',
      percentTotalVs: 'De overige generaties in dezelfde tabel.',
      gapWhat: 'In welke mate een generatie elke Fundamental beleeft, op een schaal van 1 tot 4, en hoe ver haar laagste Fundamental van de hoogste af ligt.',
      gapHow: 'Gemiddelde Pulso-score per generatie en Fundamental; de Δ is het maximum min het minimum van de rij, op één decimaal.',
      gapVs: 'De overige Fundamentals van dezelfde generatie.',
      heatmapWhat: 'Hoeveel erkenningen er in elke organisatorische eenheid zijn gegeven, uitgesplitst per Fundamental.',
      heatmapHow: 'Telling gegroepeerd per OU en Fundamental; cellen met minder dan 5 erkenningen worden verborgen vanwege anonimiteit.',
      heatmapVs: 'De overige OU\'s en Fundamentals in dezelfde tabel.',
      networkWhat: 'Hoeveel erkenningen van de ene organisatorische eenheid naar de andere zijn gestroomd.',
      networkHow: 'Telling van erkenningen die van de ene OU naar de andere zijn verzonden, van hoog naar laag gesorteerd.',
      networkVs: 'De overige stromen in dezelfde tabel.',
    },
    generational: {
      title: 'Generatieverdeling',
      subtitle: 'Erkenningen gegroepeerd per generatieband.',
      filterBu: 'Filter op BU…',
      buAll: 'BU: Alle',
      filterDepto: 'Filter op afdeling…',
      roleAll: 'Alle',
      roleLeaders: 'Leidinggevenden',
      rolePeers: 'Collega\'s',
      // Bug UAT (17-ago-2026) — estas cuatro claves vivían por error en `admin.moderation`, así
      // que `BrechaGeneracionalTable` pintaba la clave cruda («reports.generational.gapTitle»).
      // Su sitio es este bloque: las consume el tab Demográfico, no la bandeja de moderación.
      gapTitle: 'Generatiekloof × Fundamental',
      gapSubtitle: 'Gemiddelde score (1–4) per generatie en Fundamental. Δ Kloof ≥ 1,0 = kritiek.',
      gapTitleHelp: 'Elke cel wordt voor de weergave afgerond op 1 decimaal. De Δ Kloof wordt berekend op basis van de volledige (niet-afgeronde) waarde van maximum min minimum van de rij en kan daardoor afwijken van de visuele aftrekking van de afgeronde kolommen.',
      colGeneration: 'Generatie',
      colGap: 'Δ Kloof',
      // C5/C7 (2026-08-13) — marcado visual de `ousConCobertura`: qué unidades tuvieron cobertura
      // de fecha de nacimiento suficiente para aportar al cálculo generacional.
      // T-11 — tarjetas de la maqueta: conteo de personas por banda y marca de la mayoritaria.
      people_one: '{{count}} persoon',
      people_other: '{{count}} personen',
      majority: 'meerderheid',
      coverageTitle: 'Eenheden met dekking van generatiegegevens',
      // C7 — botón de export consolidado (6 hojas) del panel Demográfico completo.
      exportConsolidated: 'Demografisch paneel exporteren (4 werkbladen)',
      // Task 9 — etiquetas de columna para la hoja de export de distribución generacional.
      // 2026-09-03 — encabezado de la hoja "Resumen Ejecutivo" del Excel Demográfico
      // (subtítulo + bloque de metadatos), según la plantilla de referencia del cliente.
      exportSubtitle: 'Samenstelling van het personeelsbestand per generatie, OU en type medewerker',
      metaPeriod: 'Periode',
      metaFilters: 'Toegepaste filters',
      metaGenerated: 'Gegenereerd',
      colPercentTotal: '% van totaal',
      colYearRange: 'Jarenbereik',
      colPeople: 'Personen',
      colFrontline: 'Frontline',
      colStaff: 'Staff',
      colNote: 'Opmerking',
      // Valores de la columna «Nota» del Resumen Ejecutivo. Los emite
      // `buildGenerationalDistributionMatrix` como identificador canónico, no como texto,
      // justamente para poder traducirlos aquí.
      noteMajority: 'Meerderheid',
      noteSmallSample: 'Kleine steekproef',
    },
    leaders: {
      title: 'Leiders',
      subtitle: 'Directe teamgrootte en erkenningen per leider.',
      export: 'Exporteren naar Excel',
      colLeader: 'Leider',
      colPosition: 'Functie',
      colOu: 'OE',
      colLevel: 'Niveau',
      colTeamSize: 'Teamgrootte',
      colTeamReceived: 'Team-erkenningen (ontvangen)',
      colTeamReceivedHelp: 'Totaal aantal erkenningen ontvangen door personen binnen de structuren van de leiders.',
      colTeamSent: 'Team-erkenningen (verzonden)',
      colTeamSentHelp: 'Totaal aantal erkenningen verzonden door personen binnen de structuren van de leiders.',
      colLeaderSent: 'Door de leider verzonden erkenningen',
      colLeaderReceived: 'Door de leider ontvangen erkenningen',
      colParticipation: 'Deelname',
      colRatio: 'Ratio',
      colExport: 'Exporteren',
      exportRow: 'Deze rij exporteren',
      exportRowFor: 'De rij van {{name}} exporteren',
      kpiTotalLeaders: 'Totaal aantal leiders',
      kpiTeamSizeSum: 'Teamgrootte',
      kpiRatioAvg: 'Verhouding ontvangen/verstuurd',
      kpiParticipationAvg: 'Deelname',
      emptyByPerson: 'Geen resultaten gevonden: de geselecteerde persoon heeft binnen je bereik geen direct ondergeschikten.',
      currentWeek: '(huidige week, standaard)',
      teamSizeNote: 'De teamgrootte telt de directe ondergeschikten volgens het organigram en verandert niet met de datums of het Fundamental; de erkenningen van het team wel.',
      // Textos del Excel de Líderes (`leadersExcel.ts`): nombres de hoja, banner, bloque de
      // metadatos, encabezados de las hojas Resumen/Definiciones, el «Detalle» de cada KPI y el
      // glosario completo. Las etiquetas de dato NO se repiten aquí: se reusan de `col*`/`kpi*`
      // de arriba, que son las mismas que ya se leen en pantalla.
      excel: {
        sheetSummary: 'Managementsamenvatting',
        sheetDefinitions: 'Definities',
        sheetTeams: 'Teams per leider',
        teamsSubtitle: 'Detail van erkenningen per hiërarchische structuur.',
        definitionsTitle: 'Wat betekent elk gegeven?',
        definitionsSubtitle: 'Uitleg in eenvoudige taal, voor iedereen die dit bestand downloadt — zonder verstand van data.',
        metaPeriod: 'Periode',
        metaFilters: 'Toegepaste filters',
        metaGenerated: 'Gegenereerd op',
        colKpi: 'KPI',
        colValue: 'Waarde',
        colDetail: 'Detail',
        colDatum: 'Gegeven',
        colWhatIs: 'Wat het is',
        colHowCalculated: 'Hoe het wordt berekend',
        detailTotalLeaders: 'Totaal aantal leiders met medewerkers onder zich in het personeelsbestand.',
        detailTeamSize: 'Som van de teamgrootte (directe medewerkers) van de getoonde leiders.',
        detailTeamReceived: 'Totaal aantal erkenningen ontvangen door mensen binnen de structuren van de leiders.',
        detailTeamSent: 'Totaal aantal erkenningen verstuurd door mensen binnen de structuren van de leiders.',
        detailLeaderReceived: 'Totaal aantal erkenningen die de leiders rechtstreeks ontvingen.',
        detailLeaderSent: 'Totaal aantal erkenningen die de leiders rechtstreeks verstuurden.',
        detailRatio: 'Ontvangen teamerkenningen gedeeld door de verstuurde.',
        detailParticipation: 'Gemiddelde deelname van de teams van de leiders.',
        whatTeamSize: 'Hoeveel mensen rechtstreeks aan die leider rapporteren.',
        howTeamSize: 'Aantal mensen van wie de manager de leider is. De lagere niveaus van het organigram tellen niet mee.',
        whatTeamReceived: 'Hoeveel erkenningen het team van die leider in totaal ontving, van wie dan ook.',
        howTeamReceived: 'Som van de erkenningen waarbij de ontvanger tot het directe team van de leider behoort.',
        whatTeamSent: 'Hoeveel erkenningen het team van die leider in totaal verstuurde, aan wie dan ook.',
        howTeamSent: 'Som van de erkenningen waarbij de afzender tot het directe team van de leider behoort.',
        whatLeaderReceived: 'Hoeveel erkenningen de leider in totaal ontving, van wie dan ook.',
        howLeaderReceived: 'Aantal erkenningen waarbij de leider de ontvanger is. Het team telt niet mee.',
        whatLeaderSent: 'Hoeveel erkenningen de leider verstuurde, aan wie dan ook.',
        howLeaderSent: 'Aantal erkenningen waarbij de leider de afzender is. Het team telt niet mee.',
        whatRatio: 'Hoeveel meer erkenning een team ontvangt dan het aan anderen geeft.',
        howRatio: 'Ontvangen teamerkenningen gedeeld door de verstuurde. «—» als het team er geen verstuurde.',
        whatParticipation: 'Welk percentage van het team van die leider minstens één keer iemand heeft erkend.',
        howParticipation: 'Teamleden met minstens 1 verstuurde erkenning, gedeeld door de teamgrootte. Ontvangen telt niet: dat is de actie van iemand anders.',
        whatLeader: 'Medewerker die personeel onder zich heeft in het personeelsbestand van het bedrijf.',
        howLeader: 'Iedereen met minstens één directe medewerker. De samenvatting telt de leiders van alle geografieën binnen het opgevraagde bereik bij elkaar op.',
        whatLevel: 'Diepte van de leider in het organigram: N-1 is de top (zonder manager), daarna N-2, N-3… naar beneden.',
        howLevel: 'Keten van managers tot de top + 1, berekend over het hele bedrijf en niet alleen onder de leiders die in deze lijst zichtbaar zijn.',
      },
    },
    moderation: {
      title: 'Moderatie',
      subtitle: 'Detail van gerapporteerde erkenningen. Bevat contactgegevens voor escalatie.',
      total: 'Totaal aantal rapportages',
      pending: 'In behandeling',
      hidden: 'Verborgen',
      restored: 'Herstelde',
      colReported: 'Gerapporteerd',
      colReportedEmail: 'E-mail gerapporteerd',
      colOu: 'OE',
      colCountry: 'Land',
      colReporter: 'Melder',
      colReporterEmail: 'E-mail melder',
      colReason: 'Reden',
      colStatus: 'Status',
      colDate: 'Datum',
      statusPending: 'In behandeling',
      statusHidden: 'Verborgen',
      statusRestored: 'Herstelde',
      statusPublished: 'Gepubliceerd',
      colComment: 'Gerapporteerde opmerking',
      colLanguage: 'Taal',
      colReportCount: '# Rapportages',
      export: 'Exporteren naar Excel',
      colCampaign: 'Campagne',
      allCampaigns: 'Alle campagnes',
      campaignNone: 'Geen campagne',
      campaignUnavailable: 'Campagne niet beschikbaar',
    },
    campaigns: {
      title: 'Campagnegeschiedenis',
      subtitle: 'Afgesloten campagnes: doelgroep en erkenningen.',
      search: 'Zoeken op naam…',
      // D4 — categorieselector (Fundamentales/Brillamos/Personalizada) die de gecombineerde
      // tabelexport vervangt.
      filterTypeLabel: 'Categorie',
      filterAllTypes: 'Alle categorieën',
      summaryParticipants: 'Totaal deelnemers',
      summaryRate: 'Deelname %',
      colName: 'Naam',
      colType: 'Type',
      colAudience: 'Doelgroep (personen)',
      colRecognitions: 'Erkenningen',
      // C2 — «Deelname per campagne» (rep-panel-campgeneral).
      colParticipants: 'Deelnemers',
      colRate: 'Deelnamepercentage',
      colAvgUser: 'Gemiddelde per deelnemer',
      colAvgUserHelp: 'Gemiddeld aantal erkenningen per deelnemer aan de campagne: erkenningen ÷ deelnemers.',
      dominantFundamentalTooltip: 'Meest erkende Fundament: {{name}}',
      colStart: "Startdatum",
      colExpiration: "Einddatum",
      prevPage: 'Vorige',
      nextPage: 'Volgende',
      pageOf: 'Pagina {{page}} van {{total}}',
      type: {
        Fundamentales: 'Kernprincipes',
        Brillamos: 'Shine Together',
        Personalizada: 'Aangepast',
      },
      // D3 — Reportería deja de ofrecer pausar/relanzar/enviar-a-aprobación (esa máquina de estados
      // vive en el editor de campañas, `admin.campaigns`). Queda una sola acción por fila: descargar
      // el Excel de esa campaña.
      // D6 — foutmelding voor de gebruiker als de campagne-export mislukt (netwerk/backend), via Toast.
    },
  },
  // ── D5 Pass-C — Voorkeuren, team, dashboard, ranking, aangepaste campagne ──
  notifPrefs: {
    title: 'Meldingen',
    subtitle: 'Kies welke meldingen je per e-mail wilt ontvangen.',
    unavailable: 'Je voorkeuren konden niet worden geladen.',
    emailEnabled: 'E-mails ontvangen',
    emailHint: 'Hoofdschakelaar voor alle e-mails.',
    saveError: 'Je voorkeuren konden niet worden opgeslagen.',
    cat: {
      recognitionReceived: 'Ontvangen erkenningen',
      streakAndBadges: 'Reeksen en badges',
      campaigns: 'Campagnes',
      digest: 'Activiteitenoverzicht',
    },
    catHint: {
      recognitionReceived: 'Wanneer iemand jou waardeert.',
      streakAndBadges: 'Jouw reeks en vrijgespeelde badges.',
      campaigns: 'Nieuws over campagnes Wij stralen.',
      digest: 'Periodiek overzicht van je activiteit.',
    },
    catLockedAntiSpoiler: 'Vergrendeld zolang de Anti-Spoiler-modus actief is: we kunnen je pas na afloop van de campagne op de hoogte brengen van je waarderingen.',
  },
  team: {
    mostRecognized: 'Meest Gewaardeerd', mostRecognizers: 'Meest Waarderend',
    title: 'Mijn team',
    subtitle: 'Deelname van je team aan de erkenning.',
    subtitleFor: 'Team van {{name}}',
    empty: 'Er is nog geen activiteit van je team.',
    teamSize: 'Teamgrootte',
    sent: 'Verzonden',
    received: 'Ontvangen',
    participation: 'Deelname',
    members: 'Teamleden',
    emptyMembers: 'Er zijn geen leden om te tonen.',
    colMember: 'Lid',
    colSent: 'Verzonden',
    colReceived: 'Ontvangen',
    colStreak: 'Reeks',
    noStreak: 'Geen reeks',
    explore: 'Hun team verkennen',
    myTeam: 'Mijn team',
    breadcrumb: 'Teampad',
    colTopFundamental: 'Top kernprincipe',
    // La celda lleva las DOS lecturas etiquetadas: por lo que RECONOCEN a la persona (el dato
    // que existe para todo el equipo) y lo que ella usa al reconocer (UAT 18-ago-2026).
    fundRecibido: 'Erkend voor:',
    fundEnviado: 'Erkent voor:',
    colActions: 'Acties',
    viewButton: 'Profiel van {{name}} bekijken',
    viewButton_short: 'Bekijken',
    backToTeam: 'Terug naar team',
    backToProfile: 'Terug naar mijn profiel',
    expandMember: 'Details van {{name}} bekijken',
  },
  tablero: {
    title: 'Directiedashboard',
    subtitle: 'KPI’s van het Erkenningsprogramma. Alleen puntenbeheerders zien punten.',
    pointsTitle: 'Campagnepunten',
    pointsCampaign: 'Campagne met punten',
    pointsNone: 'Geen enkele campagne kent punten toe.',
    pointsHint: 'Met de OE en de periode uit de balk.',
    empty: 'Er zijn geen KPI’s voor het geselecteerde bereik.',
    // RF-143 (C4) — drill-down por Fundamental y por generación.
    allFundamentals: 'Alle Fundamenten',
    allGenerations: 'Alle generaties',
    notApplicableNote: 'Met het generatiefilter worden KPI’s die op het totale personeelsbestand zijn gebaseerd als “n/a” getoond: de telling is niet uitgesplitst naar generatie, dus dat percentage zou iets anders betekenen.',
    // 🔴 Las CLAVES son los valores exactos de GenerationHelper (UserAdminService); solo se
    //    traduce el rótulo. Cambiar una clave dejaría el filtro sin casar con nadie.
    generations: {
      GenAlpha: 'Generatie Alfa',
      GenZ: 'Generatie Z',
      Millennial: 'Millennials',
      GenX: 'Generatie X',
      BabyBoomer: 'Babyboomers',
      Silent: 'Stille Generatie',
    },
  },
  leaderboard: {
    title: 'Ranking per OU',
    subtitle: 'Nominaties per organisatie-eenheid/land.',
    noOu: 'Zonder OU',
    you: ' (jij)',
  },
  campaignType: {
    personalizada: 'Aangepaste campagne',
  },
  campaignLanding: {
    customNote: 'Dit is een informatieve campagne. Verken haar documenten en microsite.',
  },
  innovacion: {
    kpiStreak: 'Reeks',
    kpiStreakHint: 'record: {{record}} weken',
    kpiStreakHintMonthly: 'record: {{record}} maanden',
    kpiNominations: 'Nominaties',
    kpiNominationsHint: 'Verzonden in deze campagne',
    kpiNominationsHint2: '{{count}} verschillende personen',
    kpiUnique: 'Genomineerde personen',
    kpiUniqueHint: 'Unieke ontvangers',
    kpiDaysLeft: 'Resterende dagen',
    suppressed: 'De gegevens zijn onderdrukt vanwege privacy: de groep is te klein om cijfers te tonen.',
    kpisUnavailable: 'Live-KPI’s zijn momenteel niet beschikbaar.',
    fundamentalsTitle: 'Kernprincipes van deze campagne',
    nominateSecondary: 'Naar de pagina Nomineren',
    recentTitle: 'Recente erkenningen',
    recentEmpty: 'Nog geen erkenningen in deze campagne.',
    noCampaign: 'Er is geen actieve aangepaste campagne. Deze kan worden aangemaakt via Beheer → Campagnes.',
  },
};

export default recognition;
